/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2026 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2026 - Finnish Meteorological Institute (FMI)
 * Copyright 2026 - The Norwegian Meteorological Institute (MET Norway)
 * */
const demoPluginBundle = `;(function(){var s=document.createElement("style");s.setAttribute("data-inline","plugin-1");s.textContent=".app-root{min-height:100vh;display:flex;align-items:center;justify-content:center;background:radial-gradient(circle at top,#1b1b3a,#050514 60%);font-family:system-ui,-apple-system,BlinkMacSystemFont,SF Pro Text,sans-serif;color:#fff}.time-slider-card{position:relative;width:420px;padding:32px 32px 28px;border-radius:28px;background:radial-gradient(circle at top left,#26264d,#050514 80%);box-shadow:0 18px 40px #0009,0 0 0 1px #ffffff0a;-webkit-backdrop-filter:blur(18px);backdrop-filter:blur(18px);overflow:hidden}.time-slider-card:before{content:\\"\\";position:absolute;top:0;right:0;bottom:0;left:0;background-image:radial-gradient(circle,rgba(255,255,255,.12) 0,transparent 55%),radial-gradient(circle,rgba(255,255,255,.12) 0,transparent 55%);background-position:20% 25%,80% 70%;background-size:2px 2px,1.6px 1.6px;opacity:.35;pointer-events:none}.time-slider-card:after{content:\\"\\";position:absolute;top:0;right:0;bottom:0;left:0;background:radial-gradient(circle at center,rgba(70,120,255,.18),transparent 60%);opacity:.6;pointer-events:none}.time-slider-title{position:relative;letter-spacing:.32em;text-transform:uppercase;font-size:10px;color:#fff9;text-align:center;margin-bottom:34px}.time-slider-track-wrapper{position:relative;margin-bottom:28px}.time-slider-track{position:relative;height:3px;border-radius:999px;background:linear-gradient(90deg,#ffb258,#ffd88a 20%,#87c9ff 55%,#4f7dff);box-shadow:0 0 12px #87c9ff4d;cursor:pointer}.time-slider-marker{position:absolute;top:50%;transform:translate(-50%,-50%);width:10px;height:10px;border-radius:999px;background:#ffffff29;box-shadow:0 0 0 2px #05051499}.time-slider-thumb{position:absolute;top:50%;transform:translate(-50%,-50%);width:32px;height:32px;border-radius:999px;background:radial-gradient(circle at 30% 30%,#fefeff,#78c7ff 40%,#1b4cff);box-shadow:0 0 16px #78c7ffe6,0 0 40px #3f80ffd9,0 0 0 3px #0c2660cc;cursor:grab;transition:transform .15s ease-out,box-shadow .15s ease-out}.time-slider-thumb.dragging{cursor:grabbing;transform:translate(-50%,-50%) scale(1.06);box-shadow:0 0 20px #8ad2ff,0 0 48px #3f80ff,0 0 0 4px #0c2660e6}.time-slider-labels{position:relative;display:flex;justify-content:space-between;margin:0 -4px 10px;font-size:12px;color:#ffffffb3}.time-slider-labels span{padding:0 4px}.time-slider-value{position:relative;text-align:center;font-size:13px;letter-spacing:.08em;text-transform:uppercase;color:#c2d8ffcc}\\n";document.head.appendChild(s);}());
var sc = Object.defineProperty;
var ac = (e, t, n) => t in e ? sc(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var yt = (e, t, n) => ac(e, typeof t != "symbol" ? t + "" : t, n);
function cc(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ki = { exports: {} }, nl = {}, Yi = { exports: {} }, z = {};
var Zn = Symbol.for("react.element"), fc = Symbol.for("react.portal"), dc = Symbol.for("react.fragment"), pc = Symbol.for("react.strict_mode"), mc = Symbol.for("react.profiler"), hc = Symbol.for("react.provider"), vc = Symbol.for("react.context"), yc = Symbol.for("react.forward_ref"), gc = Symbol.for("react.suspense"), wc = Symbol.for("react.memo"), Sc = Symbol.for("react.lazy"), Fo = Symbol.iterator;
function kc(e) {
  return e === null || typeof e != "object" ? null : (e = Fo && e[Fo] || e["@@iterator"], typeof e == "function" ? e : null);
}
var Xi = { isMounted: function() {
  return !1;
}, enqueueForceUpdate: function() {
}, enqueueReplaceState: function() {
}, enqueueSetState: function() {
} }, Gi = Object.assign, Zi = {};
function on(e, t, n) {
  this.props = e, this.context = t, this.refs = Zi, this.updater = n || Xi;
}
on.prototype.isReactComponent = {};
on.prototype.setState = function(e, t) {
  if (typeof e != "object" && typeof e != "function" && e != null) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
  this.updater.enqueueSetState(this, e, t, "setState");
};
on.prototype.forceUpdate = function(e) {
  this.updater.enqueueForceUpdate(this, e, "forceUpdate");
};
function Ji() {
}
Ji.prototype = on.prototype;
function Au(e, t, n) {
  this.props = e, this.context = t, this.refs = Zi, this.updater = n || Xi;
}
var $u = Au.prototype = new Ji();
$u.constructor = Au;
Gi($u, on.prototype);
$u.isPureReactComponent = !0;
var jo = Array.isArray, qi = Object.prototype.hasOwnProperty, Vu = { current: null }, bi = { key: !0, ref: !0, __self: !0, __source: !0 };
function es(e, t, n) {
  var r, l = {}, u = null, o = null;
  if (t != null) for (r in t.ref !== void 0 && (o = t.ref), t.key !== void 0 && (u = "" + t.key), t) qi.call(t, r) && !bi.hasOwnProperty(r) && (l[r] = t[r]);
  var i = arguments.length - 2;
  if (i === 1) l.children = n;
  else if (1 < i) {
    for (var s = Array(i), c = 0; c < i; c++) s[c] = arguments[c + 2];
    l.children = s;
  }
  if (e && e.defaultProps) for (r in i = e.defaultProps, i) l[r] === void 0 && (l[r] = i[r]);
  return { $$typeof: Zn, type: e, key: u, ref: o, props: l, _owner: Vu.current };
}
function Ec(e, t) {
  return { $$typeof: Zn, type: e.type, key: t, ref: e.ref, props: e.props, _owner: e._owner };
}
function Hu(e) {
  return typeof e == "object" && e !== null && e.$$typeof === Zn;
}
function Cc(e) {
  var t = { "=": "=0", ":": "=2" };
  return "$" + e.replace(/[=:]/g, function(n) {
    return t[n];
  });
}
var Uo = /\\/+/g;
function kl(e, t) {
  return typeof e == "object" && e !== null && e.key != null ? Cc("" + e.key) : t.toString(36);
}
function Sr(e, t, n, r, l) {
  var u = typeof e;
  (u === "undefined" || u === "boolean") && (e = null);
  var o = !1;
  if (e === null) o = !0;
  else switch (u) {
    case "string":
    case "number":
      o = !0;
      break;
    case "object":
      switch (e.$$typeof) {
        case Zn:
        case fc:
          o = !0;
      }
  }
  if (o) return o = e, l = l(o), e = r === "" ? "." + kl(o, 0) : r, jo(l) ? (n = "", e != null && (n = e.replace(Uo, "$&/") + "/"), Sr(l, t, n, "", function(c) {
    return c;
  })) : l != null && (Hu(l) && (l = Ec(l, n + (!l.key || o && o.key === l.key ? "" : ("" + l.key).replace(Uo, "$&/") + "/") + e)), t.push(l)), 1;
  if (o = 0, r = r === "" ? "." : r + ":", jo(e)) for (var i = 0; i < e.length; i++) {
    u = e[i];
    var s = r + kl(u, i);
    o += Sr(u, t, n, s, l);
  }
  else if (s = kc(e), typeof s == "function") for (e = s.call(e), i = 0; !(u = e.next()).done; ) u = u.value, s = r + kl(u, i++), o += Sr(u, t, n, s, l);
  else if (u === "object") throw t = String(e), Error("Objects are not valid as a React child (found: " + (t === "[object Object]" ? "object with keys {" + Object.keys(e).join(", ") + "}" : t) + "). If you meant to render a collection of children, use an array instead.");
  return o;
}
function rr(e, t, n) {
  if (e == null) return e;
  var r = [], l = 0;
  return Sr(e, r, "", "", function(u) {
    return t.call(n, u, l++);
  }), r;
}
function _c(e) {
  if (e._status === -1) {
    var t = e._result;
    t = t(), t.then(function(n) {
      (e._status === 0 || e._status === -1) && (e._status = 1, e._result = n);
    }, function(n) {
      (e._status === 0 || e._status === -1) && (e._status = 2, e._result = n);
    }), e._status === -1 && (e._status = 0, e._result = t);
  }
  if (e._status === 1) return e._result.default;
  throw e._result;
}
var oe = { current: null }, kr = { transition: null }, xc = { ReactCurrentDispatcher: oe, ReactCurrentBatchConfig: kr, ReactCurrentOwner: Vu };
function ts() {
  throw Error("act(...) is not supported in production builds of React.");
}
z.Children = { map: rr, forEach: function(e, t, n) {
  rr(e, function() {
    t.apply(this, arguments);
  }, n);
}, count: function(e) {
  var t = 0;
  return rr(e, function() {
    t++;
  }), t;
}, toArray: function(e) {
  return rr(e, function(t) {
    return t;
  }) || [];
}, only: function(e) {
  if (!Hu(e)) throw Error("React.Children.only expected to receive a single React element child.");
  return e;
} };
z.Component = on;
z.Fragment = dc;
z.Profiler = mc;
z.PureComponent = Au;
z.StrictMode = pc;
z.Suspense = gc;
z.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = xc;
z.act = ts;
z.cloneElement = function(e, t, n) {
  if (e == null) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + e + ".");
  var r = Gi({}, e.props), l = e.key, u = e.ref, o = e._owner;
  if (t != null) {
    if (t.ref !== void 0 && (u = t.ref, o = Vu.current), t.key !== void 0 && (l = "" + t.key), e.type && e.type.defaultProps) var i = e.type.defaultProps;
    for (s in t) qi.call(t, s) && !bi.hasOwnProperty(s) && (r[s] = t[s] === void 0 && i !== void 0 ? i[s] : t[s]);
  }
  var s = arguments.length - 2;
  if (s === 1) r.children = n;
  else if (1 < s) {
    i = Array(s);
    for (var c = 0; c < s; c++) i[c] = arguments[c + 2];
    r.children = i;
  }
  return { $$typeof: Zn, type: e.type, key: l, ref: u, props: r, _owner: o };
};
z.createContext = function(e) {
  return e = { $$typeof: vc, _currentValue: e, _currentValue2: e, _threadCount: 0, Provider: null, Consumer: null, _defaultValue: null, _globalName: null }, e.Provider = { $$typeof: hc, _context: e }, e.Consumer = e;
};
z.createElement = es;
z.createFactory = function(e) {
  var t = es.bind(null, e);
  return t.type = e, t;
};
z.createRef = function() {
  return { current: null };
};
z.forwardRef = function(e) {
  return { $$typeof: yc, render: e };
};
z.isValidElement = Hu;
z.lazy = function(e) {
  return { $$typeof: Sc, _payload: { _status: -1, _result: e }, _init: _c };
};
z.memo = function(e, t) {
  return { $$typeof: wc, type: e, compare: t === void 0 ? null : t };
};
z.startTransition = function(e) {
  var t = kr.transition;
  kr.transition = {};
  try {
    e();
  } finally {
    kr.transition = t;
  }
};
z.unstable_act = ts;
z.useCallback = function(e, t) {
  return oe.current.useCallback(e, t);
};
z.useContext = function(e) {
  return oe.current.useContext(e);
};
z.useDebugValue = function() {
};
z.useDeferredValue = function(e) {
  return oe.current.useDeferredValue(e);
};
z.useEffect = function(e, t) {
  return oe.current.useEffect(e, t);
};
z.useId = function() {
  return oe.current.useId();
};
z.useImperativeHandle = function(e, t, n) {
  return oe.current.useImperativeHandle(e, t, n);
};
z.useInsertionEffect = function(e, t) {
  return oe.current.useInsertionEffect(e, t);
};
z.useLayoutEffect = function(e, t) {
  return oe.current.useLayoutEffect(e, t);
};
z.useMemo = function(e, t) {
  return oe.current.useMemo(e, t);
};
z.useReducer = function(e, t, n) {
  return oe.current.useReducer(e, t, n);
};
z.useRef = function(e) {
  return oe.current.useRef(e);
};
z.useState = function(e) {
  return oe.current.useState(e);
};
z.useSyncExternalStore = function(e, t, n) {
  return oe.current.useSyncExternalStore(e, t, n);
};
z.useTransition = function() {
  return oe.current.useTransition();
};
z.version = "18.3.1";
Yi.exports = z;
var Bu = Yi.exports;
const Ot = /* @__PURE__ */ cc(Bu);
var Pc = Bu, Nc = Symbol.for("react.element"), Tc = Symbol.for("react.fragment"), zc = Object.prototype.hasOwnProperty, Lc = Pc.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, Rc = { key: !0, ref: !0, __self: !0, __source: !0 };
function ns(e, t, n) {
  var r, l = {}, u = null, o = null;
  n !== void 0 && (u = "" + n), t.key !== void 0 && (u = "" + t.key), t.ref !== void 0 && (o = t.ref);
  for (r in t) zc.call(t, r) && !Rc.hasOwnProperty(r) && (l[r] = t[r]);
  if (e && e.defaultProps) for (r in t = e.defaultProps, t) l[r] === void 0 && (l[r] = t[r]);
  return { $$typeof: Nc, type: e, key: u, ref: o, props: l, _owner: Lc.current };
}
nl.Fragment = Tc;
nl.jsx = ns;
nl.jsxs = ns;
Ki.exports = nl;
var Ne = Ki.exports, rs = { exports: {} }, ye = {}, ls = { exports: {} }, us = {};
(function(e) {
  function t(C, N) {
    var T = C.length;
    C.push(N);
    e: for (; 0 < T; ) {
      var B = T - 1 >>> 1, X = C[B];
      if (0 < l(X, N)) C[B] = N, C[T] = X, T = B;
      else break e;
    }
  }
  function n(C) {
    return C.length === 0 ? null : C[0];
  }
  function r(C) {
    if (C.length === 0) return null;
    var N = C[0], T = C.pop();
    if (T !== N) {
      C[0] = T;
      e: for (var B = 0, X = C.length, tr = X >>> 1; B < tr; ) {
        var ht = 2 * (B + 1) - 1, Sl = C[ht], vt = ht + 1, nr = C[vt];
        if (0 > l(Sl, T)) vt < X && 0 > l(nr, Sl) ? (C[B] = nr, C[vt] = T, B = vt) : (C[B] = Sl, C[ht] = T, B = ht);
        else if (vt < X && 0 > l(nr, T)) C[B] = nr, C[vt] = T, B = vt;
        else break e;
      }
    }
    return N;
  }
  function l(C, N) {
    var T = C.sortIndex - N.sortIndex;
    return T !== 0 ? T : C.id - N.id;
  }
  if (typeof performance == "object" && typeof performance.now == "function") {
    var u = performance;
    e.unstable_now = function() {
      return u.now();
    };
  } else {
    var o = Date, i = o.now();
    e.unstable_now = function() {
      return o.now() - i;
    };
  }
  var s = [], c = [], h = 1, m = null, p = 3, S = !1, v = !1, w = !1, L = typeof setTimeout == "function" ? setTimeout : null, f = typeof clearTimeout == "function" ? clearTimeout : null, a = typeof setImmediate < "u" ? setImmediate : null;
  typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
  function d(C) {
    for (var N = n(c); N !== null; ) {
      if (N.callback === null) r(c);
      else if (N.startTime <= C) r(c), N.sortIndex = N.expirationTime, t(s, N);
      else break;
      N = n(c);
    }
  }
  function y(C) {
    if (w = !1, d(C), !v) if (n(s) !== null) v = !0, gl(k);
    else {
      var N = n(c);
      N !== null && wl(y, N.startTime - C);
    }
  }
  function k(C, N) {
    v = !1, w && (w = !1, f(P), P = -1), S = !0;
    var T = p;
    try {
      for (d(N), m = n(s); m !== null && (!(m.expirationTime > N) || C && !xe()); ) {
        var B = m.callback;
        if (typeof B == "function") {
          m.callback = null, p = m.priorityLevel;
          var X = B(m.expirationTime <= N);
          N = e.unstable_now(), typeof X == "function" ? m.callback = X : m === n(s) && r(s), d(N);
        } else r(s);
        m = n(s);
      }
      if (m !== null) var tr = !0;
      else {
        var ht = n(c);
        ht !== null && wl(y, ht.startTime - N), tr = !1;
      }
      return tr;
    } finally {
      m = null, p = T, S = !1;
    }
  }
  var _ = !1, x = null, P = -1, H = 5, R = -1;
  function xe() {
    return !(e.unstable_now() - R < H);
  }
  function cn() {
    if (x !== null) {
      var C = e.unstable_now();
      R = C;
      var N = !0;
      try {
        N = x(!0, C);
      } finally {
        N ? fn() : (_ = !1, x = null);
      }
    } else _ = !1;
  }
  var fn;
  if (typeof a == "function") fn = function() {
    a(cn);
  };
  else if (typeof MessageChannel < "u") {
    var Do = new MessageChannel(), ic = Do.port2;
    Do.port1.onmessage = cn, fn = function() {
      ic.postMessage(null);
    };
  } else fn = function() {
    L(cn, 0);
  };
  function gl(C) {
    x = C, _ || (_ = !0, fn());
  }
  function wl(C, N) {
    P = L(function() {
      C(e.unstable_now());
    }, N);
  }
  e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(C) {
    C.callback = null;
  }, e.unstable_continueExecution = function() {
    v || S || (v = !0, gl(k));
  }, e.unstable_forceFrameRate = function(C) {
    0 > C || 125 < C ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : H = 0 < C ? Math.floor(1e3 / C) : 5;
  }, e.unstable_getCurrentPriorityLevel = function() {
    return p;
  }, e.unstable_getFirstCallbackNode = function() {
    return n(s);
  }, e.unstable_next = function(C) {
    switch (p) {
      case 1:
      case 2:
      case 3:
        var N = 3;
        break;
      default:
        N = p;
    }
    var T = p;
    p = N;
    try {
      return C();
    } finally {
      p = T;
    }
  }, e.unstable_pauseExecution = function() {
  }, e.unstable_requestPaint = function() {
  }, e.unstable_runWithPriority = function(C, N) {
    switch (C) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        break;
      default:
        C = 3;
    }
    var T = p;
    p = C;
    try {
      return N();
    } finally {
      p = T;
    }
  }, e.unstable_scheduleCallback = function(C, N, T) {
    var B = e.unstable_now();
    switch (typeof T == "object" && T !== null ? (T = T.delay, T = typeof T == "number" && 0 < T ? B + T : B) : T = B, C) {
      case 1:
        var X = -1;
        break;
      case 2:
        X = 250;
        break;
      case 5:
        X = 1073741823;
        break;
      case 4:
        X = 1e4;
        break;
      default:
        X = 5e3;
    }
    return X = T + X, C = { id: h++, callback: N, priorityLevel: C, startTime: T, expirationTime: X, sortIndex: -1 }, T > B ? (C.sortIndex = T, t(c, C), n(s) === null && C === n(c) && (w ? (f(P), P = -1) : w = !0, wl(y, T - B))) : (C.sortIndex = X, t(s, C), v || S || (v = !0, gl(k))), C;
  }, e.unstable_shouldYield = xe, e.unstable_wrapCallback = function(C) {
    var N = p;
    return function() {
      var T = p;
      p = N;
      try {
        return C.apply(this, arguments);
      } finally {
        p = T;
      }
    };
  };
})(us);
ls.exports = us;
var Mc = ls.exports;
var Ic = Bu, ve = Mc;
function g(e) {
  for (var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, n = 1; n < arguments.length; n++) t += "&args[]=" + encodeURIComponent(arguments[n]);
  return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var os = /* @__PURE__ */ new Set(), In = {};
function Rt(e, t) {
  bt(e, t), bt(e + "Capture", t);
}
function bt(e, t) {
  for (In[e] = t, e = 0; e < t.length; e++) os.add(t[e]);
}
var We = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), Yl = Object.prototype.hasOwnProperty, Oc = /^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$/, Ao = {}, $o = {};
function Dc(e) {
  return Yl.call($o, e) ? !0 : Yl.call(Ao, e) ? !1 : Oc.test(e) ? $o[e] = !0 : (Ao[e] = !0, !1);
}
function Fc(e, t, n, r) {
  if (n !== null && n.type === 0) return !1;
  switch (typeof t) {
    case "function":
    case "symbol":
      return !0;
    case "boolean":
      return r ? !1 : n !== null ? !n.acceptsBooleans : (e = e.toLowerCase().slice(0, 5), e !== "data-" && e !== "aria-");
    default:
      return !1;
  }
}
function jc(e, t, n, r) {
  if (t === null || typeof t > "u" || Fc(e, t, n, r)) return !0;
  if (r) return !1;
  if (n !== null) switch (n.type) {
    case 3:
      return !t;
    case 4:
      return t === !1;
    case 5:
      return isNaN(t);
    case 6:
      return isNaN(t) || 1 > t;
  }
  return !1;
}
function ie(e, t, n, r, l, u, o) {
  this.acceptsBooleans = t === 2 || t === 3 || t === 4, this.attributeName = r, this.attributeNamespace = l, this.mustUseProperty = n, this.propertyName = e, this.type = t, this.sanitizeURL = u, this.removeEmptyString = o;
}
var b = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(e) {
  b[e] = new ie(e, 0, !1, e, null, !1, !1);
});
[["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(e) {
  var t = e[0];
  b[t] = new ie(t, 1, !1, e[1], null, !1, !1);
});
["contentEditable", "draggable", "spellCheck", "value"].forEach(function(e) {
  b[e] = new ie(e, 2, !1, e.toLowerCase(), null, !1, !1);
});
["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(e) {
  b[e] = new ie(e, 2, !1, e, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(e) {
  b[e] = new ie(e, 3, !1, e.toLowerCase(), null, !1, !1);
});
["checked", "multiple", "muted", "selected"].forEach(function(e) {
  b[e] = new ie(e, 3, !0, e, null, !1, !1);
});
["capture", "download"].forEach(function(e) {
  b[e] = new ie(e, 4, !1, e, null, !1, !1);
});
["cols", "rows", "size", "span"].forEach(function(e) {
  b[e] = new ie(e, 6, !1, e, null, !1, !1);
});
["rowSpan", "start"].forEach(function(e) {
  b[e] = new ie(e, 5, !1, e.toLowerCase(), null, !1, !1);
});
var Wu = /[\\-:]([a-z])/g;
function Qu(e) {
  return e[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(e) {
  var t = e.replace(
    Wu,
    Qu
  );
  b[t] = new ie(t, 1, !1, e, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(e) {
  var t = e.replace(Wu, Qu);
  b[t] = new ie(t, 1, !1, e, "http://www.w3.org/1999/xlink", !1, !1);
});
["xml:base", "xml:lang", "xml:space"].forEach(function(e) {
  var t = e.replace(Wu, Qu);
  b[t] = new ie(t, 1, !1, e, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
["tabIndex", "crossOrigin"].forEach(function(e) {
  b[e] = new ie(e, 1, !1, e.toLowerCase(), null, !1, !1);
});
b.xlinkHref = new ie("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
["src", "href", "action", "formAction"].forEach(function(e) {
  b[e] = new ie(e, 1, !1, e.toLowerCase(), null, !0, !0);
});
function Ku(e, t, n, r) {
  var l = b.hasOwnProperty(t) ? b[t] : null;
  (l !== null ? l.type !== 0 : r || !(2 < t.length) || t[0] !== "o" && t[0] !== "O" || t[1] !== "n" && t[1] !== "N") && (jc(t, n, l, r) && (n = null), r || l === null ? Dc(t) && (n === null ? e.removeAttribute(t) : e.setAttribute(t, "" + n)) : l.mustUseProperty ? e[l.propertyName] = n === null ? l.type === 3 ? !1 : "" : n : (t = l.attributeName, r = l.attributeNamespace, n === null ? e.removeAttribute(t) : (l = l.type, n = l === 3 || l === 4 && n === !0 ? "" : "" + n, r ? e.setAttributeNS(r, t, n) : e.setAttribute(t, n))));
}
var Xe = Ic.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, lr = Symbol.for("react.element"), Dt = Symbol.for("react.portal"), Ft = Symbol.for("react.fragment"), Yu = Symbol.for("react.strict_mode"), Xl = Symbol.for("react.profiler"), is = Symbol.for("react.provider"), ss = Symbol.for("react.context"), Xu = Symbol.for("react.forward_ref"), Gl = Symbol.for("react.suspense"), Zl = Symbol.for("react.suspense_list"), Gu = Symbol.for("react.memo"), Ze = Symbol.for("react.lazy"), as = Symbol.for("react.offscreen"), Vo = Symbol.iterator;
function dn(e) {
  return e === null || typeof e != "object" ? null : (e = Vo && e[Vo] || e["@@iterator"], typeof e == "function" ? e : null);
}
var $ = Object.assign, El;
function Sn(e) {
  if (El === void 0) try {
    throw Error();
  } catch (n) {
    var t = n.stack.trim().match(/\\n( *(at )?)/);
    El = t && t[1] || "";
  }
  return \`
\` + El + e;
}
var Cl = !1;
function _l(e, t) {
  if (!e || Cl) return "";
  Cl = !0;
  var n = Error.prepareStackTrace;
  Error.prepareStackTrace = void 0;
  try {
    if (t) if (t = function() {
      throw Error();
    }, Object.defineProperty(t.prototype, "props", { set: function() {
      throw Error();
    } }), typeof Reflect == "object" && Reflect.construct) {
      try {
        Reflect.construct(t, []);
      } catch (c) {
        var r = c;
      }
      Reflect.construct(e, [], t);
    } else {
      try {
        t.call();
      } catch (c) {
        r = c;
      }
      e.call(t.prototype);
    }
    else {
      try {
        throw Error();
      } catch (c) {
        r = c;
      }
      e();
    }
  } catch (c) {
    if (c && r && typeof c.stack == "string") {
      for (var l = c.stack.split(\`
\`), u = r.stack.split(\`
\`), o = l.length - 1, i = u.length - 1; 1 <= o && 0 <= i && l[o] !== u[i]; ) i--;
      for (; 1 <= o && 0 <= i; o--, i--) if (l[o] !== u[i]) {
        if (o !== 1 || i !== 1)
          do
            if (o--, i--, 0 > i || l[o] !== u[i]) {
              var s = \`
\` + l[o].replace(" at new ", " at ");
              return e.displayName && s.includes("<anonymous>") && (s = s.replace("<anonymous>", e.displayName)), s;
            }
          while (1 <= o && 0 <= i);
        break;
      }
    }
  } finally {
    Cl = !1, Error.prepareStackTrace = n;
  }
  return (e = e ? e.displayName || e.name : "") ? Sn(e) : "";
}
function Uc(e) {
  switch (e.tag) {
    case 5:
      return Sn(e.type);
    case 16:
      return Sn("Lazy");
    case 13:
      return Sn("Suspense");
    case 19:
      return Sn("SuspenseList");
    case 0:
    case 2:
    case 15:
      return e = _l(e.type, !1), e;
    case 11:
      return e = _l(e.type.render, !1), e;
    case 1:
      return e = _l(e.type, !0), e;
    default:
      return "";
  }
}
function Jl(e) {
  if (e == null) return null;
  if (typeof e == "function") return e.displayName || e.name || null;
  if (typeof e == "string") return e;
  switch (e) {
    case Ft:
      return "Fragment";
    case Dt:
      return "Portal";
    case Xl:
      return "Profiler";
    case Yu:
      return "StrictMode";
    case Gl:
      return "Suspense";
    case Zl:
      return "SuspenseList";
  }
  if (typeof e == "object") switch (e.$$typeof) {
    case ss:
      return (e.displayName || "Context") + ".Consumer";
    case is:
      return (e._context.displayName || "Context") + ".Provider";
    case Xu:
      var t = e.render;
      return e = e.displayName, e || (e = t.displayName || t.name || "", e = e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef"), e;
    case Gu:
      return t = e.displayName || null, t !== null ? t : Jl(e.type) || "Memo";
    case Ze:
      t = e._payload, e = e._init;
      try {
        return Jl(e(t));
      } catch {
      }
  }
  return null;
}
function Ac(e) {
  var t = e.type;
  switch (e.tag) {
    case 24:
      return "Cache";
    case 9:
      return (t.displayName || "Context") + ".Consumer";
    case 10:
      return (t._context.displayName || "Context") + ".Provider";
    case 18:
      return "DehydratedFragment";
    case 11:
      return e = t.render, e = e.displayName || e.name || "", t.displayName || (e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef");
    case 7:
      return "Fragment";
    case 5:
      return t;
    case 4:
      return "Portal";
    case 3:
      return "Root";
    case 6:
      return "Text";
    case 16:
      return Jl(t);
    case 8:
      return t === Yu ? "StrictMode" : "Mode";
    case 22:
      return "Offscreen";
    case 12:
      return "Profiler";
    case 21:
      return "Scope";
    case 13:
      return "Suspense";
    case 19:
      return "SuspenseList";
    case 25:
      return "TracingMarker";
    case 1:
    case 0:
    case 17:
    case 2:
    case 14:
    case 15:
      if (typeof t == "function") return t.displayName || t.name || null;
      if (typeof t == "string") return t;
  }
  return null;
}
function ct(e) {
  switch (typeof e) {
    case "boolean":
    case "number":
    case "string":
    case "undefined":
      return e;
    case "object":
      return e;
    default:
      return "";
  }
}
function cs(e) {
  var t = e.type;
  return (e = e.nodeName) && e.toLowerCase() === "input" && (t === "checkbox" || t === "radio");
}
function $c(e) {
  var t = cs(e) ? "checked" : "value", n = Object.getOwnPropertyDescriptor(e.constructor.prototype, t), r = "" + e[t];
  if (!e.hasOwnProperty(t) && typeof n < "u" && typeof n.get == "function" && typeof n.set == "function") {
    var l = n.get, u = n.set;
    return Object.defineProperty(e, t, { configurable: !0, get: function() {
      return l.call(this);
    }, set: function(o) {
      r = "" + o, u.call(this, o);
    } }), Object.defineProperty(e, t, { enumerable: n.enumerable }), { getValue: function() {
      return r;
    }, setValue: function(o) {
      r = "" + o;
    }, stopTracking: function() {
      e._valueTracker = null, delete e[t];
    } };
  }
}
function ur(e) {
  e._valueTracker || (e._valueTracker = $c(e));
}
function fs(e) {
  if (!e) return !1;
  var t = e._valueTracker;
  if (!t) return !0;
  var n = t.getValue(), r = "";
  return e && (r = cs(e) ? e.checked ? "true" : "false" : e.value), e = r, e !== n ? (t.setValue(e), !0) : !1;
}
function Mr(e) {
  if (e = e || (typeof document < "u" ? document : void 0), typeof e > "u") return null;
  try {
    return e.activeElement || e.body;
  } catch {
    return e.body;
  }
}
function ql(e, t) {
  var n = t.checked;
  return $({}, t, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: n ?? e._wrapperState.initialChecked });
}
function Ho(e, t) {
  var n = t.defaultValue == null ? "" : t.defaultValue, r = t.checked != null ? t.checked : t.defaultChecked;
  n = ct(t.value != null ? t.value : n), e._wrapperState = { initialChecked: r, initialValue: n, controlled: t.type === "checkbox" || t.type === "radio" ? t.checked != null : t.value != null };
}
function ds(e, t) {
  t = t.checked, t != null && Ku(e, "checked", t, !1);
}
function bl(e, t) {
  ds(e, t);
  var n = ct(t.value), r = t.type;
  if (n != null) r === "number" ? (n === 0 && e.value === "" || e.value != n) && (e.value = "" + n) : e.value !== "" + n && (e.value = "" + n);
  else if (r === "submit" || r === "reset") {
    e.removeAttribute("value");
    return;
  }
  t.hasOwnProperty("value") ? eu(e, t.type, n) : t.hasOwnProperty("defaultValue") && eu(e, t.type, ct(t.defaultValue)), t.checked == null && t.defaultChecked != null && (e.defaultChecked = !!t.defaultChecked);
}
function Bo(e, t, n) {
  if (t.hasOwnProperty("value") || t.hasOwnProperty("defaultValue")) {
    var r = t.type;
    if (!(r !== "submit" && r !== "reset" || t.value !== void 0 && t.value !== null)) return;
    t = "" + e._wrapperState.initialValue, n || t === e.value || (e.value = t), e.defaultValue = t;
  }
  n = e.name, n !== "" && (e.name = ""), e.defaultChecked = !!e._wrapperState.initialChecked, n !== "" && (e.name = n);
}
function eu(e, t, n) {
  (t !== "number" || Mr(e.ownerDocument) !== e) && (n == null ? e.defaultValue = "" + e._wrapperState.initialValue : e.defaultValue !== "" + n && (e.defaultValue = "" + n));
}
var kn = Array.isArray;
function Yt(e, t, n, r) {
  if (e = e.options, t) {
    t = {};
    for (var l = 0; l < n.length; l++) t["$" + n[l]] = !0;
    for (n = 0; n < e.length; n++) l = t.hasOwnProperty("$" + e[n].value), e[n].selected !== l && (e[n].selected = l), l && r && (e[n].defaultSelected = !0);
  } else {
    for (n = "" + ct(n), t = null, l = 0; l < e.length; l++) {
      if (e[l].value === n) {
        e[l].selected = !0, r && (e[l].defaultSelected = !0);
        return;
      }
      t !== null || e[l].disabled || (t = e[l]);
    }
    t !== null && (t.selected = !0);
  }
}
function tu(e, t) {
  if (t.dangerouslySetInnerHTML != null) throw Error(g(91));
  return $({}, t, { value: void 0, defaultValue: void 0, children: "" + e._wrapperState.initialValue });
}
function Wo(e, t) {
  var n = t.value;
  if (n == null) {
    if (n = t.children, t = t.defaultValue, n != null) {
      if (t != null) throw Error(g(92));
      if (kn(n)) {
        if (1 < n.length) throw Error(g(93));
        n = n[0];
      }
      t = n;
    }
    t == null && (t = ""), n = t;
  }
  e._wrapperState = { initialValue: ct(n) };
}
function ps(e, t) {
  var n = ct(t.value), r = ct(t.defaultValue);
  n != null && (n = "" + n, n !== e.value && (e.value = n), t.defaultValue == null && e.defaultValue !== n && (e.defaultValue = n)), r != null && (e.defaultValue = "" + r);
}
function Qo(e) {
  var t = e.textContent;
  t === e._wrapperState.initialValue && t !== "" && t !== null && (e.value = t);
}
function ms(e) {
  switch (e) {
    case "svg":
      return "http://www.w3.org/2000/svg";
    case "math":
      return "http://www.w3.org/1998/Math/MathML";
    default:
      return "http://www.w3.org/1999/xhtml";
  }
}
function nu(e, t) {
  return e == null || e === "http://www.w3.org/1999/xhtml" ? ms(t) : e === "http://www.w3.org/2000/svg" && t === "foreignObject" ? "http://www.w3.org/1999/xhtml" : e;
}
var or, hs = function(e) {
  return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(t, n, r, l) {
    MSApp.execUnsafeLocalFunction(function() {
      return e(t, n, r, l);
    });
  } : e;
}(function(e, t) {
  if (e.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in e) e.innerHTML = t;
  else {
    for (or = or || document.createElement("div"), or.innerHTML = "<svg>" + t.valueOf().toString() + "</svg>", t = or.firstChild; e.firstChild; ) e.removeChild(e.firstChild);
    for (; t.firstChild; ) e.appendChild(t.firstChild);
  }
});
function On(e, t) {
  if (t) {
    var n = e.firstChild;
    if (n && n === e.lastChild && n.nodeType === 3) {
      n.nodeValue = t;
      return;
    }
  }
  e.textContent = t;
}
var _n = {
  animationIterationCount: !0,
  aspectRatio: !0,
  borderImageOutset: !0,
  borderImageSlice: !0,
  borderImageWidth: !0,
  boxFlex: !0,
  boxFlexGroup: !0,
  boxOrdinalGroup: !0,
  columnCount: !0,
  columns: !0,
  flex: !0,
  flexGrow: !0,
  flexPositive: !0,
  flexShrink: !0,
  flexNegative: !0,
  flexOrder: !0,
  gridArea: !0,
  gridRow: !0,
  gridRowEnd: !0,
  gridRowSpan: !0,
  gridRowStart: !0,
  gridColumn: !0,
  gridColumnEnd: !0,
  gridColumnSpan: !0,
  gridColumnStart: !0,
  fontWeight: !0,
  lineClamp: !0,
  lineHeight: !0,
  opacity: !0,
  order: !0,
  orphans: !0,
  tabSize: !0,
  widows: !0,
  zIndex: !0,
  zoom: !0,
  fillOpacity: !0,
  floodOpacity: !0,
  stopOpacity: !0,
  strokeDasharray: !0,
  strokeDashoffset: !0,
  strokeMiterlimit: !0,
  strokeOpacity: !0,
  strokeWidth: !0
}, Vc = ["Webkit", "ms", "Moz", "O"];
Object.keys(_n).forEach(function(e) {
  Vc.forEach(function(t) {
    t = t + e.charAt(0).toUpperCase() + e.substring(1), _n[t] = _n[e];
  });
});
function vs(e, t, n) {
  return t == null || typeof t == "boolean" || t === "" ? "" : n || typeof t != "number" || t === 0 || _n.hasOwnProperty(e) && _n[e] ? ("" + t).trim() : t + "px";
}
function ys(e, t) {
  e = e.style;
  for (var n in t) if (t.hasOwnProperty(n)) {
    var r = n.indexOf("--") === 0, l = vs(n, t[n], r);
    n === "float" && (n = "cssFloat"), r ? e.setProperty(n, l) : e[n] = l;
  }
}
var Hc = $({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
function ru(e, t) {
  if (t) {
    if (Hc[e] && (t.children != null || t.dangerouslySetInnerHTML != null)) throw Error(g(137, e));
    if (t.dangerouslySetInnerHTML != null) {
      if (t.children != null) throw Error(g(60));
      if (typeof t.dangerouslySetInnerHTML != "object" || !("__html" in t.dangerouslySetInnerHTML)) throw Error(g(61));
    }
    if (t.style != null && typeof t.style != "object") throw Error(g(62));
  }
}
function lu(e, t) {
  if (e.indexOf("-") === -1) return typeof t.is == "string";
  switch (e) {
    case "annotation-xml":
    case "color-profile":
    case "font-face":
    case "font-face-src":
    case "font-face-uri":
    case "font-face-format":
    case "font-face-name":
    case "missing-glyph":
      return !1;
    default:
      return !0;
  }
}
var uu = null;
function Zu(e) {
  return e = e.target || e.srcElement || window, e.correspondingUseElement && (e = e.correspondingUseElement), e.nodeType === 3 ? e.parentNode : e;
}
var ou = null, Xt = null, Gt = null;
function Ko(e) {
  if (e = bn(e)) {
    if (typeof ou != "function") throw Error(g(280));
    var t = e.stateNode;
    t && (t = il(t), ou(e.stateNode, e.type, t));
  }
}
function gs(e) {
  Xt ? Gt ? Gt.push(e) : Gt = [e] : Xt = e;
}
function ws() {
  if (Xt) {
    var e = Xt, t = Gt;
    if (Gt = Xt = null, Ko(e), t) for (e = 0; e < t.length; e++) Ko(t[e]);
  }
}
function Ss(e, t) {
  return e(t);
}
function ks() {
}
var xl = !1;
function Es(e, t, n) {
  if (xl) return e(t, n);
  xl = !0;
  try {
    return Ss(e, t, n);
  } finally {
    xl = !1, (Xt !== null || Gt !== null) && (ks(), ws());
  }
}
function Dn(e, t) {
  var n = e.stateNode;
  if (n === null) return null;
  var r = il(n);
  if (r === null) return null;
  n = r[t];
  e: switch (t) {
    case "onClick":
    case "onClickCapture":
    case "onDoubleClick":
    case "onDoubleClickCapture":
    case "onMouseDown":
    case "onMouseDownCapture":
    case "onMouseMove":
    case "onMouseMoveCapture":
    case "onMouseUp":
    case "onMouseUpCapture":
    case "onMouseEnter":
      (r = !r.disabled) || (e = e.type, r = !(e === "button" || e === "input" || e === "select" || e === "textarea")), e = !r;
      break e;
    default:
      e = !1;
  }
  if (e) return null;
  if (n && typeof n != "function") throw Error(g(231, t, typeof n));
  return n;
}
var iu = !1;
if (We) try {
  var pn = {};
  Object.defineProperty(pn, "passive", { get: function() {
    iu = !0;
  } }), window.addEventListener("test", pn, pn), window.removeEventListener("test", pn, pn);
} catch {
  iu = !1;
}
function Bc(e, t, n, r, l, u, o, i, s) {
  var c = Array.prototype.slice.call(arguments, 3);
  try {
    t.apply(n, c);
  } catch (h) {
    this.onError(h);
  }
}
var xn = !1, Ir = null, Or = !1, su = null, Wc = { onError: function(e) {
  xn = !0, Ir = e;
} };
function Qc(e, t, n, r, l, u, o, i, s) {
  xn = !1, Ir = null, Bc.apply(Wc, arguments);
}
function Kc(e, t, n, r, l, u, o, i, s) {
  if (Qc.apply(this, arguments), xn) {
    if (xn) {
      var c = Ir;
      xn = !1, Ir = null;
    } else throw Error(g(198));
    Or || (Or = !0, su = c);
  }
}
function Mt(e) {
  var t = e, n = e;
  if (e.alternate) for (; t.return; ) t = t.return;
  else {
    e = t;
    do
      t = e, t.flags & 4098 && (n = t.return), e = t.return;
    while (e);
  }
  return t.tag === 3 ? n : null;
}
function Cs(e) {
  if (e.tag === 13) {
    var t = e.memoizedState;
    if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null) return t.dehydrated;
  }
  return null;
}
function Yo(e) {
  if (Mt(e) !== e) throw Error(g(188));
}
function Yc(e) {
  var t = e.alternate;
  if (!t) {
    if (t = Mt(e), t === null) throw Error(g(188));
    return t !== e ? null : e;
  }
  for (var n = e, r = t; ; ) {
    var l = n.return;
    if (l === null) break;
    var u = l.alternate;
    if (u === null) {
      if (r = l.return, r !== null) {
        n = r;
        continue;
      }
      break;
    }
    if (l.child === u.child) {
      for (u = l.child; u; ) {
        if (u === n) return Yo(l), e;
        if (u === r) return Yo(l), t;
        u = u.sibling;
      }
      throw Error(g(188));
    }
    if (n.return !== r.return) n = l, r = u;
    else {
      for (var o = !1, i = l.child; i; ) {
        if (i === n) {
          o = !0, n = l, r = u;
          break;
        }
        if (i === r) {
          o = !0, r = l, n = u;
          break;
        }
        i = i.sibling;
      }
      if (!o) {
        for (i = u.child; i; ) {
          if (i === n) {
            o = !0, n = u, r = l;
            break;
          }
          if (i === r) {
            o = !0, r = u, n = l;
            break;
          }
          i = i.sibling;
        }
        if (!o) throw Error(g(189));
      }
    }
    if (n.alternate !== r) throw Error(g(190));
  }
  if (n.tag !== 3) throw Error(g(188));
  return n.stateNode.current === n ? e : t;
}
function _s(e) {
  return e = Yc(e), e !== null ? xs(e) : null;
}
function xs(e) {
  if (e.tag === 5 || e.tag === 6) return e;
  for (e = e.child; e !== null; ) {
    var t = xs(e);
    if (t !== null) return t;
    e = e.sibling;
  }
  return null;
}
var Ps = ve.unstable_scheduleCallback, Xo = ve.unstable_cancelCallback, Xc = ve.unstable_shouldYield, Gc = ve.unstable_requestPaint, W = ve.unstable_now, Zc = ve.unstable_getCurrentPriorityLevel, Ju = ve.unstable_ImmediatePriority, Ns = ve.unstable_UserBlockingPriority, Dr = ve.unstable_NormalPriority, Jc = ve.unstable_LowPriority, Ts = ve.unstable_IdlePriority, rl = null, je = null;
function qc(e) {
  if (je && typeof je.onCommitFiberRoot == "function") try {
    je.onCommitFiberRoot(rl, e, void 0, (e.current.flags & 128) === 128);
  } catch {
  }
}
var Re = Math.clz32 ? Math.clz32 : tf, bc = Math.log, ef = Math.LN2;
function tf(e) {
  return e >>>= 0, e === 0 ? 32 : 31 - (bc(e) / ef | 0) | 0;
}
var ir = 64, sr = 4194304;
function En(e) {
  switch (e & -e) {
    case 1:
      return 1;
    case 2:
      return 2;
    case 4:
      return 4;
    case 8:
      return 8;
    case 16:
      return 16;
    case 32:
      return 32;
    case 64:
    case 128:
    case 256:
    case 512:
    case 1024:
    case 2048:
    case 4096:
    case 8192:
    case 16384:
    case 32768:
    case 65536:
    case 131072:
    case 262144:
    case 524288:
    case 1048576:
    case 2097152:
      return e & 4194240;
    case 4194304:
    case 8388608:
    case 16777216:
    case 33554432:
    case 67108864:
      return e & 130023424;
    case 134217728:
      return 134217728;
    case 268435456:
      return 268435456;
    case 536870912:
      return 536870912;
    case 1073741824:
      return 1073741824;
    default:
      return e;
  }
}
function Fr(e, t) {
  var n = e.pendingLanes;
  if (n === 0) return 0;
  var r = 0, l = e.suspendedLanes, u = e.pingedLanes, o = n & 268435455;
  if (o !== 0) {
    var i = o & ~l;
    i !== 0 ? r = En(i) : (u &= o, u !== 0 && (r = En(u)));
  } else o = n & ~l, o !== 0 ? r = En(o) : u !== 0 && (r = En(u));
  if (r === 0) return 0;
  if (t !== 0 && t !== r && !(t & l) && (l = r & -r, u = t & -t, l >= u || l === 16 && (u & 4194240) !== 0)) return t;
  if (r & 4 && (r |= n & 16), t = e.entangledLanes, t !== 0) for (e = e.entanglements, t &= r; 0 < t; ) n = 31 - Re(t), l = 1 << n, r |= e[n], t &= ~l;
  return r;
}
function nf(e, t) {
  switch (e) {
    case 1:
    case 2:
    case 4:
      return t + 250;
    case 8:
    case 16:
    case 32:
    case 64:
    case 128:
    case 256:
    case 512:
    case 1024:
    case 2048:
    case 4096:
    case 8192:
    case 16384:
    case 32768:
    case 65536:
    case 131072:
    case 262144:
    case 524288:
    case 1048576:
    case 2097152:
      return t + 5e3;
    case 4194304:
    case 8388608:
    case 16777216:
    case 33554432:
    case 67108864:
      return -1;
    case 134217728:
    case 268435456:
    case 536870912:
    case 1073741824:
      return -1;
    default:
      return -1;
  }
}
function rf(e, t) {
  for (var n = e.suspendedLanes, r = e.pingedLanes, l = e.expirationTimes, u = e.pendingLanes; 0 < u; ) {
    var o = 31 - Re(u), i = 1 << o, s = l[o];
    s === -1 ? (!(i & n) || i & r) && (l[o] = nf(i, t)) : s <= t && (e.expiredLanes |= i), u &= ~i;
  }
}
function au(e) {
  return e = e.pendingLanes & -1073741825, e !== 0 ? e : e & 1073741824 ? 1073741824 : 0;
}
function zs() {
  var e = ir;
  return ir <<= 1, !(ir & 4194240) && (ir = 64), e;
}
function Pl(e) {
  for (var t = [], n = 0; 31 > n; n++) t.push(e);
  return t;
}
function Jn(e, t, n) {
  e.pendingLanes |= t, t !== 536870912 && (e.suspendedLanes = 0, e.pingedLanes = 0), e = e.eventTimes, t = 31 - Re(t), e[t] = n;
}
function lf(e, t) {
  var n = e.pendingLanes & ~t;
  e.pendingLanes = t, e.suspendedLanes = 0, e.pingedLanes = 0, e.expiredLanes &= t, e.mutableReadLanes &= t, e.entangledLanes &= t, t = e.entanglements;
  var r = e.eventTimes;
  for (e = e.expirationTimes; 0 < n; ) {
    var l = 31 - Re(n), u = 1 << l;
    t[l] = 0, r[l] = -1, e[l] = -1, n &= ~u;
  }
}
function qu(e, t) {
  var n = e.entangledLanes |= t;
  for (e = e.entanglements; n; ) {
    var r = 31 - Re(n), l = 1 << r;
    l & t | e[r] & t && (e[r] |= t), n &= ~l;
  }
}
var I = 0;
function Ls(e) {
  return e &= -e, 1 < e ? 4 < e ? e & 268435455 ? 16 : 536870912 : 4 : 1;
}
var Rs, bu, Ms, Is, Os, cu = !1, ar = [], nt = null, rt = null, lt = null, Fn = /* @__PURE__ */ new Map(), jn = /* @__PURE__ */ new Map(), qe = [], uf = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function Go(e, t) {
  switch (e) {
    case "focusin":
    case "focusout":
      nt = null;
      break;
    case "dragenter":
    case "dragleave":
      rt = null;
      break;
    case "mouseover":
    case "mouseout":
      lt = null;
      break;
    case "pointerover":
    case "pointerout":
      Fn.delete(t.pointerId);
      break;
    case "gotpointercapture":
    case "lostpointercapture":
      jn.delete(t.pointerId);
  }
}
function mn(e, t, n, r, l, u) {
  return e === null || e.nativeEvent !== u ? (e = { blockedOn: t, domEventName: n, eventSystemFlags: r, nativeEvent: u, targetContainers: [l] }, t !== null && (t = bn(t), t !== null && bu(t)), e) : (e.eventSystemFlags |= r, t = e.targetContainers, l !== null && t.indexOf(l) === -1 && t.push(l), e);
}
function of(e, t, n, r, l) {
  switch (t) {
    case "focusin":
      return nt = mn(nt, e, t, n, r, l), !0;
    case "dragenter":
      return rt = mn(rt, e, t, n, r, l), !0;
    case "mouseover":
      return lt = mn(lt, e, t, n, r, l), !0;
    case "pointerover":
      var u = l.pointerId;
      return Fn.set(u, mn(Fn.get(u) || null, e, t, n, r, l)), !0;
    case "gotpointercapture":
      return u = l.pointerId, jn.set(u, mn(jn.get(u) || null, e, t, n, r, l)), !0;
  }
  return !1;
}
function Ds(e) {
  var t = St(e.target);
  if (t !== null) {
    var n = Mt(t);
    if (n !== null) {
      if (t = n.tag, t === 13) {
        if (t = Cs(n), t !== null) {
          e.blockedOn = t, Os(e.priority, function() {
            Ms(n);
          });
          return;
        }
      } else if (t === 3 && n.stateNode.current.memoizedState.isDehydrated) {
        e.blockedOn = n.tag === 3 ? n.stateNode.containerInfo : null;
        return;
      }
    }
  }
  e.blockedOn = null;
}
function Er(e) {
  if (e.blockedOn !== null) return !1;
  for (var t = e.targetContainers; 0 < t.length; ) {
    var n = fu(e.domEventName, e.eventSystemFlags, t[0], e.nativeEvent);
    if (n === null) {
      n = e.nativeEvent;
      var r = new n.constructor(n.type, n);
      uu = r, n.target.dispatchEvent(r), uu = null;
    } else return t = bn(n), t !== null && bu(t), e.blockedOn = n, !1;
    t.shift();
  }
  return !0;
}
function Zo(e, t, n) {
  Er(e) && n.delete(t);
}
function sf() {
  cu = !1, nt !== null && Er(nt) && (nt = null), rt !== null && Er(rt) && (rt = null), lt !== null && Er(lt) && (lt = null), Fn.forEach(Zo), jn.forEach(Zo);
}
function hn(e, t) {
  e.blockedOn === t && (e.blockedOn = null, cu || (cu = !0, ve.unstable_scheduleCallback(ve.unstable_NormalPriority, sf)));
}
function Un(e) {
  function t(l) {
    return hn(l, e);
  }
  if (0 < ar.length) {
    hn(ar[0], e);
    for (var n = 1; n < ar.length; n++) {
      var r = ar[n];
      r.blockedOn === e && (r.blockedOn = null);
    }
  }
  for (nt !== null && hn(nt, e), rt !== null && hn(rt, e), lt !== null && hn(lt, e), Fn.forEach(t), jn.forEach(t), n = 0; n < qe.length; n++) r = qe[n], r.blockedOn === e && (r.blockedOn = null);
  for (; 0 < qe.length && (n = qe[0], n.blockedOn === null); ) Ds(n), n.blockedOn === null && qe.shift();
}
var Zt = Xe.ReactCurrentBatchConfig, jr = !0;
function af(e, t, n, r) {
  var l = I, u = Zt.transition;
  Zt.transition = null;
  try {
    I = 1, eo(e, t, n, r);
  } finally {
    I = l, Zt.transition = u;
  }
}
function cf(e, t, n, r) {
  var l = I, u = Zt.transition;
  Zt.transition = null;
  try {
    I = 4, eo(e, t, n, r);
  } finally {
    I = l, Zt.transition = u;
  }
}
function eo(e, t, n, r) {
  if (jr) {
    var l = fu(e, t, n, r);
    if (l === null) Fl(e, t, r, Ur, n), Go(e, r);
    else if (of(l, e, t, n, r)) r.stopPropagation();
    else if (Go(e, r), t & 4 && -1 < uf.indexOf(e)) {
      for (; l !== null; ) {
        var u = bn(l);
        if (u !== null && Rs(u), u = fu(e, t, n, r), u === null && Fl(e, t, r, Ur, n), u === l) break;
        l = u;
      }
      l !== null && r.stopPropagation();
    } else Fl(e, t, r, null, n);
  }
}
var Ur = null;
function fu(e, t, n, r) {
  if (Ur = null, e = Zu(r), e = St(e), e !== null) if (t = Mt(e), t === null) e = null;
  else if (n = t.tag, n === 13) {
    if (e = Cs(t), e !== null) return e;
    e = null;
  } else if (n === 3) {
    if (t.stateNode.current.memoizedState.isDehydrated) return t.tag === 3 ? t.stateNode.containerInfo : null;
    e = null;
  } else t !== e && (e = null);
  return Ur = e, null;
}
function Fs(e) {
  switch (e) {
    case "cancel":
    case "click":
    case "close":
    case "contextmenu":
    case "copy":
    case "cut":
    case "auxclick":
    case "dblclick":
    case "dragend":
    case "dragstart":
    case "drop":
    case "focusin":
    case "focusout":
    case "input":
    case "invalid":
    case "keydown":
    case "keypress":
    case "keyup":
    case "mousedown":
    case "mouseup":
    case "paste":
    case "pause":
    case "play":
    case "pointercancel":
    case "pointerdown":
    case "pointerup":
    case "ratechange":
    case "reset":
    case "resize":
    case "seeked":
    case "submit":
    case "touchcancel":
    case "touchend":
    case "touchstart":
    case "volumechange":
    case "change":
    case "selectionchange":
    case "textInput":
    case "compositionstart":
    case "compositionend":
    case "compositionupdate":
    case "beforeblur":
    case "afterblur":
    case "beforeinput":
    case "blur":
    case "fullscreenchange":
    case "focus":
    case "hashchange":
    case "popstate":
    case "select":
    case "selectstart":
      return 1;
    case "drag":
    case "dragenter":
    case "dragexit":
    case "dragleave":
    case "dragover":
    case "mousemove":
    case "mouseout":
    case "mouseover":
    case "pointermove":
    case "pointerout":
    case "pointerover":
    case "scroll":
    case "toggle":
    case "touchmove":
    case "wheel":
    case "mouseenter":
    case "mouseleave":
    case "pointerenter":
    case "pointerleave":
      return 4;
    case "message":
      switch (Zc()) {
        case Ju:
          return 1;
        case Ns:
          return 4;
        case Dr:
        case Jc:
          return 16;
        case Ts:
          return 536870912;
        default:
          return 16;
      }
    default:
      return 16;
  }
}
var et = null, to = null, Cr = null;
function js() {
  if (Cr) return Cr;
  var e, t = to, n = t.length, r, l = "value" in et ? et.value : et.textContent, u = l.length;
  for (e = 0; e < n && t[e] === l[e]; e++) ;
  var o = n - e;
  for (r = 1; r <= o && t[n - r] === l[u - r]; r++) ;
  return Cr = l.slice(e, 1 < r ? 1 - r : void 0);
}
function _r(e) {
  var t = e.keyCode;
  return "charCode" in e ? (e = e.charCode, e === 0 && t === 13 && (e = 13)) : e = t, e === 10 && (e = 13), 32 <= e || e === 13 ? e : 0;
}
function cr() {
  return !0;
}
function Jo() {
  return !1;
}
function ge(e) {
  function t(n, r, l, u, o) {
    this._reactName = n, this._targetInst = l, this.type = r, this.nativeEvent = u, this.target = o, this.currentTarget = null;
    for (var i in e) e.hasOwnProperty(i) && (n = e[i], this[i] = n ? n(u) : u[i]);
    return this.isDefaultPrevented = (u.defaultPrevented != null ? u.defaultPrevented : u.returnValue === !1) ? cr : Jo, this.isPropagationStopped = Jo, this;
  }
  return $(t.prototype, { preventDefault: function() {
    this.defaultPrevented = !0;
    var n = this.nativeEvent;
    n && (n.preventDefault ? n.preventDefault() : typeof n.returnValue != "unknown" && (n.returnValue = !1), this.isDefaultPrevented = cr);
  }, stopPropagation: function() {
    var n = this.nativeEvent;
    n && (n.stopPropagation ? n.stopPropagation() : typeof n.cancelBubble != "unknown" && (n.cancelBubble = !0), this.isPropagationStopped = cr);
  }, persist: function() {
  }, isPersistent: cr }), t;
}
var sn = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(e) {
  return e.timeStamp || Date.now();
}, defaultPrevented: 0, isTrusted: 0 }, no = ge(sn), qn = $({}, sn, { view: 0, detail: 0 }), ff = ge(qn), Nl, Tl, vn, ll = $({}, qn, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: ro, button: 0, buttons: 0, relatedTarget: function(e) {
  return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
}, movementX: function(e) {
  return "movementX" in e ? e.movementX : (e !== vn && (vn && e.type === "mousemove" ? (Nl = e.screenX - vn.screenX, Tl = e.screenY - vn.screenY) : Tl = Nl = 0, vn = e), Nl);
}, movementY: function(e) {
  return "movementY" in e ? e.movementY : Tl;
} }), qo = ge(ll), df = $({}, ll, { dataTransfer: 0 }), pf = ge(df), mf = $({}, qn, { relatedTarget: 0 }), zl = ge(mf), hf = $({}, sn, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), vf = ge(hf), yf = $({}, sn, { clipboardData: function(e) {
  return "clipboardData" in e ? e.clipboardData : window.clipboardData;
} }), gf = ge(yf), wf = $({}, sn, { data: 0 }), bo = ge(wf), Sf = {
  Esc: "Escape",
  Spacebar: " ",
  Left: "ArrowLeft",
  Up: "ArrowUp",
  Right: "ArrowRight",
  Down: "ArrowDown",
  Del: "Delete",
  Win: "OS",
  Menu: "ContextMenu",
  Apps: "ContextMenu",
  Scroll: "ScrollLock",
  MozPrintableKey: "Unidentified"
}, kf = {
  8: "Backspace",
  9: "Tab",
  12: "Clear",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  19: "Pause",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  45: "Insert",
  46: "Delete",
  112: "F1",
  113: "F2",
  114: "F3",
  115: "F4",
  116: "F5",
  117: "F6",
  118: "F7",
  119: "F8",
  120: "F9",
  121: "F10",
  122: "F11",
  123: "F12",
  144: "NumLock",
  145: "ScrollLock",
  224: "Meta"
}, Ef = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
function Cf(e) {
  var t = this.nativeEvent;
  return t.getModifierState ? t.getModifierState(e) : (e = Ef[e]) ? !!t[e] : !1;
}
function ro() {
  return Cf;
}
var _f = $({}, qn, { key: function(e) {
  if (e.key) {
    var t = Sf[e.key] || e.key;
    if (t !== "Unidentified") return t;
  }
  return e.type === "keypress" ? (e = _r(e), e === 13 ? "Enter" : String.fromCharCode(e)) : e.type === "keydown" || e.type === "keyup" ? kf[e.keyCode] || "Unidentified" : "";
}, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: ro, charCode: function(e) {
  return e.type === "keypress" ? _r(e) : 0;
}, keyCode: function(e) {
  return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
}, which: function(e) {
  return e.type === "keypress" ? _r(e) : e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
} }), xf = ge(_f), Pf = $({}, ll, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), ei = ge(Pf), Nf = $({}, qn, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: ro }), Tf = ge(Nf), zf = $({}, sn, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), Lf = ge(zf), Rf = $({}, ll, {
  deltaX: function(e) {
    return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
  },
  deltaY: function(e) {
    return "deltaY" in e ? e.deltaY : "wheelDeltaY" in e ? -e.wheelDeltaY : "wheelDelta" in e ? -e.wheelDelta : 0;
  },
  deltaZ: 0,
  deltaMode: 0
}), Mf = ge(Rf), If = [9, 13, 27, 32], lo = We && "CompositionEvent" in window, Pn = null;
We && "documentMode" in document && (Pn = document.documentMode);
var Of = We && "TextEvent" in window && !Pn, Us = We && (!lo || Pn && 8 < Pn && 11 >= Pn), ti = " ", ni = !1;
function As(e, t) {
  switch (e) {
    case "keyup":
      return If.indexOf(t.keyCode) !== -1;
    case "keydown":
      return t.keyCode !== 229;
    case "keypress":
    case "mousedown":
    case "focusout":
      return !0;
    default:
      return !1;
  }
}
function $s(e) {
  return e = e.detail, typeof e == "object" && "data" in e ? e.data : null;
}
var jt = !1;
function Df(e, t) {
  switch (e) {
    case "compositionend":
      return $s(t);
    case "keypress":
      return t.which !== 32 ? null : (ni = !0, ti);
    case "textInput":
      return e = t.data, e === ti && ni ? null : e;
    default:
      return null;
  }
}
function Ff(e, t) {
  if (jt) return e === "compositionend" || !lo && As(e, t) ? (e = js(), Cr = to = et = null, jt = !1, e) : null;
  switch (e) {
    case "paste":
      return null;
    case "keypress":
      if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
        if (t.char && 1 < t.char.length) return t.char;
        if (t.which) return String.fromCharCode(t.which);
      }
      return null;
    case "compositionend":
      return Us && t.locale !== "ko" ? null : t.data;
    default:
      return null;
  }
}
var jf = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
function ri(e) {
  var t = e && e.nodeName && e.nodeName.toLowerCase();
  return t === "input" ? !!jf[e.type] : t === "textarea";
}
function Vs(e, t, n, r) {
  gs(r), t = Ar(t, "onChange"), 0 < t.length && (n = new no("onChange", "change", null, n, r), e.push({ event: n, listeners: t }));
}
var Nn = null, An = null;
function Uf(e) {
  qs(e, 0);
}
function ul(e) {
  var t = $t(e);
  if (fs(t)) return e;
}
function Af(e, t) {
  if (e === "change") return t;
}
var Hs = !1;
if (We) {
  var Ll;
  if (We) {
    var Rl = "oninput" in document;
    if (!Rl) {
      var li = document.createElement("div");
      li.setAttribute("oninput", "return;"), Rl = typeof li.oninput == "function";
    }
    Ll = Rl;
  } else Ll = !1;
  Hs = Ll && (!document.documentMode || 9 < document.documentMode);
}
function ui() {
  Nn && (Nn.detachEvent("onpropertychange", Bs), An = Nn = null);
}
function Bs(e) {
  if (e.propertyName === "value" && ul(An)) {
    var t = [];
    Vs(t, An, e, Zu(e)), Es(Uf, t);
  }
}
function $f(e, t, n) {
  e === "focusin" ? (ui(), Nn = t, An = n, Nn.attachEvent("onpropertychange", Bs)) : e === "focusout" && ui();
}
function Vf(e) {
  if (e === "selectionchange" || e === "keyup" || e === "keydown") return ul(An);
}
function Hf(e, t) {
  if (e === "click") return ul(t);
}
function Bf(e, t) {
  if (e === "input" || e === "change") return ul(t);
}
function Wf(e, t) {
  return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
var Ie = typeof Object.is == "function" ? Object.is : Wf;
function $n(e, t) {
  if (Ie(e, t)) return !0;
  if (typeof e != "object" || e === null || typeof t != "object" || t === null) return !1;
  var n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length) return !1;
  for (r = 0; r < n.length; r++) {
    var l = n[r];
    if (!Yl.call(t, l) || !Ie(e[l], t[l])) return !1;
  }
  return !0;
}
function oi(e) {
  for (; e && e.firstChild; ) e = e.firstChild;
  return e;
}
function ii(e, t) {
  var n = oi(e);
  e = 0;
  for (var r; n; ) {
    if (n.nodeType === 3) {
      if (r = e + n.textContent.length, e <= t && r >= t) return { node: n, offset: t - e };
      e = r;
    }
    e: {
      for (; n; ) {
        if (n.nextSibling) {
          n = n.nextSibling;
          break e;
        }
        n = n.parentNode;
      }
      n = void 0;
    }
    n = oi(n);
  }
}
function Ws(e, t) {
  return e && t ? e === t ? !0 : e && e.nodeType === 3 ? !1 : t && t.nodeType === 3 ? Ws(e, t.parentNode) : "contains" in e ? e.contains(t) : e.compareDocumentPosition ? !!(e.compareDocumentPosition(t) & 16) : !1 : !1;
}
function Qs() {
  for (var e = window, t = Mr(); t instanceof e.HTMLIFrameElement; ) {
    try {
      var n = typeof t.contentWindow.location.href == "string";
    } catch {
      n = !1;
    }
    if (n) e = t.contentWindow;
    else break;
    t = Mr(e.document);
  }
  return t;
}
function uo(e) {
  var t = e && e.nodeName && e.nodeName.toLowerCase();
  return t && (t === "input" && (e.type === "text" || e.type === "search" || e.type === "tel" || e.type === "url" || e.type === "password") || t === "textarea" || e.contentEditable === "true");
}
function Qf(e) {
  var t = Qs(), n = e.focusedElem, r = e.selectionRange;
  if (t !== n && n && n.ownerDocument && Ws(n.ownerDocument.documentElement, n)) {
    if (r !== null && uo(n)) {
      if (t = r.start, e = r.end, e === void 0 && (e = t), "selectionStart" in n) n.selectionStart = t, n.selectionEnd = Math.min(e, n.value.length);
      else if (e = (t = n.ownerDocument || document) && t.defaultView || window, e.getSelection) {
        e = e.getSelection();
        var l = n.textContent.length, u = Math.min(r.start, l);
        r = r.end === void 0 ? u : Math.min(r.end, l), !e.extend && u > r && (l = r, r = u, u = l), l = ii(n, u);
        var o = ii(
          n,
          r
        );
        l && o && (e.rangeCount !== 1 || e.anchorNode !== l.node || e.anchorOffset !== l.offset || e.focusNode !== o.node || e.focusOffset !== o.offset) && (t = t.createRange(), t.setStart(l.node, l.offset), e.removeAllRanges(), u > r ? (e.addRange(t), e.extend(o.node, o.offset)) : (t.setEnd(o.node, o.offset), e.addRange(t)));
      }
    }
    for (t = [], e = n; e = e.parentNode; ) e.nodeType === 1 && t.push({ element: e, left: e.scrollLeft, top: e.scrollTop });
    for (typeof n.focus == "function" && n.focus(), n = 0; n < t.length; n++) e = t[n], e.element.scrollLeft = e.left, e.element.scrollTop = e.top;
  }
}
var Kf = We && "documentMode" in document && 11 >= document.documentMode, Ut = null, du = null, Tn = null, pu = !1;
function si(e, t, n) {
  var r = n.window === n ? n.document : n.nodeType === 9 ? n : n.ownerDocument;
  pu || Ut == null || Ut !== Mr(r) || (r = Ut, "selectionStart" in r && uo(r) ? r = { start: r.selectionStart, end: r.selectionEnd } : (r = (r.ownerDocument && r.ownerDocument.defaultView || window).getSelection(), r = { anchorNode: r.anchorNode, anchorOffset: r.anchorOffset, focusNode: r.focusNode, focusOffset: r.focusOffset }), Tn && $n(Tn, r) || (Tn = r, r = Ar(du, "onSelect"), 0 < r.length && (t = new no("onSelect", "select", null, t, n), e.push({ event: t, listeners: r }), t.target = Ut)));
}
function fr(e, t) {
  var n = {};
  return n[e.toLowerCase()] = t.toLowerCase(), n["Webkit" + e] = "webkit" + t, n["Moz" + e] = "moz" + t, n;
}
var At = { animationend: fr("Animation", "AnimationEnd"), animationiteration: fr("Animation", "AnimationIteration"), animationstart: fr("Animation", "AnimationStart"), transitionend: fr("Transition", "TransitionEnd") }, Ml = {}, Ks = {};
We && (Ks = document.createElement("div").style, "AnimationEvent" in window || (delete At.animationend.animation, delete At.animationiteration.animation, delete At.animationstart.animation), "TransitionEvent" in window || delete At.transitionend.transition);
function ol(e) {
  if (Ml[e]) return Ml[e];
  if (!At[e]) return e;
  var t = At[e], n;
  for (n in t) if (t.hasOwnProperty(n) && n in Ks) return Ml[e] = t[n];
  return e;
}
var Ys = ol("animationend"), Xs = ol("animationiteration"), Gs = ol("animationstart"), Zs = ol("transitionend"), Js = /* @__PURE__ */ new Map(), ai = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function dt(e, t) {
  Js.set(e, t), Rt(t, [e]);
}
for (var Il = 0; Il < ai.length; Il++) {
  var Ol = ai[Il], Yf = Ol.toLowerCase(), Xf = Ol[0].toUpperCase() + Ol.slice(1);
  dt(Yf, "on" + Xf);
}
dt(Ys, "onAnimationEnd");
dt(Xs, "onAnimationIteration");
dt(Gs, "onAnimationStart");
dt("dblclick", "onDoubleClick");
dt("focusin", "onFocus");
dt("focusout", "onBlur");
dt(Zs, "onTransitionEnd");
bt("onMouseEnter", ["mouseout", "mouseover"]);
bt("onMouseLeave", ["mouseout", "mouseover"]);
bt("onPointerEnter", ["pointerout", "pointerover"]);
bt("onPointerLeave", ["pointerout", "pointerover"]);
Rt("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
Rt("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
Rt("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]);
Rt("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
Rt("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
Rt("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Cn = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Gf = new Set("cancel close invalid load scroll toggle".split(" ").concat(Cn));
function ci(e, t, n) {
  var r = e.type || "unknown-event";
  e.currentTarget = n, Kc(r, t, void 0, e), e.currentTarget = null;
}
function qs(e, t) {
  t = (t & 4) !== 0;
  for (var n = 0; n < e.length; n++) {
    var r = e[n], l = r.event;
    r = r.listeners;
    e: {
      var u = void 0;
      if (t) for (var o = r.length - 1; 0 <= o; o--) {
        var i = r[o], s = i.instance, c = i.currentTarget;
        if (i = i.listener, s !== u && l.isPropagationStopped()) break e;
        ci(l, i, c), u = s;
      }
      else for (o = 0; o < r.length; o++) {
        if (i = r[o], s = i.instance, c = i.currentTarget, i = i.listener, s !== u && l.isPropagationStopped()) break e;
        ci(l, i, c), u = s;
      }
    }
  }
  if (Or) throw e = su, Or = !1, su = null, e;
}
function D(e, t) {
  var n = t[gu];
  n === void 0 && (n = t[gu] = /* @__PURE__ */ new Set());
  var r = e + "__bubble";
  n.has(r) || (bs(t, e, 2, !1), n.add(r));
}
function Dl(e, t, n) {
  var r = 0;
  t && (r |= 4), bs(n, e, r, t);
}
var dr = "_reactListening" + Math.random().toString(36).slice(2);
function Vn(e) {
  if (!e[dr]) {
    e[dr] = !0, os.forEach(function(n) {
      n !== "selectionchange" && (Gf.has(n) || Dl(n, !1, e), Dl(n, !0, e));
    });
    var t = e.nodeType === 9 ? e : e.ownerDocument;
    t === null || t[dr] || (t[dr] = !0, Dl("selectionchange", !1, t));
  }
}
function bs(e, t, n, r) {
  switch (Fs(t)) {
    case 1:
      var l = af;
      break;
    case 4:
      l = cf;
      break;
    default:
      l = eo;
  }
  n = l.bind(null, t, n, e), l = void 0, !iu || t !== "touchstart" && t !== "touchmove" && t !== "wheel" || (l = !0), r ? l !== void 0 ? e.addEventListener(t, n, { capture: !0, passive: l }) : e.addEventListener(t, n, !0) : l !== void 0 ? e.addEventListener(t, n, { passive: l }) : e.addEventListener(t, n, !1);
}
function Fl(e, t, n, r, l) {
  var u = r;
  if (!(t & 1) && !(t & 2) && r !== null) e: for (; ; ) {
    if (r === null) return;
    var o = r.tag;
    if (o === 3 || o === 4) {
      var i = r.stateNode.containerInfo;
      if (i === l || i.nodeType === 8 && i.parentNode === l) break;
      if (o === 4) for (o = r.return; o !== null; ) {
        var s = o.tag;
        if ((s === 3 || s === 4) && (s = o.stateNode.containerInfo, s === l || s.nodeType === 8 && s.parentNode === l)) return;
        o = o.return;
      }
      for (; i !== null; ) {
        if (o = St(i), o === null) return;
        if (s = o.tag, s === 5 || s === 6) {
          r = u = o;
          continue e;
        }
        i = i.parentNode;
      }
    }
    r = r.return;
  }
  Es(function() {
    var c = u, h = Zu(n), m = [];
    e: {
      var p = Js.get(e);
      if (p !== void 0) {
        var S = no, v = e;
        switch (e) {
          case "keypress":
            if (_r(n) === 0) break e;
          case "keydown":
          case "keyup":
            S = xf;
            break;
          case "focusin":
            v = "focus", S = zl;
            break;
          case "focusout":
            v = "blur", S = zl;
            break;
          case "beforeblur":
          case "afterblur":
            S = zl;
            break;
          case "click":
            if (n.button === 2) break e;
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            S = qo;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            S = pf;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            S = Tf;
            break;
          case Ys:
          case Xs:
          case Gs:
            S = vf;
            break;
          case Zs:
            S = Lf;
            break;
          case "scroll":
            S = ff;
            break;
          case "wheel":
            S = Mf;
            break;
          case "copy":
          case "cut":
          case "paste":
            S = gf;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            S = ei;
        }
        var w = (t & 4) !== 0, L = !w && e === "scroll", f = w ? p !== null ? p + "Capture" : null : p;
        w = [];
        for (var a = c, d; a !== null; ) {
          d = a;
          var y = d.stateNode;
          if (d.tag === 5 && y !== null && (d = y, f !== null && (y = Dn(a, f), y != null && w.push(Hn(a, y, d)))), L) break;
          a = a.return;
        }
        0 < w.length && (p = new S(p, v, null, n, h), m.push({ event: p, listeners: w }));
      }
    }
    if (!(t & 7)) {
      e: {
        if (p = e === "mouseover" || e === "pointerover", S = e === "mouseout" || e === "pointerout", p && n !== uu && (v = n.relatedTarget || n.fromElement) && (St(v) || v[Qe])) break e;
        if ((S || p) && (p = h.window === h ? h : (p = h.ownerDocument) ? p.defaultView || p.parentWindow : window, S ? (v = n.relatedTarget || n.toElement, S = c, v = v ? St(v) : null, v !== null && (L = Mt(v), v !== L || v.tag !== 5 && v.tag !== 6) && (v = null)) : (S = null, v = c), S !== v)) {
          if (w = qo, y = "onMouseLeave", f = "onMouseEnter", a = "mouse", (e === "pointerout" || e === "pointerover") && (w = ei, y = "onPointerLeave", f = "onPointerEnter", a = "pointer"), L = S == null ? p : $t(S), d = v == null ? p : $t(v), p = new w(y, a + "leave", S, n, h), p.target = L, p.relatedTarget = d, y = null, St(h) === c && (w = new w(f, a + "enter", v, n, h), w.target = d, w.relatedTarget = L, y = w), L = y, S && v) t: {
            for (w = S, f = v, a = 0, d = w; d; d = It(d)) a++;
            for (d = 0, y = f; y; y = It(y)) d++;
            for (; 0 < a - d; ) w = It(w), a--;
            for (; 0 < d - a; ) f = It(f), d--;
            for (; a--; ) {
              if (w === f || f !== null && w === f.alternate) break t;
              w = It(w), f = It(f);
            }
            w = null;
          }
          else w = null;
          S !== null && fi(m, p, S, w, !1), v !== null && L !== null && fi(m, L, v, w, !0);
        }
      }
      e: {
        if (p = c ? $t(c) : window, S = p.nodeName && p.nodeName.toLowerCase(), S === "select" || S === "input" && p.type === "file") var k = Af;
        else if (ri(p)) if (Hs) k = Bf;
        else {
          k = Vf;
          var _ = $f;
        }
        else (S = p.nodeName) && S.toLowerCase() === "input" && (p.type === "checkbox" || p.type === "radio") && (k = Hf);
        if (k && (k = k(e, c))) {
          Vs(m, k, n, h);
          break e;
        }
        _ && _(e, p, c), e === "focusout" && (_ = p._wrapperState) && _.controlled && p.type === "number" && eu(p, "number", p.value);
      }
      switch (_ = c ? $t(c) : window, e) {
        case "focusin":
          (ri(_) || _.contentEditable === "true") && (Ut = _, du = c, Tn = null);
          break;
        case "focusout":
          Tn = du = Ut = null;
          break;
        case "mousedown":
          pu = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          pu = !1, si(m, n, h);
          break;
        case "selectionchange":
          if (Kf) break;
        case "keydown":
        case "keyup":
          si(m, n, h);
      }
      var x;
      if (lo) e: {
        switch (e) {
          case "compositionstart":
            var P = "onCompositionStart";
            break e;
          case "compositionend":
            P = "onCompositionEnd";
            break e;
          case "compositionupdate":
            P = "onCompositionUpdate";
            break e;
        }
        P = void 0;
      }
      else jt ? As(e, n) && (P = "onCompositionEnd") : e === "keydown" && n.keyCode === 229 && (P = "onCompositionStart");
      P && (Us && n.locale !== "ko" && (jt || P !== "onCompositionStart" ? P === "onCompositionEnd" && jt && (x = js()) : (et = h, to = "value" in et ? et.value : et.textContent, jt = !0)), _ = Ar(c, P), 0 < _.length && (P = new bo(P, e, null, n, h), m.push({ event: P, listeners: _ }), x ? P.data = x : (x = $s(n), x !== null && (P.data = x)))), (x = Of ? Df(e, n) : Ff(e, n)) && (c = Ar(c, "onBeforeInput"), 0 < c.length && (h = new bo("onBeforeInput", "beforeinput", null, n, h), m.push({ event: h, listeners: c }), h.data = x));
    }
    qs(m, t);
  });
}
function Hn(e, t, n) {
  return { instance: e, listener: t, currentTarget: n };
}
function Ar(e, t) {
  for (var n = t + "Capture", r = []; e !== null; ) {
    var l = e, u = l.stateNode;
    l.tag === 5 && u !== null && (l = u, u = Dn(e, n), u != null && r.unshift(Hn(e, u, l)), u = Dn(e, t), u != null && r.push(Hn(e, u, l))), e = e.return;
  }
  return r;
}
function It(e) {
  if (e === null) return null;
  do
    e = e.return;
  while (e && e.tag !== 5);
  return e || null;
}
function fi(e, t, n, r, l) {
  for (var u = t._reactName, o = []; n !== null && n !== r; ) {
    var i = n, s = i.alternate, c = i.stateNode;
    if (s !== null && s === r) break;
    i.tag === 5 && c !== null && (i = c, l ? (s = Dn(n, u), s != null && o.unshift(Hn(n, s, i))) : l || (s = Dn(n, u), s != null && o.push(Hn(n, s, i)))), n = n.return;
  }
  o.length !== 0 && e.push({ event: t, listeners: o });
}
var Zf = /\\r\\n?/g, Jf = /\\u0000|\\uFFFD/g;
function di(e) {
  return (typeof e == "string" ? e : "" + e).replace(Zf, \`
\`).replace(Jf, "");
}
function pr(e, t, n) {
  if (t = di(t), di(e) !== t && n) throw Error(g(425));
}
function $r() {
}
var mu = null, hu = null;
function vu(e, t) {
  return e === "textarea" || e === "noscript" || typeof t.children == "string" || typeof t.children == "number" || typeof t.dangerouslySetInnerHTML == "object" && t.dangerouslySetInnerHTML !== null && t.dangerouslySetInnerHTML.__html != null;
}
var yu = typeof setTimeout == "function" ? setTimeout : void 0, qf = typeof clearTimeout == "function" ? clearTimeout : void 0, pi = typeof Promise == "function" ? Promise : void 0, bf = typeof queueMicrotask == "function" ? queueMicrotask : typeof pi < "u" ? function(e) {
  return pi.resolve(null).then(e).catch(ed);
} : yu;
function ed(e) {
  setTimeout(function() {
    throw e;
  });
}
function jl(e, t) {
  var n = t, r = 0;
  do {
    var l = n.nextSibling;
    if (e.removeChild(n), l && l.nodeType === 8) if (n = l.data, n === "/$") {
      if (r === 0) {
        e.removeChild(l), Un(t);
        return;
      }
      r--;
    } else n !== "$" && n !== "$?" && n !== "$!" || r++;
    n = l;
  } while (n);
  Un(t);
}
function ut(e) {
  for (; e != null; e = e.nextSibling) {
    var t = e.nodeType;
    if (t === 1 || t === 3) break;
    if (t === 8) {
      if (t = e.data, t === "$" || t === "$!" || t === "$?") break;
      if (t === "/$") return null;
    }
  }
  return e;
}
function mi(e) {
  e = e.previousSibling;
  for (var t = 0; e; ) {
    if (e.nodeType === 8) {
      var n = e.data;
      if (n === "$" || n === "$!" || n === "$?") {
        if (t === 0) return e;
        t--;
      } else n === "/$" && t++;
    }
    e = e.previousSibling;
  }
  return null;
}
var an = Math.random().toString(36).slice(2), Fe = "__reactFiber$" + an, Bn = "__reactProps$" + an, Qe = "__reactContainer$" + an, gu = "__reactEvents$" + an, td = "__reactListeners$" + an, nd = "__reactHandles$" + an;
function St(e) {
  var t = e[Fe];
  if (t) return t;
  for (var n = e.parentNode; n; ) {
    if (t = n[Qe] || n[Fe]) {
      if (n = t.alternate, t.child !== null || n !== null && n.child !== null) for (e = mi(e); e !== null; ) {
        if (n = e[Fe]) return n;
        e = mi(e);
      }
      return t;
    }
    e = n, n = e.parentNode;
  }
  return null;
}
function bn(e) {
  return e = e[Fe] || e[Qe], !e || e.tag !== 5 && e.tag !== 6 && e.tag !== 13 && e.tag !== 3 ? null : e;
}
function $t(e) {
  if (e.tag === 5 || e.tag === 6) return e.stateNode;
  throw Error(g(33));
}
function il(e) {
  return e[Bn] || null;
}
var wu = [], Vt = -1;
function pt(e) {
  return { current: e };
}
function F(e) {
  0 > Vt || (e.current = wu[Vt], wu[Vt] = null, Vt--);
}
function O(e, t) {
  Vt++, wu[Vt] = e.current, e.current = t;
}
var ft = {}, re = pt(ft), ce = pt(!1), Pt = ft;
function en(e, t) {
  var n = e.type.contextTypes;
  if (!n) return ft;
  var r = e.stateNode;
  if (r && r.__reactInternalMemoizedUnmaskedChildContext === t) return r.__reactInternalMemoizedMaskedChildContext;
  var l = {}, u;
  for (u in n) l[u] = t[u];
  return r && (e = e.stateNode, e.__reactInternalMemoizedUnmaskedChildContext = t, e.__reactInternalMemoizedMaskedChildContext = l), l;
}
function fe(e) {
  return e = e.childContextTypes, e != null;
}
function Vr() {
  F(ce), F(re);
}
function hi(e, t, n) {
  if (re.current !== ft) throw Error(g(168));
  O(re, t), O(ce, n);
}
function ea(e, t, n) {
  var r = e.stateNode;
  if (t = t.childContextTypes, typeof r.getChildContext != "function") return n;
  r = r.getChildContext();
  for (var l in r) if (!(l in t)) throw Error(g(108, Ac(e) || "Unknown", l));
  return $({}, n, r);
}
function Hr(e) {
  return e = (e = e.stateNode) && e.__reactInternalMemoizedMergedChildContext || ft, Pt = re.current, O(re, e), O(ce, ce.current), !0;
}
function vi(e, t, n) {
  var r = e.stateNode;
  if (!r) throw Error(g(169));
  n ? (e = ea(e, t, Pt), r.__reactInternalMemoizedMergedChildContext = e, F(ce), F(re), O(re, e)) : F(ce), O(ce, n);
}
var $e = null, sl = !1, Ul = !1;
function ta(e) {
  $e === null ? $e = [e] : $e.push(e);
}
function rd(e) {
  sl = !0, ta(e);
}
function mt() {
  if (!Ul && $e !== null) {
    Ul = !0;
    var e = 0, t = I;
    try {
      var n = $e;
      for (I = 1; e < n.length; e++) {
        var r = n[e];
        do
          r = r(!0);
        while (r !== null);
      }
      $e = null, sl = !1;
    } catch (l) {
      throw $e !== null && ($e = $e.slice(e + 1)), Ps(Ju, mt), l;
    } finally {
      I = t, Ul = !1;
    }
  }
  return null;
}
var Ht = [], Bt = 0, Br = null, Wr = 0, we = [], Se = 0, Nt = null, Ve = 1, He = "";
function gt(e, t) {
  Ht[Bt++] = Wr, Ht[Bt++] = Br, Br = e, Wr = t;
}
function na(e, t, n) {
  we[Se++] = Ve, we[Se++] = He, we[Se++] = Nt, Nt = e;
  var r = Ve;
  e = He;
  var l = 32 - Re(r) - 1;
  r &= ~(1 << l), n += 1;
  var u = 32 - Re(t) + l;
  if (30 < u) {
    var o = l - l % 5;
    u = (r & (1 << o) - 1).toString(32), r >>= o, l -= o, Ve = 1 << 32 - Re(t) + l | n << l | r, He = u + e;
  } else Ve = 1 << u | n << l | r, He = e;
}
function oo(e) {
  e.return !== null && (gt(e, 1), na(e, 1, 0));
}
function io(e) {
  for (; e === Br; ) Br = Ht[--Bt], Ht[Bt] = null, Wr = Ht[--Bt], Ht[Bt] = null;
  for (; e === Nt; ) Nt = we[--Se], we[Se] = null, He = we[--Se], we[Se] = null, Ve = we[--Se], we[Se] = null;
}
var he = null, me = null, j = !1, Le = null;
function ra(e, t) {
  var n = ke(5, null, null, 0);
  n.elementType = "DELETED", n.stateNode = t, n.return = e, t = e.deletions, t === null ? (e.deletions = [n], e.flags |= 16) : t.push(n);
}
function yi(e, t) {
  switch (e.tag) {
    case 5:
      var n = e.type;
      return t = t.nodeType !== 1 || n.toLowerCase() !== t.nodeName.toLowerCase() ? null : t, t !== null ? (e.stateNode = t, he = e, me = ut(t.firstChild), !0) : !1;
    case 6:
      return t = e.pendingProps === "" || t.nodeType !== 3 ? null : t, t !== null ? (e.stateNode = t, he = e, me = null, !0) : !1;
    case 13:
      return t = t.nodeType !== 8 ? null : t, t !== null ? (n = Nt !== null ? { id: Ve, overflow: He } : null, e.memoizedState = { dehydrated: t, treeContext: n, retryLane: 1073741824 }, n = ke(18, null, null, 0), n.stateNode = t, n.return = e, e.child = n, he = e, me = null, !0) : !1;
    default:
      return !1;
  }
}
function Su(e) {
  return (e.mode & 1) !== 0 && (e.flags & 128) === 0;
}
function ku(e) {
  if (j) {
    var t = me;
    if (t) {
      var n = t;
      if (!yi(e, t)) {
        if (Su(e)) throw Error(g(418));
        t = ut(n.nextSibling);
        var r = he;
        t && yi(e, t) ? ra(r, n) : (e.flags = e.flags & -4097 | 2, j = !1, he = e);
      }
    } else {
      if (Su(e)) throw Error(g(418));
      e.flags = e.flags & -4097 | 2, j = !1, he = e;
    }
  }
}
function gi(e) {
  for (e = e.return; e !== null && e.tag !== 5 && e.tag !== 3 && e.tag !== 13; ) e = e.return;
  he = e;
}
function mr(e) {
  if (e !== he) return !1;
  if (!j) return gi(e), j = !0, !1;
  var t;
  if ((t = e.tag !== 3) && !(t = e.tag !== 5) && (t = e.type, t = t !== "head" && t !== "body" && !vu(e.type, e.memoizedProps)), t && (t = me)) {
    if (Su(e)) throw la(), Error(g(418));
    for (; t; ) ra(e, t), t = ut(t.nextSibling);
  }
  if (gi(e), e.tag === 13) {
    if (e = e.memoizedState, e = e !== null ? e.dehydrated : null, !e) throw Error(g(317));
    e: {
      for (e = e.nextSibling, t = 0; e; ) {
        if (e.nodeType === 8) {
          var n = e.data;
          if (n === "/$") {
            if (t === 0) {
              me = ut(e.nextSibling);
              break e;
            }
            t--;
          } else n !== "$" && n !== "$!" && n !== "$?" || t++;
        }
        e = e.nextSibling;
      }
      me = null;
    }
  } else me = he ? ut(e.stateNode.nextSibling) : null;
  return !0;
}
function la() {
  for (var e = me; e; ) e = ut(e.nextSibling);
}
function tn() {
  me = he = null, j = !1;
}
function so(e) {
  Le === null ? Le = [e] : Le.push(e);
}
var ld = Xe.ReactCurrentBatchConfig;
function yn(e, t, n) {
  if (e = n.ref, e !== null && typeof e != "function" && typeof e != "object") {
    if (n._owner) {
      if (n = n._owner, n) {
        if (n.tag !== 1) throw Error(g(309));
        var r = n.stateNode;
      }
      if (!r) throw Error(g(147, e));
      var l = r, u = "" + e;
      return t !== null && t.ref !== null && typeof t.ref == "function" && t.ref._stringRef === u ? t.ref : (t = function(o) {
        var i = l.refs;
        o === null ? delete i[u] : i[u] = o;
      }, t._stringRef = u, t);
    }
    if (typeof e != "string") throw Error(g(284));
    if (!n._owner) throw Error(g(290, e));
  }
  return e;
}
function hr(e, t) {
  throw e = Object.prototype.toString.call(t), Error(g(31, e === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : e));
}
function wi(e) {
  var t = e._init;
  return t(e._payload);
}
function ua(e) {
  function t(f, a) {
    if (e) {
      var d = f.deletions;
      d === null ? (f.deletions = [a], f.flags |= 16) : d.push(a);
    }
  }
  function n(f, a) {
    if (!e) return null;
    for (; a !== null; ) t(f, a), a = a.sibling;
    return null;
  }
  function r(f, a) {
    for (f = /* @__PURE__ */ new Map(); a !== null; ) a.key !== null ? f.set(a.key, a) : f.set(a.index, a), a = a.sibling;
    return f;
  }
  function l(f, a) {
    return f = at(f, a), f.index = 0, f.sibling = null, f;
  }
  function u(f, a, d) {
    return f.index = d, e ? (d = f.alternate, d !== null ? (d = d.index, d < a ? (f.flags |= 2, a) : d) : (f.flags |= 2, a)) : (f.flags |= 1048576, a);
  }
  function o(f) {
    return e && f.alternate === null && (f.flags |= 2), f;
  }
  function i(f, a, d, y) {
    return a === null || a.tag !== 6 ? (a = Ql(d, f.mode, y), a.return = f, a) : (a = l(a, d), a.return = f, a);
  }
  function s(f, a, d, y) {
    var k = d.type;
    return k === Ft ? h(f, a, d.props.children, y, d.key) : a !== null && (a.elementType === k || typeof k == "object" && k !== null && k.$$typeof === Ze && wi(k) === a.type) ? (y = l(a, d.props), y.ref = yn(f, a, d), y.return = f, y) : (y = Rr(d.type, d.key, d.props, null, f.mode, y), y.ref = yn(f, a, d), y.return = f, y);
  }
  function c(f, a, d, y) {
    return a === null || a.tag !== 4 || a.stateNode.containerInfo !== d.containerInfo || a.stateNode.implementation !== d.implementation ? (a = Kl(d, f.mode, y), a.return = f, a) : (a = l(a, d.children || []), a.return = f, a);
  }
  function h(f, a, d, y, k) {
    return a === null || a.tag !== 7 ? (a = _t(d, f.mode, y, k), a.return = f, a) : (a = l(a, d), a.return = f, a);
  }
  function m(f, a, d) {
    if (typeof a == "string" && a !== "" || typeof a == "number") return a = Ql("" + a, f.mode, d), a.return = f, a;
    if (typeof a == "object" && a !== null) {
      switch (a.$$typeof) {
        case lr:
          return d = Rr(a.type, a.key, a.props, null, f.mode, d), d.ref = yn(f, null, a), d.return = f, d;
        case Dt:
          return a = Kl(a, f.mode, d), a.return = f, a;
        case Ze:
          var y = a._init;
          return m(f, y(a._payload), d);
      }
      if (kn(a) || dn(a)) return a = _t(a, f.mode, d, null), a.return = f, a;
      hr(f, a);
    }
    return null;
  }
  function p(f, a, d, y) {
    var k = a !== null ? a.key : null;
    if (typeof d == "string" && d !== "" || typeof d == "number") return k !== null ? null : i(f, a, "" + d, y);
    if (typeof d == "object" && d !== null) {
      switch (d.$$typeof) {
        case lr:
          return d.key === k ? s(f, a, d, y) : null;
        case Dt:
          return d.key === k ? c(f, a, d, y) : null;
        case Ze:
          return k = d._init, p(
            f,
            a,
            k(d._payload),
            y
          );
      }
      if (kn(d) || dn(d)) return k !== null ? null : h(f, a, d, y, null);
      hr(f, d);
    }
    return null;
  }
  function S(f, a, d, y, k) {
    if (typeof y == "string" && y !== "" || typeof y == "number") return f = f.get(d) || null, i(a, f, "" + y, k);
    if (typeof y == "object" && y !== null) {
      switch (y.$$typeof) {
        case lr:
          return f = f.get(y.key === null ? d : y.key) || null, s(a, f, y, k);
        case Dt:
          return f = f.get(y.key === null ? d : y.key) || null, c(a, f, y, k);
        case Ze:
          var _ = y._init;
          return S(f, a, d, _(y._payload), k);
      }
      if (kn(y) || dn(y)) return f = f.get(d) || null, h(a, f, y, k, null);
      hr(a, y);
    }
    return null;
  }
  function v(f, a, d, y) {
    for (var k = null, _ = null, x = a, P = a = 0, H = null; x !== null && P < d.length; P++) {
      x.index > P ? (H = x, x = null) : H = x.sibling;
      var R = p(f, x, d[P], y);
      if (R === null) {
        x === null && (x = H);
        break;
      }
      e && x && R.alternate === null && t(f, x), a = u(R, a, P), _ === null ? k = R : _.sibling = R, _ = R, x = H;
    }
    if (P === d.length) return n(f, x), j && gt(f, P), k;
    if (x === null) {
      for (; P < d.length; P++) x = m(f, d[P], y), x !== null && (a = u(x, a, P), _ === null ? k = x : _.sibling = x, _ = x);
      return j && gt(f, P), k;
    }
    for (x = r(f, x); P < d.length; P++) H = S(x, f, P, d[P], y), H !== null && (e && H.alternate !== null && x.delete(H.key === null ? P : H.key), a = u(H, a, P), _ === null ? k = H : _.sibling = H, _ = H);
    return e && x.forEach(function(xe) {
      return t(f, xe);
    }), j && gt(f, P), k;
  }
  function w(f, a, d, y) {
    var k = dn(d);
    if (typeof k != "function") throw Error(g(150));
    if (d = k.call(d), d == null) throw Error(g(151));
    for (var _ = k = null, x = a, P = a = 0, H = null, R = d.next(); x !== null && !R.done; P++, R = d.next()) {
      x.index > P ? (H = x, x = null) : H = x.sibling;
      var xe = p(f, x, R.value, y);
      if (xe === null) {
        x === null && (x = H);
        break;
      }
      e && x && xe.alternate === null && t(f, x), a = u(xe, a, P), _ === null ? k = xe : _.sibling = xe, _ = xe, x = H;
    }
    if (R.done) return n(
      f,
      x
    ), j && gt(f, P), k;
    if (x === null) {
      for (; !R.done; P++, R = d.next()) R = m(f, R.value, y), R !== null && (a = u(R, a, P), _ === null ? k = R : _.sibling = R, _ = R);
      return j && gt(f, P), k;
    }
    for (x = r(f, x); !R.done; P++, R = d.next()) R = S(x, f, P, R.value, y), R !== null && (e && R.alternate !== null && x.delete(R.key === null ? P : R.key), a = u(R, a, P), _ === null ? k = R : _.sibling = R, _ = R);
    return e && x.forEach(function(cn) {
      return t(f, cn);
    }), j && gt(f, P), k;
  }
  function L(f, a, d, y) {
    if (typeof d == "object" && d !== null && d.type === Ft && d.key === null && (d = d.props.children), typeof d == "object" && d !== null) {
      switch (d.$$typeof) {
        case lr:
          e: {
            for (var k = d.key, _ = a; _ !== null; ) {
              if (_.key === k) {
                if (k = d.type, k === Ft) {
                  if (_.tag === 7) {
                    n(f, _.sibling), a = l(_, d.props.children), a.return = f, f = a;
                    break e;
                  }
                } else if (_.elementType === k || typeof k == "object" && k !== null && k.$$typeof === Ze && wi(k) === _.type) {
                  n(f, _.sibling), a = l(_, d.props), a.ref = yn(f, _, d), a.return = f, f = a;
                  break e;
                }
                n(f, _);
                break;
              } else t(f, _);
              _ = _.sibling;
            }
            d.type === Ft ? (a = _t(d.props.children, f.mode, y, d.key), a.return = f, f = a) : (y = Rr(d.type, d.key, d.props, null, f.mode, y), y.ref = yn(f, a, d), y.return = f, f = y);
          }
          return o(f);
        case Dt:
          e: {
            for (_ = d.key; a !== null; ) {
              if (a.key === _) if (a.tag === 4 && a.stateNode.containerInfo === d.containerInfo && a.stateNode.implementation === d.implementation) {
                n(f, a.sibling), a = l(a, d.children || []), a.return = f, f = a;
                break e;
              } else {
                n(f, a);
                break;
              }
              else t(f, a);
              a = a.sibling;
            }
            a = Kl(d, f.mode, y), a.return = f, f = a;
          }
          return o(f);
        case Ze:
          return _ = d._init, L(f, a, _(d._payload), y);
      }
      if (kn(d)) return v(f, a, d, y);
      if (dn(d)) return w(f, a, d, y);
      hr(f, d);
    }
    return typeof d == "string" && d !== "" || typeof d == "number" ? (d = "" + d, a !== null && a.tag === 6 ? (n(f, a.sibling), a = l(a, d), a.return = f, f = a) : (n(f, a), a = Ql(d, f.mode, y), a.return = f, f = a), o(f)) : n(f, a);
  }
  return L;
}
var nn = ua(!0), oa = ua(!1), Qr = pt(null), Kr = null, Wt = null, ao = null;
function co() {
  ao = Wt = Kr = null;
}
function fo(e) {
  var t = Qr.current;
  F(Qr), e._currentValue = t;
}
function Eu(e, t, n) {
  for (; e !== null; ) {
    var r = e.alternate;
    if ((e.childLanes & t) !== t ? (e.childLanes |= t, r !== null && (r.childLanes |= t)) : r !== null && (r.childLanes & t) !== t && (r.childLanes |= t), e === n) break;
    e = e.return;
  }
}
function Jt(e, t) {
  Kr = e, ao = Wt = null, e = e.dependencies, e !== null && e.firstContext !== null && (e.lanes & t && (ae = !0), e.firstContext = null);
}
function Ce(e) {
  var t = e._currentValue;
  if (ao !== e) if (e = { context: e, memoizedValue: t, next: null }, Wt === null) {
    if (Kr === null) throw Error(g(308));
    Wt = e, Kr.dependencies = { lanes: 0, firstContext: e };
  } else Wt = Wt.next = e;
  return t;
}
var kt = null;
function po(e) {
  kt === null ? kt = [e] : kt.push(e);
}
function ia(e, t, n, r) {
  var l = t.interleaved;
  return l === null ? (n.next = n, po(t)) : (n.next = l.next, l.next = n), t.interleaved = n, Ke(e, r);
}
function Ke(e, t) {
  e.lanes |= t;
  var n = e.alternate;
  for (n !== null && (n.lanes |= t), n = e, e = e.return; e !== null; ) e.childLanes |= t, n = e.alternate, n !== null && (n.childLanes |= t), n = e, e = e.return;
  return n.tag === 3 ? n.stateNode : null;
}
var Je = !1;
function mo(e) {
  e.updateQueue = { baseState: e.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
}
function sa(e, t) {
  e = e.updateQueue, t.updateQueue === e && (t.updateQueue = { baseState: e.baseState, firstBaseUpdate: e.firstBaseUpdate, lastBaseUpdate: e.lastBaseUpdate, shared: e.shared, effects: e.effects });
}
function Be(e, t) {
  return { eventTime: e, lane: t, tag: 0, payload: null, callback: null, next: null };
}
function ot(e, t, n) {
  var r = e.updateQueue;
  if (r === null) return null;
  if (r = r.shared, M & 2) {
    var l = r.pending;
    return l === null ? t.next = t : (t.next = l.next, l.next = t), r.pending = t, Ke(e, n);
  }
  return l = r.interleaved, l === null ? (t.next = t, po(r)) : (t.next = l.next, l.next = t), r.interleaved = t, Ke(e, n);
}
function xr(e, t, n) {
  if (t = t.updateQueue, t !== null && (t = t.shared, (n & 4194240) !== 0)) {
    var r = t.lanes;
    r &= e.pendingLanes, n |= r, t.lanes = n, qu(e, n);
  }
}
function Si(e, t) {
  var n = e.updateQueue, r = e.alternate;
  if (r !== null && (r = r.updateQueue, n === r)) {
    var l = null, u = null;
    if (n = n.firstBaseUpdate, n !== null) {
      do {
        var o = { eventTime: n.eventTime, lane: n.lane, tag: n.tag, payload: n.payload, callback: n.callback, next: null };
        u === null ? l = u = o : u = u.next = o, n = n.next;
      } while (n !== null);
      u === null ? l = u = t : u = u.next = t;
    } else l = u = t;
    n = { baseState: r.baseState, firstBaseUpdate: l, lastBaseUpdate: u, shared: r.shared, effects: r.effects }, e.updateQueue = n;
    return;
  }
  e = n.lastBaseUpdate, e === null ? n.firstBaseUpdate = t : e.next = t, n.lastBaseUpdate = t;
}
function Yr(e, t, n, r) {
  var l = e.updateQueue;
  Je = !1;
  var u = l.firstBaseUpdate, o = l.lastBaseUpdate, i = l.shared.pending;
  if (i !== null) {
    l.shared.pending = null;
    var s = i, c = s.next;
    s.next = null, o === null ? u = c : o.next = c, o = s;
    var h = e.alternate;
    h !== null && (h = h.updateQueue, i = h.lastBaseUpdate, i !== o && (i === null ? h.firstBaseUpdate = c : i.next = c, h.lastBaseUpdate = s));
  }
  if (u !== null) {
    var m = l.baseState;
    o = 0, h = c = s = null, i = u;
    do {
      var p = i.lane, S = i.eventTime;
      if ((r & p) === p) {
        h !== null && (h = h.next = {
          eventTime: S,
          lane: 0,
          tag: i.tag,
          payload: i.payload,
          callback: i.callback,
          next: null
        });
        e: {
          var v = e, w = i;
          switch (p = t, S = n, w.tag) {
            case 1:
              if (v = w.payload, typeof v == "function") {
                m = v.call(S, m, p);
                break e;
              }
              m = v;
              break e;
            case 3:
              v.flags = v.flags & -65537 | 128;
            case 0:
              if (v = w.payload, p = typeof v == "function" ? v.call(S, m, p) : v, p == null) break e;
              m = $({}, m, p);
              break e;
            case 2:
              Je = !0;
          }
        }
        i.callback !== null && i.lane !== 0 && (e.flags |= 64, p = l.effects, p === null ? l.effects = [i] : p.push(i));
      } else S = { eventTime: S, lane: p, tag: i.tag, payload: i.payload, callback: i.callback, next: null }, h === null ? (c = h = S, s = m) : h = h.next = S, o |= p;
      if (i = i.next, i === null) {
        if (i = l.shared.pending, i === null) break;
        p = i, i = p.next, p.next = null, l.lastBaseUpdate = p, l.shared.pending = null;
      }
    } while (!0);
    if (h === null && (s = m), l.baseState = s, l.firstBaseUpdate = c, l.lastBaseUpdate = h, t = l.shared.interleaved, t !== null) {
      l = t;
      do
        o |= l.lane, l = l.next;
      while (l !== t);
    } else u === null && (l.shared.lanes = 0);
    zt |= o, e.lanes = o, e.memoizedState = m;
  }
}
function ki(e, t, n) {
  if (e = t.effects, t.effects = null, e !== null) for (t = 0; t < e.length; t++) {
    var r = e[t], l = r.callback;
    if (l !== null) {
      if (r.callback = null, r = n, typeof l != "function") throw Error(g(191, l));
      l.call(r);
    }
  }
}
var er = {}, Ue = pt(er), Wn = pt(er), Qn = pt(er);
function Et(e) {
  if (e === er) throw Error(g(174));
  return e;
}
function ho(e, t) {
  switch (O(Qn, t), O(Wn, e), O(Ue, er), e = t.nodeType, e) {
    case 9:
    case 11:
      t = (t = t.documentElement) ? t.namespaceURI : nu(null, "");
      break;
    default:
      e = e === 8 ? t.parentNode : t, t = e.namespaceURI || null, e = e.tagName, t = nu(t, e);
  }
  F(Ue), O(Ue, t);
}
function rn() {
  F(Ue), F(Wn), F(Qn);
}
function aa(e) {
  Et(Qn.current);
  var t = Et(Ue.current), n = nu(t, e.type);
  t !== n && (O(Wn, e), O(Ue, n));
}
function vo(e) {
  Wn.current === e && (F(Ue), F(Wn));
}
var U = pt(0);
function Xr(e) {
  for (var t = e; t !== null; ) {
    if (t.tag === 13) {
      var n = t.memoizedState;
      if (n !== null && (n = n.dehydrated, n === null || n.data === "$?" || n.data === "$!")) return t;
    } else if (t.tag === 19 && t.memoizedProps.revealOrder !== void 0) {
      if (t.flags & 128) return t;
    } else if (t.child !== null) {
      t.child.return = t, t = t.child;
      continue;
    }
    if (t === e) break;
    for (; t.sibling === null; ) {
      if (t.return === null || t.return === e) return null;
      t = t.return;
    }
    t.sibling.return = t.return, t = t.sibling;
  }
  return null;
}
var Al = [];
function yo() {
  for (var e = 0; e < Al.length; e++) Al[e]._workInProgressVersionPrimary = null;
  Al.length = 0;
}
var Pr = Xe.ReactCurrentDispatcher, $l = Xe.ReactCurrentBatchConfig, Tt = 0, A = null, K = null, G = null, Gr = !1, zn = !1, Kn = 0, ud = 0;
function ee() {
  throw Error(g(321));
}
function go(e, t) {
  if (t === null) return !1;
  for (var n = 0; n < t.length && n < e.length; n++) if (!Ie(e[n], t[n])) return !1;
  return !0;
}
function wo(e, t, n, r, l, u) {
  if (Tt = u, A = t, t.memoizedState = null, t.updateQueue = null, t.lanes = 0, Pr.current = e === null || e.memoizedState === null ? ad : cd, e = n(r, l), zn) {
    u = 0;
    do {
      if (zn = !1, Kn = 0, 25 <= u) throw Error(g(301));
      u += 1, G = K = null, t.updateQueue = null, Pr.current = fd, e = n(r, l);
    } while (zn);
  }
  if (Pr.current = Zr, t = K !== null && K.next !== null, Tt = 0, G = K = A = null, Gr = !1, t) throw Error(g(300));
  return e;
}
function So() {
  var e = Kn !== 0;
  return Kn = 0, e;
}
function De() {
  var e = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
  return G === null ? A.memoizedState = G = e : G = G.next = e, G;
}
function _e() {
  if (K === null) {
    var e = A.alternate;
    e = e !== null ? e.memoizedState : null;
  } else e = K.next;
  var t = G === null ? A.memoizedState : G.next;
  if (t !== null) G = t, K = e;
  else {
    if (e === null) throw Error(g(310));
    K = e, e = { memoizedState: K.memoizedState, baseState: K.baseState, baseQueue: K.baseQueue, queue: K.queue, next: null }, G === null ? A.memoizedState = G = e : G = G.next = e;
  }
  return G;
}
function Yn(e, t) {
  return typeof t == "function" ? t(e) : t;
}
function Vl(e) {
  var t = _e(), n = t.queue;
  if (n === null) throw Error(g(311));
  n.lastRenderedReducer = e;
  var r = K, l = r.baseQueue, u = n.pending;
  if (u !== null) {
    if (l !== null) {
      var o = l.next;
      l.next = u.next, u.next = o;
    }
    r.baseQueue = l = u, n.pending = null;
  }
  if (l !== null) {
    u = l.next, r = r.baseState;
    var i = o = null, s = null, c = u;
    do {
      var h = c.lane;
      if ((Tt & h) === h) s !== null && (s = s.next = { lane: 0, action: c.action, hasEagerState: c.hasEagerState, eagerState: c.eagerState, next: null }), r = c.hasEagerState ? c.eagerState : e(r, c.action);
      else {
        var m = {
          lane: h,
          action: c.action,
          hasEagerState: c.hasEagerState,
          eagerState: c.eagerState,
          next: null
        };
        s === null ? (i = s = m, o = r) : s = s.next = m, A.lanes |= h, zt |= h;
      }
      c = c.next;
    } while (c !== null && c !== u);
    s === null ? o = r : s.next = i, Ie(r, t.memoizedState) || (ae = !0), t.memoizedState = r, t.baseState = o, t.baseQueue = s, n.lastRenderedState = r;
  }
  if (e = n.interleaved, e !== null) {
    l = e;
    do
      u = l.lane, A.lanes |= u, zt |= u, l = l.next;
    while (l !== e);
  } else l === null && (n.lanes = 0);
  return [t.memoizedState, n.dispatch];
}
function Hl(e) {
  var t = _e(), n = t.queue;
  if (n === null) throw Error(g(311));
  n.lastRenderedReducer = e;
  var r = n.dispatch, l = n.pending, u = t.memoizedState;
  if (l !== null) {
    n.pending = null;
    var o = l = l.next;
    do
      u = e(u, o.action), o = o.next;
    while (o !== l);
    Ie(u, t.memoizedState) || (ae = !0), t.memoizedState = u, t.baseQueue === null && (t.baseState = u), n.lastRenderedState = u;
  }
  return [u, r];
}
function ca() {
}
function fa(e, t) {
  var n = A, r = _e(), l = t(), u = !Ie(r.memoizedState, l);
  if (u && (r.memoizedState = l, ae = !0), r = r.queue, ko(ma.bind(null, n, r, e), [e]), r.getSnapshot !== t || u || G !== null && G.memoizedState.tag & 1) {
    if (n.flags |= 2048, Xn(9, pa.bind(null, n, r, l, t), void 0, null), Z === null) throw Error(g(349));
    Tt & 30 || da(n, t, l);
  }
  return l;
}
function da(e, t, n) {
  e.flags |= 16384, e = { getSnapshot: t, value: n }, t = A.updateQueue, t === null ? (t = { lastEffect: null, stores: null }, A.updateQueue = t, t.stores = [e]) : (n = t.stores, n === null ? t.stores = [e] : n.push(e));
}
function pa(e, t, n, r) {
  t.value = n, t.getSnapshot = r, ha(t) && va(e);
}
function ma(e, t, n) {
  return n(function() {
    ha(t) && va(e);
  });
}
function ha(e) {
  var t = e.getSnapshot;
  e = e.value;
  try {
    var n = t();
    return !Ie(e, n);
  } catch {
    return !0;
  }
}
function va(e) {
  var t = Ke(e, 1);
  t !== null && Me(t, e, 1, -1);
}
function Ei(e) {
  var t = De();
  return typeof e == "function" && (e = e()), t.memoizedState = t.baseState = e, e = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: Yn, lastRenderedState: e }, t.queue = e, e = e.dispatch = sd.bind(null, A, e), [t.memoizedState, e];
}
function Xn(e, t, n, r) {
  return e = { tag: e, create: t, destroy: n, deps: r, next: null }, t = A.updateQueue, t === null ? (t = { lastEffect: null, stores: null }, A.updateQueue = t, t.lastEffect = e.next = e) : (n = t.lastEffect, n === null ? t.lastEffect = e.next = e : (r = n.next, n.next = e, e.next = r, t.lastEffect = e)), e;
}
function ya() {
  return _e().memoizedState;
}
function Nr(e, t, n, r) {
  var l = De();
  A.flags |= e, l.memoizedState = Xn(1 | t, n, void 0, r === void 0 ? null : r);
}
function al(e, t, n, r) {
  var l = _e();
  r = r === void 0 ? null : r;
  var u = void 0;
  if (K !== null) {
    var o = K.memoizedState;
    if (u = o.destroy, r !== null && go(r, o.deps)) {
      l.memoizedState = Xn(t, n, u, r);
      return;
    }
  }
  A.flags |= e, l.memoizedState = Xn(1 | t, n, u, r);
}
function Ci(e, t) {
  return Nr(8390656, 8, e, t);
}
function ko(e, t) {
  return al(2048, 8, e, t);
}
function ga(e, t) {
  return al(4, 2, e, t);
}
function wa(e, t) {
  return al(4, 4, e, t);
}
function Sa(e, t) {
  if (typeof t == "function") return e = e(), t(e), function() {
    t(null);
  };
  if (t != null) return e = e(), t.current = e, function() {
    t.current = null;
  };
}
function ka(e, t, n) {
  return n = n != null ? n.concat([e]) : null, al(4, 4, Sa.bind(null, t, e), n);
}
function Eo() {
}
function Ea(e, t) {
  var n = _e();
  t = t === void 0 ? null : t;
  var r = n.memoizedState;
  return r !== null && t !== null && go(t, r[1]) ? r[0] : (n.memoizedState = [e, t], e);
}
function Ca(e, t) {
  var n = _e();
  t = t === void 0 ? null : t;
  var r = n.memoizedState;
  return r !== null && t !== null && go(t, r[1]) ? r[0] : (e = e(), n.memoizedState = [e, t], e);
}
function _a(e, t, n) {
  return Tt & 21 ? (Ie(n, t) || (n = zs(), A.lanes |= n, zt |= n, e.baseState = !0), t) : (e.baseState && (e.baseState = !1, ae = !0), e.memoizedState = n);
}
function od(e, t) {
  var n = I;
  I = n !== 0 && 4 > n ? n : 4, e(!0);
  var r = $l.transition;
  $l.transition = {};
  try {
    e(!1), t();
  } finally {
    I = n, $l.transition = r;
  }
}
function xa() {
  return _e().memoizedState;
}
function id(e, t, n) {
  var r = st(e);
  if (n = { lane: r, action: n, hasEagerState: !1, eagerState: null, next: null }, Pa(e)) Na(t, n);
  else if (n = ia(e, t, n, r), n !== null) {
    var l = ue();
    Me(n, e, r, l), Ta(n, t, r);
  }
}
function sd(e, t, n) {
  var r = st(e), l = { lane: r, action: n, hasEagerState: !1, eagerState: null, next: null };
  if (Pa(e)) Na(t, l);
  else {
    var u = e.alternate;
    if (e.lanes === 0 && (u === null || u.lanes === 0) && (u = t.lastRenderedReducer, u !== null)) try {
      var o = t.lastRenderedState, i = u(o, n);
      if (l.hasEagerState = !0, l.eagerState = i, Ie(i, o)) {
        var s = t.interleaved;
        s === null ? (l.next = l, po(t)) : (l.next = s.next, s.next = l), t.interleaved = l;
        return;
      }
    } catch {
    } finally {
    }
    n = ia(e, t, l, r), n !== null && (l = ue(), Me(n, e, r, l), Ta(n, t, r));
  }
}
function Pa(e) {
  var t = e.alternate;
  return e === A || t !== null && t === A;
}
function Na(e, t) {
  zn = Gr = !0;
  var n = e.pending;
  n === null ? t.next = t : (t.next = n.next, n.next = t), e.pending = t;
}
function Ta(e, t, n) {
  if (n & 4194240) {
    var r = t.lanes;
    r &= e.pendingLanes, n |= r, t.lanes = n, qu(e, n);
  }
}
var Zr = { readContext: Ce, useCallback: ee, useContext: ee, useEffect: ee, useImperativeHandle: ee, useInsertionEffect: ee, useLayoutEffect: ee, useMemo: ee, useReducer: ee, useRef: ee, useState: ee, useDebugValue: ee, useDeferredValue: ee, useTransition: ee, useMutableSource: ee, useSyncExternalStore: ee, useId: ee, unstable_isNewReconciler: !1 }, ad = { readContext: Ce, useCallback: function(e, t) {
  return De().memoizedState = [e, t === void 0 ? null : t], e;
}, useContext: Ce, useEffect: Ci, useImperativeHandle: function(e, t, n) {
  return n = n != null ? n.concat([e]) : null, Nr(
    4194308,
    4,
    Sa.bind(null, t, e),
    n
  );
}, useLayoutEffect: function(e, t) {
  return Nr(4194308, 4, e, t);
}, useInsertionEffect: function(e, t) {
  return Nr(4, 2, e, t);
}, useMemo: function(e, t) {
  var n = De();
  return t = t === void 0 ? null : t, e = e(), n.memoizedState = [e, t], e;
}, useReducer: function(e, t, n) {
  var r = De();
  return t = n !== void 0 ? n(t) : t, r.memoizedState = r.baseState = t, e = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: e, lastRenderedState: t }, r.queue = e, e = e.dispatch = id.bind(null, A, e), [r.memoizedState, e];
}, useRef: function(e) {
  var t = De();
  return e = { current: e }, t.memoizedState = e;
}, useState: Ei, useDebugValue: Eo, useDeferredValue: function(e) {
  return De().memoizedState = e;
}, useTransition: function() {
  var e = Ei(!1), t = e[0];
  return e = od.bind(null, e[1]), De().memoizedState = e, [t, e];
}, useMutableSource: function() {
}, useSyncExternalStore: function(e, t, n) {
  var r = A, l = De();
  if (j) {
    if (n === void 0) throw Error(g(407));
    n = n();
  } else {
    if (n = t(), Z === null) throw Error(g(349));
    Tt & 30 || da(r, t, n);
  }
  l.memoizedState = n;
  var u = { value: n, getSnapshot: t };
  return l.queue = u, Ci(ma.bind(
    null,
    r,
    u,
    e
  ), [e]), r.flags |= 2048, Xn(9, pa.bind(null, r, u, n, t), void 0, null), n;
}, useId: function() {
  var e = De(), t = Z.identifierPrefix;
  if (j) {
    var n = He, r = Ve;
    n = (r & ~(1 << 32 - Re(r) - 1)).toString(32) + n, t = ":" + t + "R" + n, n = Kn++, 0 < n && (t += "H" + n.toString(32)), t += ":";
  } else n = ud++, t = ":" + t + "r" + n.toString(32) + ":";
  return e.memoizedState = t;
}, unstable_isNewReconciler: !1 }, cd = {
  readContext: Ce,
  useCallback: Ea,
  useContext: Ce,
  useEffect: ko,
  useImperativeHandle: ka,
  useInsertionEffect: ga,
  useLayoutEffect: wa,
  useMemo: Ca,
  useReducer: Vl,
  useRef: ya,
  useState: function() {
    return Vl(Yn);
  },
  useDebugValue: Eo,
  useDeferredValue: function(e) {
    var t = _e();
    return _a(t, K.memoizedState, e);
  },
  useTransition: function() {
    var e = Vl(Yn)[0], t = _e().memoizedState;
    return [e, t];
  },
  useMutableSource: ca,
  useSyncExternalStore: fa,
  useId: xa,
  unstable_isNewReconciler: !1
}, fd = { readContext: Ce, useCallback: Ea, useContext: Ce, useEffect: ko, useImperativeHandle: ka, useInsertionEffect: ga, useLayoutEffect: wa, useMemo: Ca, useReducer: Hl, useRef: ya, useState: function() {
  return Hl(Yn);
}, useDebugValue: Eo, useDeferredValue: function(e) {
  var t = _e();
  return K === null ? t.memoizedState = e : _a(t, K.memoizedState, e);
}, useTransition: function() {
  var e = Hl(Yn)[0], t = _e().memoizedState;
  return [e, t];
}, useMutableSource: ca, useSyncExternalStore: fa, useId: xa, unstable_isNewReconciler: !1 };
function Te(e, t) {
  if (e && e.defaultProps) {
    t = $({}, t), e = e.defaultProps;
    for (var n in e) t[n] === void 0 && (t[n] = e[n]);
    return t;
  }
  return t;
}
function Cu(e, t, n, r) {
  t = e.memoizedState, n = n(r, t), n = n == null ? t : $({}, t, n), e.memoizedState = n, e.lanes === 0 && (e.updateQueue.baseState = n);
}
var cl = { isMounted: function(e) {
  return (e = e._reactInternals) ? Mt(e) === e : !1;
}, enqueueSetState: function(e, t, n) {
  e = e._reactInternals;
  var r = ue(), l = st(e), u = Be(r, l);
  u.payload = t, n != null && (u.callback = n), t = ot(e, u, l), t !== null && (Me(t, e, l, r), xr(t, e, l));
}, enqueueReplaceState: function(e, t, n) {
  e = e._reactInternals;
  var r = ue(), l = st(e), u = Be(r, l);
  u.tag = 1, u.payload = t, n != null && (u.callback = n), t = ot(e, u, l), t !== null && (Me(t, e, l, r), xr(t, e, l));
}, enqueueForceUpdate: function(e, t) {
  e = e._reactInternals;
  var n = ue(), r = st(e), l = Be(n, r);
  l.tag = 2, t != null && (l.callback = t), t = ot(e, l, r), t !== null && (Me(t, e, r, n), xr(t, e, r));
} };
function _i(e, t, n, r, l, u, o) {
  return e = e.stateNode, typeof e.shouldComponentUpdate == "function" ? e.shouldComponentUpdate(r, u, o) : t.prototype && t.prototype.isPureReactComponent ? !$n(n, r) || !$n(l, u) : !0;
}
function za(e, t, n) {
  var r = !1, l = ft, u = t.contextType;
  return typeof u == "object" && u !== null ? u = Ce(u) : (l = fe(t) ? Pt : re.current, r = t.contextTypes, u = (r = r != null) ? en(e, l) : ft), t = new t(n, u), e.memoizedState = t.state !== null && t.state !== void 0 ? t.state : null, t.updater = cl, e.stateNode = t, t._reactInternals = e, r && (e = e.stateNode, e.__reactInternalMemoizedUnmaskedChildContext = l, e.__reactInternalMemoizedMaskedChildContext = u), t;
}
function xi(e, t, n, r) {
  e = t.state, typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps(n, r), typeof t.UNSAFE_componentWillReceiveProps == "function" && t.UNSAFE_componentWillReceiveProps(n, r), t.state !== e && cl.enqueueReplaceState(t, t.state, null);
}
function _u(e, t, n, r) {
  var l = e.stateNode;
  l.props = n, l.state = e.memoizedState, l.refs = {}, mo(e);
  var u = t.contextType;
  typeof u == "object" && u !== null ? l.context = Ce(u) : (u = fe(t) ? Pt : re.current, l.context = en(e, u)), l.state = e.memoizedState, u = t.getDerivedStateFromProps, typeof u == "function" && (Cu(e, t, u, n), l.state = e.memoizedState), typeof t.getDerivedStateFromProps == "function" || typeof l.getSnapshotBeforeUpdate == "function" || typeof l.UNSAFE_componentWillMount != "function" && typeof l.componentWillMount != "function" || (t = l.state, typeof l.componentWillMount == "function" && l.componentWillMount(), typeof l.UNSAFE_componentWillMount == "function" && l.UNSAFE_componentWillMount(), t !== l.state && cl.enqueueReplaceState(l, l.state, null), Yr(e, n, l, r), l.state = e.memoizedState), typeof l.componentDidMount == "function" && (e.flags |= 4194308);
}
function ln(e, t) {
  try {
    var n = "", r = t;
    do
      n += Uc(r), r = r.return;
    while (r);
    var l = n;
  } catch (u) {
    l = \`
Error generating stack: \` + u.message + \`
\` + u.stack;
  }
  return { value: e, source: t, stack: l, digest: null };
}
function Bl(e, t, n) {
  return { value: e, source: null, stack: n ?? null, digest: t ?? null };
}
function xu(e, t) {
  try {
    console.error(t.value);
  } catch (n) {
    setTimeout(function() {
      throw n;
    });
  }
}
var dd = typeof WeakMap == "function" ? WeakMap : Map;
function La(e, t, n) {
  n = Be(-1, n), n.tag = 3, n.payload = { element: null };
  var r = t.value;
  return n.callback = function() {
    qr || (qr = !0, Du = r), xu(e, t);
  }, n;
}
function Ra(e, t, n) {
  n = Be(-1, n), n.tag = 3;
  var r = e.type.getDerivedStateFromError;
  if (typeof r == "function") {
    var l = t.value;
    n.payload = function() {
      return r(l);
    }, n.callback = function() {
      xu(e, t);
    };
  }
  var u = e.stateNode;
  return u !== null && typeof u.componentDidCatch == "function" && (n.callback = function() {
    xu(e, t), typeof r != "function" && (it === null ? it = /* @__PURE__ */ new Set([this]) : it.add(this));
    var o = t.stack;
    this.componentDidCatch(t.value, { componentStack: o !== null ? o : "" });
  }), n;
}
function Pi(e, t, n) {
  var r = e.pingCache;
  if (r === null) {
    r = e.pingCache = new dd();
    var l = /* @__PURE__ */ new Set();
    r.set(t, l);
  } else l = r.get(t), l === void 0 && (l = /* @__PURE__ */ new Set(), r.set(t, l));
  l.has(n) || (l.add(n), e = Pd.bind(null, e, t, n), t.then(e, e));
}
function Ni(e) {
  do {
    var t;
    if ((t = e.tag === 13) && (t = e.memoizedState, t = t !== null ? t.dehydrated !== null : !0), t) return e;
    e = e.return;
  } while (e !== null);
  return null;
}
function Ti(e, t, n, r, l) {
  return e.mode & 1 ? (e.flags |= 65536, e.lanes = l, e) : (e === t ? e.flags |= 65536 : (e.flags |= 128, n.flags |= 131072, n.flags &= -52805, n.tag === 1 && (n.alternate === null ? n.tag = 17 : (t = Be(-1, 1), t.tag = 2, ot(n, t, 1))), n.lanes |= 1), e);
}
var pd = Xe.ReactCurrentOwner, ae = !1;
function le(e, t, n, r) {
  t.child = e === null ? oa(t, null, n, r) : nn(t, e.child, n, r);
}
function zi(e, t, n, r, l) {
  n = n.render;
  var u = t.ref;
  return Jt(t, l), r = wo(e, t, n, r, u, l), n = So(), e !== null && !ae ? (t.updateQueue = e.updateQueue, t.flags &= -2053, e.lanes &= ~l, Ye(e, t, l)) : (j && n && oo(t), t.flags |= 1, le(e, t, r, l), t.child);
}
function Li(e, t, n, r, l) {
  if (e === null) {
    var u = n.type;
    return typeof u == "function" && !Lo(u) && u.defaultProps === void 0 && n.compare === null && n.defaultProps === void 0 ? (t.tag = 15, t.type = u, Ma(e, t, u, r, l)) : (e = Rr(n.type, null, r, t, t.mode, l), e.ref = t.ref, e.return = t, t.child = e);
  }
  if (u = e.child, !(e.lanes & l)) {
    var o = u.memoizedProps;
    if (n = n.compare, n = n !== null ? n : $n, n(o, r) && e.ref === t.ref) return Ye(e, t, l);
  }
  return t.flags |= 1, e = at(u, r), e.ref = t.ref, e.return = t, t.child = e;
}
function Ma(e, t, n, r, l) {
  if (e !== null) {
    var u = e.memoizedProps;
    if ($n(u, r) && e.ref === t.ref) if (ae = !1, t.pendingProps = r = u, (e.lanes & l) !== 0) e.flags & 131072 && (ae = !0);
    else return t.lanes = e.lanes, Ye(e, t, l);
  }
  return Pu(e, t, n, r, l);
}
function Ia(e, t, n) {
  var r = t.pendingProps, l = r.children, u = e !== null ? e.memoizedState : null;
  if (r.mode === "hidden") if (!(t.mode & 1)) t.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, O(Kt, pe), pe |= n;
  else {
    if (!(n & 1073741824)) return e = u !== null ? u.baseLanes | n : n, t.lanes = t.childLanes = 1073741824, t.memoizedState = { baseLanes: e, cachePool: null, transitions: null }, t.updateQueue = null, O(Kt, pe), pe |= e, null;
    t.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, r = u !== null ? u.baseLanes : n, O(Kt, pe), pe |= r;
  }
  else u !== null ? (r = u.baseLanes | n, t.memoizedState = null) : r = n, O(Kt, pe), pe |= r;
  return le(e, t, l, n), t.child;
}
function Oa(e, t) {
  var n = t.ref;
  (e === null && n !== null || e !== null && e.ref !== n) && (t.flags |= 512, t.flags |= 2097152);
}
function Pu(e, t, n, r, l) {
  var u = fe(n) ? Pt : re.current;
  return u = en(t, u), Jt(t, l), n = wo(e, t, n, r, u, l), r = So(), e !== null && !ae ? (t.updateQueue = e.updateQueue, t.flags &= -2053, e.lanes &= ~l, Ye(e, t, l)) : (j && r && oo(t), t.flags |= 1, le(e, t, n, l), t.child);
}
function Ri(e, t, n, r, l) {
  if (fe(n)) {
    var u = !0;
    Hr(t);
  } else u = !1;
  if (Jt(t, l), t.stateNode === null) Tr(e, t), za(t, n, r), _u(t, n, r, l), r = !0;
  else if (e === null) {
    var o = t.stateNode, i = t.memoizedProps;
    o.props = i;
    var s = o.context, c = n.contextType;
    typeof c == "object" && c !== null ? c = Ce(c) : (c = fe(n) ? Pt : re.current, c = en(t, c));
    var h = n.getDerivedStateFromProps, m = typeof h == "function" || typeof o.getSnapshotBeforeUpdate == "function";
    m || typeof o.UNSAFE_componentWillReceiveProps != "function" && typeof o.componentWillReceiveProps != "function" || (i !== r || s !== c) && xi(t, o, r, c), Je = !1;
    var p = t.memoizedState;
    o.state = p, Yr(t, r, o, l), s = t.memoizedState, i !== r || p !== s || ce.current || Je ? (typeof h == "function" && (Cu(t, n, h, r), s = t.memoizedState), (i = Je || _i(t, n, i, r, p, s, c)) ? (m || typeof o.UNSAFE_componentWillMount != "function" && typeof o.componentWillMount != "function" || (typeof o.componentWillMount == "function" && o.componentWillMount(), typeof o.UNSAFE_componentWillMount == "function" && o.UNSAFE_componentWillMount()), typeof o.componentDidMount == "function" && (t.flags |= 4194308)) : (typeof o.componentDidMount == "function" && (t.flags |= 4194308), t.memoizedProps = r, t.memoizedState = s), o.props = r, o.state = s, o.context = c, r = i) : (typeof o.componentDidMount == "function" && (t.flags |= 4194308), r = !1);
  } else {
    o = t.stateNode, sa(e, t), i = t.memoizedProps, c = t.type === t.elementType ? i : Te(t.type, i), o.props = c, m = t.pendingProps, p = o.context, s = n.contextType, typeof s == "object" && s !== null ? s = Ce(s) : (s = fe(n) ? Pt : re.current, s = en(t, s));
    var S = n.getDerivedStateFromProps;
    (h = typeof S == "function" || typeof o.getSnapshotBeforeUpdate == "function") || typeof o.UNSAFE_componentWillReceiveProps != "function" && typeof o.componentWillReceiveProps != "function" || (i !== m || p !== s) && xi(t, o, r, s), Je = !1, p = t.memoizedState, o.state = p, Yr(t, r, o, l);
    var v = t.memoizedState;
    i !== m || p !== v || ce.current || Je ? (typeof S == "function" && (Cu(t, n, S, r), v = t.memoizedState), (c = Je || _i(t, n, c, r, p, v, s) || !1) ? (h || typeof o.UNSAFE_componentWillUpdate != "function" && typeof o.componentWillUpdate != "function" || (typeof o.componentWillUpdate == "function" && o.componentWillUpdate(r, v, s), typeof o.UNSAFE_componentWillUpdate == "function" && o.UNSAFE_componentWillUpdate(r, v, s)), typeof o.componentDidUpdate == "function" && (t.flags |= 4), typeof o.getSnapshotBeforeUpdate == "function" && (t.flags |= 1024)) : (typeof o.componentDidUpdate != "function" || i === e.memoizedProps && p === e.memoizedState || (t.flags |= 4), typeof o.getSnapshotBeforeUpdate != "function" || i === e.memoizedProps && p === e.memoizedState || (t.flags |= 1024), t.memoizedProps = r, t.memoizedState = v), o.props = r, o.state = v, o.context = s, r = c) : (typeof o.componentDidUpdate != "function" || i === e.memoizedProps && p === e.memoizedState || (t.flags |= 4), typeof o.getSnapshotBeforeUpdate != "function" || i === e.memoizedProps && p === e.memoizedState || (t.flags |= 1024), r = !1);
  }
  return Nu(e, t, n, r, u, l);
}
function Nu(e, t, n, r, l, u) {
  Oa(e, t);
  var o = (t.flags & 128) !== 0;
  if (!r && !o) return l && vi(t, n, !1), Ye(e, t, u);
  r = t.stateNode, pd.current = t;
  var i = o && typeof n.getDerivedStateFromError != "function" ? null : r.render();
  return t.flags |= 1, e !== null && o ? (t.child = nn(t, e.child, null, u), t.child = nn(t, null, i, u)) : le(e, t, i, u), t.memoizedState = r.state, l && vi(t, n, !0), t.child;
}
function Da(e) {
  var t = e.stateNode;
  t.pendingContext ? hi(e, t.pendingContext, t.pendingContext !== t.context) : t.context && hi(e, t.context, !1), ho(e, t.containerInfo);
}
function Mi(e, t, n, r, l) {
  return tn(), so(l), t.flags |= 256, le(e, t, n, r), t.child;
}
var Tu = { dehydrated: null, treeContext: null, retryLane: 0 };
function zu(e) {
  return { baseLanes: e, cachePool: null, transitions: null };
}
function Fa(e, t, n) {
  var r = t.pendingProps, l = U.current, u = !1, o = (t.flags & 128) !== 0, i;
  if ((i = o) || (i = e !== null && e.memoizedState === null ? !1 : (l & 2) !== 0), i ? (u = !0, t.flags &= -129) : (e === null || e.memoizedState !== null) && (l |= 1), O(U, l & 1), e === null)
    return ku(t), e = t.memoizedState, e !== null && (e = e.dehydrated, e !== null) ? (t.mode & 1 ? e.data === "$!" ? t.lanes = 8 : t.lanes = 1073741824 : t.lanes = 1, null) : (o = r.children, e = r.fallback, u ? (r = t.mode, u = t.child, o = { mode: "hidden", children: o }, !(r & 1) && u !== null ? (u.childLanes = 0, u.pendingProps = o) : u = pl(o, r, 0, null), e = _t(e, r, n, null), u.return = t, e.return = t, u.sibling = e, t.child = u, t.child.memoizedState = zu(n), t.memoizedState = Tu, e) : Co(t, o));
  if (l = e.memoizedState, l !== null && (i = l.dehydrated, i !== null)) return md(e, t, o, r, i, l, n);
  if (u) {
    u = r.fallback, o = t.mode, l = e.child, i = l.sibling;
    var s = { mode: "hidden", children: r.children };
    return !(o & 1) && t.child !== l ? (r = t.child, r.childLanes = 0, r.pendingProps = s, t.deletions = null) : (r = at(l, s), r.subtreeFlags = l.subtreeFlags & 14680064), i !== null ? u = at(i, u) : (u = _t(u, o, n, null), u.flags |= 2), u.return = t, r.return = t, r.sibling = u, t.child = r, r = u, u = t.child, o = e.child.memoizedState, o = o === null ? zu(n) : { baseLanes: o.baseLanes | n, cachePool: null, transitions: o.transitions }, u.memoizedState = o, u.childLanes = e.childLanes & ~n, t.memoizedState = Tu, r;
  }
  return u = e.child, e = u.sibling, r = at(u, { mode: "visible", children: r.children }), !(t.mode & 1) && (r.lanes = n), r.return = t, r.sibling = null, e !== null && (n = t.deletions, n === null ? (t.deletions = [e], t.flags |= 16) : n.push(e)), t.child = r, t.memoizedState = null, r;
}
function Co(e, t) {
  return t = pl({ mode: "visible", children: t }, e.mode, 0, null), t.return = e, e.child = t;
}
function vr(e, t, n, r) {
  return r !== null && so(r), nn(t, e.child, null, n), e = Co(t, t.pendingProps.children), e.flags |= 2, t.memoizedState = null, e;
}
function md(e, t, n, r, l, u, o) {
  if (n)
    return t.flags & 256 ? (t.flags &= -257, r = Bl(Error(g(422))), vr(e, t, o, r)) : t.memoizedState !== null ? (t.child = e.child, t.flags |= 128, null) : (u = r.fallback, l = t.mode, r = pl({ mode: "visible", children: r.children }, l, 0, null), u = _t(u, l, o, null), u.flags |= 2, r.return = t, u.return = t, r.sibling = u, t.child = r, t.mode & 1 && nn(t, e.child, null, o), t.child.memoizedState = zu(o), t.memoizedState = Tu, u);
  if (!(t.mode & 1)) return vr(e, t, o, null);
  if (l.data === "$!") {
    if (r = l.nextSibling && l.nextSibling.dataset, r) var i = r.dgst;
    return r = i, u = Error(g(419)), r = Bl(u, r, void 0), vr(e, t, o, r);
  }
  if (i = (o & e.childLanes) !== 0, ae || i) {
    if (r = Z, r !== null) {
      switch (o & -o) {
        case 4:
          l = 2;
          break;
        case 16:
          l = 8;
          break;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
          l = 32;
          break;
        case 536870912:
          l = 268435456;
          break;
        default:
          l = 0;
      }
      l = l & (r.suspendedLanes | o) ? 0 : l, l !== 0 && l !== u.retryLane && (u.retryLane = l, Ke(e, l), Me(r, e, l, -1));
    }
    return zo(), r = Bl(Error(g(421))), vr(e, t, o, r);
  }
  return l.data === "$?" ? (t.flags |= 128, t.child = e.child, t = Nd.bind(null, e), l._reactRetry = t, null) : (e = u.treeContext, me = ut(l.nextSibling), he = t, j = !0, Le = null, e !== null && (we[Se++] = Ve, we[Se++] = He, we[Se++] = Nt, Ve = e.id, He = e.overflow, Nt = t), t = Co(t, r.children), t.flags |= 4096, t);
}
function Ii(e, t, n) {
  e.lanes |= t;
  var r = e.alternate;
  r !== null && (r.lanes |= t), Eu(e.return, t, n);
}
function Wl(e, t, n, r, l) {
  var u = e.memoizedState;
  u === null ? e.memoizedState = { isBackwards: t, rendering: null, renderingStartTime: 0, last: r, tail: n, tailMode: l } : (u.isBackwards = t, u.rendering = null, u.renderingStartTime = 0, u.last = r, u.tail = n, u.tailMode = l);
}
function ja(e, t, n) {
  var r = t.pendingProps, l = r.revealOrder, u = r.tail;
  if (le(e, t, r.children, n), r = U.current, r & 2) r = r & 1 | 2, t.flags |= 128;
  else {
    if (e !== null && e.flags & 128) e: for (e = t.child; e !== null; ) {
      if (e.tag === 13) e.memoizedState !== null && Ii(e, n, t);
      else if (e.tag === 19) Ii(e, n, t);
      else if (e.child !== null) {
        e.child.return = e, e = e.child;
        continue;
      }
      if (e === t) break e;
      for (; e.sibling === null; ) {
        if (e.return === null || e.return === t) break e;
        e = e.return;
      }
      e.sibling.return = e.return, e = e.sibling;
    }
    r &= 1;
  }
  if (O(U, r), !(t.mode & 1)) t.memoizedState = null;
  else switch (l) {
    case "forwards":
      for (n = t.child, l = null; n !== null; ) e = n.alternate, e !== null && Xr(e) === null && (l = n), n = n.sibling;
      n = l, n === null ? (l = t.child, t.child = null) : (l = n.sibling, n.sibling = null), Wl(t, !1, l, n, u);
      break;
    case "backwards":
      for (n = null, l = t.child, t.child = null; l !== null; ) {
        if (e = l.alternate, e !== null && Xr(e) === null) {
          t.child = l;
          break;
        }
        e = l.sibling, l.sibling = n, n = l, l = e;
      }
      Wl(t, !0, n, null, u);
      break;
    case "together":
      Wl(t, !1, null, null, void 0);
      break;
    default:
      t.memoizedState = null;
  }
  return t.child;
}
function Tr(e, t) {
  !(t.mode & 1) && e !== null && (e.alternate = null, t.alternate = null, t.flags |= 2);
}
function Ye(e, t, n) {
  if (e !== null && (t.dependencies = e.dependencies), zt |= t.lanes, !(n & t.childLanes)) return null;
  if (e !== null && t.child !== e.child) throw Error(g(153));
  if (t.child !== null) {
    for (e = t.child, n = at(e, e.pendingProps), t.child = n, n.return = t; e.sibling !== null; ) e = e.sibling, n = n.sibling = at(e, e.pendingProps), n.return = t;
    n.sibling = null;
  }
  return t.child;
}
function hd(e, t, n) {
  switch (t.tag) {
    case 3:
      Da(t), tn();
      break;
    case 5:
      aa(t);
      break;
    case 1:
      fe(t.type) && Hr(t);
      break;
    case 4:
      ho(t, t.stateNode.containerInfo);
      break;
    case 10:
      var r = t.type._context, l = t.memoizedProps.value;
      O(Qr, r._currentValue), r._currentValue = l;
      break;
    case 13:
      if (r = t.memoizedState, r !== null)
        return r.dehydrated !== null ? (O(U, U.current & 1), t.flags |= 128, null) : n & t.child.childLanes ? Fa(e, t, n) : (O(U, U.current & 1), e = Ye(e, t, n), e !== null ? e.sibling : null);
      O(U, U.current & 1);
      break;
    case 19:
      if (r = (n & t.childLanes) !== 0, e.flags & 128) {
        if (r) return ja(e, t, n);
        t.flags |= 128;
      }
      if (l = t.memoizedState, l !== null && (l.rendering = null, l.tail = null, l.lastEffect = null), O(U, U.current), r) break;
      return null;
    case 22:
    case 23:
      return t.lanes = 0, Ia(e, t, n);
  }
  return Ye(e, t, n);
}
var Ua, Lu, Aa, $a;
Ua = function(e, t) {
  for (var n = t.child; n !== null; ) {
    if (n.tag === 5 || n.tag === 6) e.appendChild(n.stateNode);
    else if (n.tag !== 4 && n.child !== null) {
      n.child.return = n, n = n.child;
      continue;
    }
    if (n === t) break;
    for (; n.sibling === null; ) {
      if (n.return === null || n.return === t) return;
      n = n.return;
    }
    n.sibling.return = n.return, n = n.sibling;
  }
};
Lu = function() {
};
Aa = function(e, t, n, r) {
  var l = e.memoizedProps;
  if (l !== r) {
    e = t.stateNode, Et(Ue.current);
    var u = null;
    switch (n) {
      case "input":
        l = ql(e, l), r = ql(e, r), u = [];
        break;
      case "select":
        l = $({}, l, { value: void 0 }), r = $({}, r, { value: void 0 }), u = [];
        break;
      case "textarea":
        l = tu(e, l), r = tu(e, r), u = [];
        break;
      default:
        typeof l.onClick != "function" && typeof r.onClick == "function" && (e.onclick = $r);
    }
    ru(n, r);
    var o;
    n = null;
    for (c in l) if (!r.hasOwnProperty(c) && l.hasOwnProperty(c) && l[c] != null) if (c === "style") {
      var i = l[c];
      for (o in i) i.hasOwnProperty(o) && (n || (n = {}), n[o] = "");
    } else c !== "dangerouslySetInnerHTML" && c !== "children" && c !== "suppressContentEditableWarning" && c !== "suppressHydrationWarning" && c !== "autoFocus" && (In.hasOwnProperty(c) ? u || (u = []) : (u = u || []).push(c, null));
    for (c in r) {
      var s = r[c];
      if (i = l != null ? l[c] : void 0, r.hasOwnProperty(c) && s !== i && (s != null || i != null)) if (c === "style") if (i) {
        for (o in i) !i.hasOwnProperty(o) || s && s.hasOwnProperty(o) || (n || (n = {}), n[o] = "");
        for (o in s) s.hasOwnProperty(o) && i[o] !== s[o] && (n || (n = {}), n[o] = s[o]);
      } else n || (u || (u = []), u.push(
        c,
        n
      )), n = s;
      else c === "dangerouslySetInnerHTML" ? (s = s ? s.__html : void 0, i = i ? i.__html : void 0, s != null && i !== s && (u = u || []).push(c, s)) : c === "children" ? typeof s != "string" && typeof s != "number" || (u = u || []).push(c, "" + s) : c !== "suppressContentEditableWarning" && c !== "suppressHydrationWarning" && (In.hasOwnProperty(c) ? (s != null && c === "onScroll" && D("scroll", e), u || i === s || (u = [])) : (u = u || []).push(c, s));
    }
    n && (u = u || []).push("style", n);
    var c = u;
    (t.updateQueue = c) && (t.flags |= 4);
  }
};
$a = function(e, t, n, r) {
  n !== r && (t.flags |= 4);
};
function gn(e, t) {
  if (!j) switch (e.tailMode) {
    case "hidden":
      t = e.tail;
      for (var n = null; t !== null; ) t.alternate !== null && (n = t), t = t.sibling;
      n === null ? e.tail = null : n.sibling = null;
      break;
    case "collapsed":
      n = e.tail;
      for (var r = null; n !== null; ) n.alternate !== null && (r = n), n = n.sibling;
      r === null ? t || e.tail === null ? e.tail = null : e.tail.sibling = null : r.sibling = null;
  }
}
function te(e) {
  var t = e.alternate !== null && e.alternate.child === e.child, n = 0, r = 0;
  if (t) for (var l = e.child; l !== null; ) n |= l.lanes | l.childLanes, r |= l.subtreeFlags & 14680064, r |= l.flags & 14680064, l.return = e, l = l.sibling;
  else for (l = e.child; l !== null; ) n |= l.lanes | l.childLanes, r |= l.subtreeFlags, r |= l.flags, l.return = e, l = l.sibling;
  return e.subtreeFlags |= r, e.childLanes = n, t;
}
function vd(e, t, n) {
  var r = t.pendingProps;
  switch (io(t), t.tag) {
    case 2:
    case 16:
    case 15:
    case 0:
    case 11:
    case 7:
    case 8:
    case 12:
    case 9:
    case 14:
      return te(t), null;
    case 1:
      return fe(t.type) && Vr(), te(t), null;
    case 3:
      return r = t.stateNode, rn(), F(ce), F(re), yo(), r.pendingContext && (r.context = r.pendingContext, r.pendingContext = null), (e === null || e.child === null) && (mr(t) ? t.flags |= 4 : e === null || e.memoizedState.isDehydrated && !(t.flags & 256) || (t.flags |= 1024, Le !== null && (Uu(Le), Le = null))), Lu(e, t), te(t), null;
    case 5:
      vo(t);
      var l = Et(Qn.current);
      if (n = t.type, e !== null && t.stateNode != null) Aa(e, t, n, r, l), e.ref !== t.ref && (t.flags |= 512, t.flags |= 2097152);
      else {
        if (!r) {
          if (t.stateNode === null) throw Error(g(166));
          return te(t), null;
        }
        if (e = Et(Ue.current), mr(t)) {
          r = t.stateNode, n = t.type;
          var u = t.memoizedProps;
          switch (r[Fe] = t, r[Bn] = u, e = (t.mode & 1) !== 0, n) {
            case "dialog":
              D("cancel", r), D("close", r);
              break;
            case "iframe":
            case "object":
            case "embed":
              D("load", r);
              break;
            case "video":
            case "audio":
              for (l = 0; l < Cn.length; l++) D(Cn[l], r);
              break;
            case "source":
              D("error", r);
              break;
            case "img":
            case "image":
            case "link":
              D(
                "error",
                r
              ), D("load", r);
              break;
            case "details":
              D("toggle", r);
              break;
            case "input":
              Ho(r, u), D("invalid", r);
              break;
            case "select":
              r._wrapperState = { wasMultiple: !!u.multiple }, D("invalid", r);
              break;
            case "textarea":
              Wo(r, u), D("invalid", r);
          }
          ru(n, u), l = null;
          for (var o in u) if (u.hasOwnProperty(o)) {
            var i = u[o];
            o === "children" ? typeof i == "string" ? r.textContent !== i && (u.suppressHydrationWarning !== !0 && pr(r.textContent, i, e), l = ["children", i]) : typeof i == "number" && r.textContent !== "" + i && (u.suppressHydrationWarning !== !0 && pr(
              r.textContent,
              i,
              e
            ), l = ["children", "" + i]) : In.hasOwnProperty(o) && i != null && o === "onScroll" && D("scroll", r);
          }
          switch (n) {
            case "input":
              ur(r), Bo(r, u, !0);
              break;
            case "textarea":
              ur(r), Qo(r);
              break;
            case "select":
            case "option":
              break;
            default:
              typeof u.onClick == "function" && (r.onclick = $r);
          }
          r = l, t.updateQueue = r, r !== null && (t.flags |= 4);
        } else {
          o = l.nodeType === 9 ? l : l.ownerDocument, e === "http://www.w3.org/1999/xhtml" && (e = ms(n)), e === "http://www.w3.org/1999/xhtml" ? n === "script" ? (e = o.createElement("div"), e.innerHTML = "<script><\\/script>", e = e.removeChild(e.firstChild)) : typeof r.is == "string" ? e = o.createElement(n, { is: r.is }) : (e = o.createElement(n), n === "select" && (o = e, r.multiple ? o.multiple = !0 : r.size && (o.size = r.size))) : e = o.createElementNS(e, n), e[Fe] = t, e[Bn] = r, Ua(e, t, !1, !1), t.stateNode = e;
          e: {
            switch (o = lu(n, r), n) {
              case "dialog":
                D("cancel", e), D("close", e), l = r;
                break;
              case "iframe":
              case "object":
              case "embed":
                D("load", e), l = r;
                break;
              case "video":
              case "audio":
                for (l = 0; l < Cn.length; l++) D(Cn[l], e);
                l = r;
                break;
              case "source":
                D("error", e), l = r;
                break;
              case "img":
              case "image":
              case "link":
                D(
                  "error",
                  e
                ), D("load", e), l = r;
                break;
              case "details":
                D("toggle", e), l = r;
                break;
              case "input":
                Ho(e, r), l = ql(e, r), D("invalid", e);
                break;
              case "option":
                l = r;
                break;
              case "select":
                e._wrapperState = { wasMultiple: !!r.multiple }, l = $({}, r, { value: void 0 }), D("invalid", e);
                break;
              case "textarea":
                Wo(e, r), l = tu(e, r), D("invalid", e);
                break;
              default:
                l = r;
            }
            ru(n, l), i = l;
            for (u in i) if (i.hasOwnProperty(u)) {
              var s = i[u];
              u === "style" ? ys(e, s) : u === "dangerouslySetInnerHTML" ? (s = s ? s.__html : void 0, s != null && hs(e, s)) : u === "children" ? typeof s == "string" ? (n !== "textarea" || s !== "") && On(e, s) : typeof s == "number" && On(e, "" + s) : u !== "suppressContentEditableWarning" && u !== "suppressHydrationWarning" && u !== "autoFocus" && (In.hasOwnProperty(u) ? s != null && u === "onScroll" && D("scroll", e) : s != null && Ku(e, u, s, o));
            }
            switch (n) {
              case "input":
                ur(e), Bo(e, r, !1);
                break;
              case "textarea":
                ur(e), Qo(e);
                break;
              case "option":
                r.value != null && e.setAttribute("value", "" + ct(r.value));
                break;
              case "select":
                e.multiple = !!r.multiple, u = r.value, u != null ? Yt(e, !!r.multiple, u, !1) : r.defaultValue != null && Yt(
                  e,
                  !!r.multiple,
                  r.defaultValue,
                  !0
                );
                break;
              default:
                typeof l.onClick == "function" && (e.onclick = $r);
            }
            switch (n) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                r = !!r.autoFocus;
                break e;
              case "img":
                r = !0;
                break e;
              default:
                r = !1;
            }
          }
          r && (t.flags |= 4);
        }
        t.ref !== null && (t.flags |= 512, t.flags |= 2097152);
      }
      return te(t), null;
    case 6:
      if (e && t.stateNode != null) $a(e, t, e.memoizedProps, r);
      else {
        if (typeof r != "string" && t.stateNode === null) throw Error(g(166));
        if (n = Et(Qn.current), Et(Ue.current), mr(t)) {
          if (r = t.stateNode, n = t.memoizedProps, r[Fe] = t, (u = r.nodeValue !== n) && (e = he, e !== null)) switch (e.tag) {
            case 3:
              pr(r.nodeValue, n, (e.mode & 1) !== 0);
              break;
            case 5:
              e.memoizedProps.suppressHydrationWarning !== !0 && pr(r.nodeValue, n, (e.mode & 1) !== 0);
          }
          u && (t.flags |= 4);
        } else r = (n.nodeType === 9 ? n : n.ownerDocument).createTextNode(r), r[Fe] = t, t.stateNode = r;
      }
      return te(t), null;
    case 13:
      if (F(U), r = t.memoizedState, e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null) {
        if (j && me !== null && t.mode & 1 && !(t.flags & 128)) la(), tn(), t.flags |= 98560, u = !1;
        else if (u = mr(t), r !== null && r.dehydrated !== null) {
          if (e === null) {
            if (!u) throw Error(g(318));
            if (u = t.memoizedState, u = u !== null ? u.dehydrated : null, !u) throw Error(g(317));
            u[Fe] = t;
          } else tn(), !(t.flags & 128) && (t.memoizedState = null), t.flags |= 4;
          te(t), u = !1;
        } else Le !== null && (Uu(Le), Le = null), u = !0;
        if (!u) return t.flags & 65536 ? t : null;
      }
      return t.flags & 128 ? (t.lanes = n, t) : (r = r !== null, r !== (e !== null && e.memoizedState !== null) && r && (t.child.flags |= 8192, t.mode & 1 && (e === null || U.current & 1 ? Y === 0 && (Y = 3) : zo())), t.updateQueue !== null && (t.flags |= 4), te(t), null);
    case 4:
      return rn(), Lu(e, t), e === null && Vn(t.stateNode.containerInfo), te(t), null;
    case 10:
      return fo(t.type._context), te(t), null;
    case 17:
      return fe(t.type) && Vr(), te(t), null;
    case 19:
      if (F(U), u = t.memoizedState, u === null) return te(t), null;
      if (r = (t.flags & 128) !== 0, o = u.rendering, o === null) if (r) gn(u, !1);
      else {
        if (Y !== 0 || e !== null && e.flags & 128) for (e = t.child; e !== null; ) {
          if (o = Xr(e), o !== null) {
            for (t.flags |= 128, gn(u, !1), r = o.updateQueue, r !== null && (t.updateQueue = r, t.flags |= 4), t.subtreeFlags = 0, r = n, n = t.child; n !== null; ) u = n, e = r, u.flags &= 14680066, o = u.alternate, o === null ? (u.childLanes = 0, u.lanes = e, u.child = null, u.subtreeFlags = 0, u.memoizedProps = null, u.memoizedState = null, u.updateQueue = null, u.dependencies = null, u.stateNode = null) : (u.childLanes = o.childLanes, u.lanes = o.lanes, u.child = o.child, u.subtreeFlags = 0, u.deletions = null, u.memoizedProps = o.memoizedProps, u.memoizedState = o.memoizedState, u.updateQueue = o.updateQueue, u.type = o.type, e = o.dependencies, u.dependencies = e === null ? null : { lanes: e.lanes, firstContext: e.firstContext }), n = n.sibling;
            return O(U, U.current & 1 | 2), t.child;
          }
          e = e.sibling;
        }
        u.tail !== null && W() > un && (t.flags |= 128, r = !0, gn(u, !1), t.lanes = 4194304);
      }
      else {
        if (!r) if (e = Xr(o), e !== null) {
          if (t.flags |= 128, r = !0, n = e.updateQueue, n !== null && (t.updateQueue = n, t.flags |= 4), gn(u, !0), u.tail === null && u.tailMode === "hidden" && !o.alternate && !j) return te(t), null;
        } else 2 * W() - u.renderingStartTime > un && n !== 1073741824 && (t.flags |= 128, r = !0, gn(u, !1), t.lanes = 4194304);
        u.isBackwards ? (o.sibling = t.child, t.child = o) : (n = u.last, n !== null ? n.sibling = o : t.child = o, u.last = o);
      }
      return u.tail !== null ? (t = u.tail, u.rendering = t, u.tail = t.sibling, u.renderingStartTime = W(), t.sibling = null, n = U.current, O(U, r ? n & 1 | 2 : n & 1), t) : (te(t), null);
    case 22:
    case 23:
      return To(), r = t.memoizedState !== null, e !== null && e.memoizedState !== null !== r && (t.flags |= 8192), r && t.mode & 1 ? pe & 1073741824 && (te(t), t.subtreeFlags & 6 && (t.flags |= 8192)) : te(t), null;
    case 24:
      return null;
    case 25:
      return null;
  }
  throw Error(g(156, t.tag));
}
function yd(e, t) {
  switch (io(t), t.tag) {
    case 1:
      return fe(t.type) && Vr(), e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
    case 3:
      return rn(), F(ce), F(re), yo(), e = t.flags, e & 65536 && !(e & 128) ? (t.flags = e & -65537 | 128, t) : null;
    case 5:
      return vo(t), null;
    case 13:
      if (F(U), e = t.memoizedState, e !== null && e.dehydrated !== null) {
        if (t.alternate === null) throw Error(g(340));
        tn();
      }
      return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
    case 19:
      return F(U), null;
    case 4:
      return rn(), null;
    case 10:
      return fo(t.type._context), null;
    case 22:
    case 23:
      return To(), null;
    case 24:
      return null;
    default:
      return null;
  }
}
var yr = !1, ne = !1, gd = typeof WeakSet == "function" ? WeakSet : Set, E = null;
function Qt(e, t) {
  var n = e.ref;
  if (n !== null) if (typeof n == "function") try {
    n(null);
  } catch (r) {
    V(e, t, r);
  }
  else n.current = null;
}
function Ru(e, t, n) {
  try {
    n();
  } catch (r) {
    V(e, t, r);
  }
}
var Oi = !1;
function wd(e, t) {
  if (mu = jr, e = Qs(), uo(e)) {
    if ("selectionStart" in e) var n = { start: e.selectionStart, end: e.selectionEnd };
    else e: {
      n = (n = e.ownerDocument) && n.defaultView || window;
      var r = n.getSelection && n.getSelection();
      if (r && r.rangeCount !== 0) {
        n = r.anchorNode;
        var l = r.anchorOffset, u = r.focusNode;
        r = r.focusOffset;
        try {
          n.nodeType, u.nodeType;
        } catch {
          n = null;
          break e;
        }
        var o = 0, i = -1, s = -1, c = 0, h = 0, m = e, p = null;
        t: for (; ; ) {
          for (var S; m !== n || l !== 0 && m.nodeType !== 3 || (i = o + l), m !== u || r !== 0 && m.nodeType !== 3 || (s = o + r), m.nodeType === 3 && (o += m.nodeValue.length), (S = m.firstChild) !== null; )
            p = m, m = S;
          for (; ; ) {
            if (m === e) break t;
            if (p === n && ++c === l && (i = o), p === u && ++h === r && (s = o), (S = m.nextSibling) !== null) break;
            m = p, p = m.parentNode;
          }
          m = S;
        }
        n = i === -1 || s === -1 ? null : { start: i, end: s };
      } else n = null;
    }
    n = n || { start: 0, end: 0 };
  } else n = null;
  for (hu = { focusedElem: e, selectionRange: n }, jr = !1, E = t; E !== null; ) if (t = E, e = t.child, (t.subtreeFlags & 1028) !== 0 && e !== null) e.return = t, E = e;
  else for (; E !== null; ) {
    t = E;
    try {
      var v = t.alternate;
      if (t.flags & 1024) switch (t.tag) {
        case 0:
        case 11:
        case 15:
          break;
        case 1:
          if (v !== null) {
            var w = v.memoizedProps, L = v.memoizedState, f = t.stateNode, a = f.getSnapshotBeforeUpdate(t.elementType === t.type ? w : Te(t.type, w), L);
            f.__reactInternalSnapshotBeforeUpdate = a;
          }
          break;
        case 3:
          var d = t.stateNode.containerInfo;
          d.nodeType === 1 ? d.textContent = "" : d.nodeType === 9 && d.documentElement && d.removeChild(d.documentElement);
          break;
        case 5:
        case 6:
        case 4:
        case 17:
          break;
        default:
          throw Error(g(163));
      }
    } catch (y) {
      V(t, t.return, y);
    }
    if (e = t.sibling, e !== null) {
      e.return = t.return, E = e;
      break;
    }
    E = t.return;
  }
  return v = Oi, Oi = !1, v;
}
function Ln(e, t, n) {
  var r = t.updateQueue;
  if (r = r !== null ? r.lastEffect : null, r !== null) {
    var l = r = r.next;
    do {
      if ((l.tag & e) === e) {
        var u = l.destroy;
        l.destroy = void 0, u !== void 0 && Ru(t, n, u);
      }
      l = l.next;
    } while (l !== r);
  }
}
function fl(e, t) {
  if (t = t.updateQueue, t = t !== null ? t.lastEffect : null, t !== null) {
    var n = t = t.next;
    do {
      if ((n.tag & e) === e) {
        var r = n.create;
        n.destroy = r();
      }
      n = n.next;
    } while (n !== t);
  }
}
function Mu(e) {
  var t = e.ref;
  if (t !== null) {
    var n = e.stateNode;
    switch (e.tag) {
      case 5:
        e = n;
        break;
      default:
        e = n;
    }
    typeof t == "function" ? t(e) : t.current = e;
  }
}
function Va(e) {
  var t = e.alternate;
  t !== null && (e.alternate = null, Va(t)), e.child = null, e.deletions = null, e.sibling = null, e.tag === 5 && (t = e.stateNode, t !== null && (delete t[Fe], delete t[Bn], delete t[gu], delete t[td], delete t[nd])), e.stateNode = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
}
function Ha(e) {
  return e.tag === 5 || e.tag === 3 || e.tag === 4;
}
function Di(e) {
  e: for (; ; ) {
    for (; e.sibling === null; ) {
      if (e.return === null || Ha(e.return)) return null;
      e = e.return;
    }
    for (e.sibling.return = e.return, e = e.sibling; e.tag !== 5 && e.tag !== 6 && e.tag !== 18; ) {
      if (e.flags & 2 || e.child === null || e.tag === 4) continue e;
      e.child.return = e, e = e.child;
    }
    if (!(e.flags & 2)) return e.stateNode;
  }
}
function Iu(e, t, n) {
  var r = e.tag;
  if (r === 5 || r === 6) e = e.stateNode, t ? n.nodeType === 8 ? n.parentNode.insertBefore(e, t) : n.insertBefore(e, t) : (n.nodeType === 8 ? (t = n.parentNode, t.insertBefore(e, n)) : (t = n, t.appendChild(e)), n = n._reactRootContainer, n != null || t.onclick !== null || (t.onclick = $r));
  else if (r !== 4 && (e = e.child, e !== null)) for (Iu(e, t, n), e = e.sibling; e !== null; ) Iu(e, t, n), e = e.sibling;
}
function Ou(e, t, n) {
  var r = e.tag;
  if (r === 5 || r === 6) e = e.stateNode, t ? n.insertBefore(e, t) : n.appendChild(e);
  else if (r !== 4 && (e = e.child, e !== null)) for (Ou(e, t, n), e = e.sibling; e !== null; ) Ou(e, t, n), e = e.sibling;
}
var J = null, ze = !1;
function Ge(e, t, n) {
  for (n = n.child; n !== null; ) Ba(e, t, n), n = n.sibling;
}
function Ba(e, t, n) {
  if (je && typeof je.onCommitFiberUnmount == "function") try {
    je.onCommitFiberUnmount(rl, n);
  } catch {
  }
  switch (n.tag) {
    case 5:
      ne || Qt(n, t);
    case 6:
      var r = J, l = ze;
      J = null, Ge(e, t, n), J = r, ze = l, J !== null && (ze ? (e = J, n = n.stateNode, e.nodeType === 8 ? e.parentNode.removeChild(n) : e.removeChild(n)) : J.removeChild(n.stateNode));
      break;
    case 18:
      J !== null && (ze ? (e = J, n = n.stateNode, e.nodeType === 8 ? jl(e.parentNode, n) : e.nodeType === 1 && jl(e, n), Un(e)) : jl(J, n.stateNode));
      break;
    case 4:
      r = J, l = ze, J = n.stateNode.containerInfo, ze = !0, Ge(e, t, n), J = r, ze = l;
      break;
    case 0:
    case 11:
    case 14:
    case 15:
      if (!ne && (r = n.updateQueue, r !== null && (r = r.lastEffect, r !== null))) {
        l = r = r.next;
        do {
          var u = l, o = u.destroy;
          u = u.tag, o !== void 0 && (u & 2 || u & 4) && Ru(n, t, o), l = l.next;
        } while (l !== r);
      }
      Ge(e, t, n);
      break;
    case 1:
      if (!ne && (Qt(n, t), r = n.stateNode, typeof r.componentWillUnmount == "function")) try {
        r.props = n.memoizedProps, r.state = n.memoizedState, r.componentWillUnmount();
      } catch (i) {
        V(n, t, i);
      }
      Ge(e, t, n);
      break;
    case 21:
      Ge(e, t, n);
      break;
    case 22:
      n.mode & 1 ? (ne = (r = ne) || n.memoizedState !== null, Ge(e, t, n), ne = r) : Ge(e, t, n);
      break;
    default:
      Ge(e, t, n);
  }
}
function Fi(e) {
  var t = e.updateQueue;
  if (t !== null) {
    e.updateQueue = null;
    var n = e.stateNode;
    n === null && (n = e.stateNode = new gd()), t.forEach(function(r) {
      var l = Td.bind(null, e, r);
      n.has(r) || (n.add(r), r.then(l, l));
    });
  }
}
function Pe(e, t) {
  var n = t.deletions;
  if (n !== null) for (var r = 0; r < n.length; r++) {
    var l = n[r];
    try {
      var u = e, o = t, i = o;
      e: for (; i !== null; ) {
        switch (i.tag) {
          case 5:
            J = i.stateNode, ze = !1;
            break e;
          case 3:
            J = i.stateNode.containerInfo, ze = !0;
            break e;
          case 4:
            J = i.stateNode.containerInfo, ze = !0;
            break e;
        }
        i = i.return;
      }
      if (J === null) throw Error(g(160));
      Ba(u, o, l), J = null, ze = !1;
      var s = l.alternate;
      s !== null && (s.return = null), l.return = null;
    } catch (c) {
      V(l, t, c);
    }
  }
  if (t.subtreeFlags & 12854) for (t = t.child; t !== null; ) Wa(t, e), t = t.sibling;
}
function Wa(e, t) {
  var n = e.alternate, r = e.flags;
  switch (e.tag) {
    case 0:
    case 11:
    case 14:
    case 15:
      if (Pe(t, e), Oe(e), r & 4) {
        try {
          Ln(3, e, e.return), fl(3, e);
        } catch (w) {
          V(e, e.return, w);
        }
        try {
          Ln(5, e, e.return);
        } catch (w) {
          V(e, e.return, w);
        }
      }
      break;
    case 1:
      Pe(t, e), Oe(e), r & 512 && n !== null && Qt(n, n.return);
      break;
    case 5:
      if (Pe(t, e), Oe(e), r & 512 && n !== null && Qt(n, n.return), e.flags & 32) {
        var l = e.stateNode;
        try {
          On(l, "");
        } catch (w) {
          V(e, e.return, w);
        }
      }
      if (r & 4 && (l = e.stateNode, l != null)) {
        var u = e.memoizedProps, o = n !== null ? n.memoizedProps : u, i = e.type, s = e.updateQueue;
        if (e.updateQueue = null, s !== null) try {
          i === "input" && u.type === "radio" && u.name != null && ds(l, u), lu(i, o);
          var c = lu(i, u);
          for (o = 0; o < s.length; o += 2) {
            var h = s[o], m = s[o + 1];
            h === "style" ? ys(l, m) : h === "dangerouslySetInnerHTML" ? hs(l, m) : h === "children" ? On(l, m) : Ku(l, h, m, c);
          }
          switch (i) {
            case "input":
              bl(l, u);
              break;
            case "textarea":
              ps(l, u);
              break;
            case "select":
              var p = l._wrapperState.wasMultiple;
              l._wrapperState.wasMultiple = !!u.multiple;
              var S = u.value;
              S != null ? Yt(l, !!u.multiple, S, !1) : p !== !!u.multiple && (u.defaultValue != null ? Yt(
                l,
                !!u.multiple,
                u.defaultValue,
                !0
              ) : Yt(l, !!u.multiple, u.multiple ? [] : "", !1));
          }
          l[Bn] = u;
        } catch (w) {
          V(e, e.return, w);
        }
      }
      break;
    case 6:
      if (Pe(t, e), Oe(e), r & 4) {
        if (e.stateNode === null) throw Error(g(162));
        l = e.stateNode, u = e.memoizedProps;
        try {
          l.nodeValue = u;
        } catch (w) {
          V(e, e.return, w);
        }
      }
      break;
    case 3:
      if (Pe(t, e), Oe(e), r & 4 && n !== null && n.memoizedState.isDehydrated) try {
        Un(t.containerInfo);
      } catch (w) {
        V(e, e.return, w);
      }
      break;
    case 4:
      Pe(t, e), Oe(e);
      break;
    case 13:
      Pe(t, e), Oe(e), l = e.child, l.flags & 8192 && (u = l.memoizedState !== null, l.stateNode.isHidden = u, !u || l.alternate !== null && l.alternate.memoizedState !== null || (Po = W())), r & 4 && Fi(e);
      break;
    case 22:
      if (h = n !== null && n.memoizedState !== null, e.mode & 1 ? (ne = (c = ne) || h, Pe(t, e), ne = c) : Pe(t, e), Oe(e), r & 8192) {
        if (c = e.memoizedState !== null, (e.stateNode.isHidden = c) && !h && e.mode & 1) for (E = e, h = e.child; h !== null; ) {
          for (m = E = h; E !== null; ) {
            switch (p = E, S = p.child, p.tag) {
              case 0:
              case 11:
              case 14:
              case 15:
                Ln(4, p, p.return);
                break;
              case 1:
                Qt(p, p.return);
                var v = p.stateNode;
                if (typeof v.componentWillUnmount == "function") {
                  r = p, n = p.return;
                  try {
                    t = r, v.props = t.memoizedProps, v.state = t.memoizedState, v.componentWillUnmount();
                  } catch (w) {
                    V(r, n, w);
                  }
                }
                break;
              case 5:
                Qt(p, p.return);
                break;
              case 22:
                if (p.memoizedState !== null) {
                  Ui(m);
                  continue;
                }
            }
            S !== null ? (S.return = p, E = S) : Ui(m);
          }
          h = h.sibling;
        }
        e: for (h = null, m = e; ; ) {
          if (m.tag === 5) {
            if (h === null) {
              h = m;
              try {
                l = m.stateNode, c ? (u = l.style, typeof u.setProperty == "function" ? u.setProperty("display", "none", "important") : u.display = "none") : (i = m.stateNode, s = m.memoizedProps.style, o = s != null && s.hasOwnProperty("display") ? s.display : null, i.style.display = vs("display", o));
              } catch (w) {
                V(e, e.return, w);
              }
            }
          } else if (m.tag === 6) {
            if (h === null) try {
              m.stateNode.nodeValue = c ? "" : m.memoizedProps;
            } catch (w) {
              V(e, e.return, w);
            }
          } else if ((m.tag !== 22 && m.tag !== 23 || m.memoizedState === null || m === e) && m.child !== null) {
            m.child.return = m, m = m.child;
            continue;
          }
          if (m === e) break e;
          for (; m.sibling === null; ) {
            if (m.return === null || m.return === e) break e;
            h === m && (h = null), m = m.return;
          }
          h === m && (h = null), m.sibling.return = m.return, m = m.sibling;
        }
      }
      break;
    case 19:
      Pe(t, e), Oe(e), r & 4 && Fi(e);
      break;
    case 21:
      break;
    default:
      Pe(
        t,
        e
      ), Oe(e);
  }
}
function Oe(e) {
  var t = e.flags;
  if (t & 2) {
    try {
      e: {
        for (var n = e.return; n !== null; ) {
          if (Ha(n)) {
            var r = n;
            break e;
          }
          n = n.return;
        }
        throw Error(g(160));
      }
      switch (r.tag) {
        case 5:
          var l = r.stateNode;
          r.flags & 32 && (On(l, ""), r.flags &= -33);
          var u = Di(e);
          Ou(e, u, l);
          break;
        case 3:
        case 4:
          var o = r.stateNode.containerInfo, i = Di(e);
          Iu(e, i, o);
          break;
        default:
          throw Error(g(161));
      }
    } catch (s) {
      V(e, e.return, s);
    }
    e.flags &= -3;
  }
  t & 4096 && (e.flags &= -4097);
}
function Sd(e, t, n) {
  E = e, Qa(e);
}
function Qa(e, t, n) {
  for (var r = (e.mode & 1) !== 0; E !== null; ) {
    var l = E, u = l.child;
    if (l.tag === 22 && r) {
      var o = l.memoizedState !== null || yr;
      if (!o) {
        var i = l.alternate, s = i !== null && i.memoizedState !== null || ne;
        i = yr;
        var c = ne;
        if (yr = o, (ne = s) && !c) for (E = l; E !== null; ) o = E, s = o.child, o.tag === 22 && o.memoizedState !== null ? Ai(l) : s !== null ? (s.return = o, E = s) : Ai(l);
        for (; u !== null; ) E = u, Qa(u), u = u.sibling;
        E = l, yr = i, ne = c;
      }
      ji(e);
    } else l.subtreeFlags & 8772 && u !== null ? (u.return = l, E = u) : ji(e);
  }
}
function ji(e) {
  for (; E !== null; ) {
    var t = E;
    if (t.flags & 8772) {
      var n = t.alternate;
      try {
        if (t.flags & 8772) switch (t.tag) {
          case 0:
          case 11:
          case 15:
            ne || fl(5, t);
            break;
          case 1:
            var r = t.stateNode;
            if (t.flags & 4 && !ne) if (n === null) r.componentDidMount();
            else {
              var l = t.elementType === t.type ? n.memoizedProps : Te(t.type, n.memoizedProps);
              r.componentDidUpdate(l, n.memoizedState, r.__reactInternalSnapshotBeforeUpdate);
            }
            var u = t.updateQueue;
            u !== null && ki(t, u, r);
            break;
          case 3:
            var o = t.updateQueue;
            if (o !== null) {
              if (n = null, t.child !== null) switch (t.child.tag) {
                case 5:
                  n = t.child.stateNode;
                  break;
                case 1:
                  n = t.child.stateNode;
              }
              ki(t, o, n);
            }
            break;
          case 5:
            var i = t.stateNode;
            if (n === null && t.flags & 4) {
              n = i;
              var s = t.memoizedProps;
              switch (t.type) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  s.autoFocus && n.focus();
                  break;
                case "img":
                  s.src && (n.src = s.src);
              }
            }
            break;
          case 6:
            break;
          case 4:
            break;
          case 12:
            break;
          case 13:
            if (t.memoizedState === null) {
              var c = t.alternate;
              if (c !== null) {
                var h = c.memoizedState;
                if (h !== null) {
                  var m = h.dehydrated;
                  m !== null && Un(m);
                }
              }
            }
            break;
          case 19:
          case 17:
          case 21:
          case 22:
          case 23:
          case 25:
            break;
          default:
            throw Error(g(163));
        }
        ne || t.flags & 512 && Mu(t);
      } catch (p) {
        V(t, t.return, p);
      }
    }
    if (t === e) {
      E = null;
      break;
    }
    if (n = t.sibling, n !== null) {
      n.return = t.return, E = n;
      break;
    }
    E = t.return;
  }
}
function Ui(e) {
  for (; E !== null; ) {
    var t = E;
    if (t === e) {
      E = null;
      break;
    }
    var n = t.sibling;
    if (n !== null) {
      n.return = t.return, E = n;
      break;
    }
    E = t.return;
  }
}
function Ai(e) {
  for (; E !== null; ) {
    var t = E;
    try {
      switch (t.tag) {
        case 0:
        case 11:
        case 15:
          var n = t.return;
          try {
            fl(4, t);
          } catch (s) {
            V(t, n, s);
          }
          break;
        case 1:
          var r = t.stateNode;
          if (typeof r.componentDidMount == "function") {
            var l = t.return;
            try {
              r.componentDidMount();
            } catch (s) {
              V(t, l, s);
            }
          }
          var u = t.return;
          try {
            Mu(t);
          } catch (s) {
            V(t, u, s);
          }
          break;
        case 5:
          var o = t.return;
          try {
            Mu(t);
          } catch (s) {
            V(t, o, s);
          }
      }
    } catch (s) {
      V(t, t.return, s);
    }
    if (t === e) {
      E = null;
      break;
    }
    var i = t.sibling;
    if (i !== null) {
      i.return = t.return, E = i;
      break;
    }
    E = t.return;
  }
}
var kd = Math.ceil, Jr = Xe.ReactCurrentDispatcher, _o = Xe.ReactCurrentOwner, Ee = Xe.ReactCurrentBatchConfig, M = 0, Z = null, Q = null, q = 0, pe = 0, Kt = pt(0), Y = 0, Gn = null, zt = 0, dl = 0, xo = 0, Rn = null, se = null, Po = 0, un = 1 / 0, Ae = null, qr = !1, Du = null, it = null, gr = !1, tt = null, br = 0, Mn = 0, Fu = null, zr = -1, Lr = 0;
function ue() {
  return M & 6 ? W() : zr !== -1 ? zr : zr = W();
}
function st(e) {
  return e.mode & 1 ? M & 2 && q !== 0 ? q & -q : ld.transition !== null ? (Lr === 0 && (Lr = zs()), Lr) : (e = I, e !== 0 || (e = window.event, e = e === void 0 ? 16 : Fs(e.type)), e) : 1;
}
function Me(e, t, n, r) {
  if (50 < Mn) throw Mn = 0, Fu = null, Error(g(185));
  Jn(e, n, r), (!(M & 2) || e !== Z) && (e === Z && (!(M & 2) && (dl |= n), Y === 4 && be(e, q)), de(e, r), n === 1 && M === 0 && !(t.mode & 1) && (un = W() + 500, sl && mt()));
}
function de(e, t) {
  var n = e.callbackNode;
  rf(e, t);
  var r = Fr(e, e === Z ? q : 0);
  if (r === 0) n !== null && Xo(n), e.callbackNode = null, e.callbackPriority = 0;
  else if (t = r & -r, e.callbackPriority !== t) {
    if (n != null && Xo(n), t === 1) e.tag === 0 ? rd($i.bind(null, e)) : ta($i.bind(null, e)), bf(function() {
      !(M & 6) && mt();
    }), n = null;
    else {
      switch (Ls(r)) {
        case 1:
          n = Ju;
          break;
        case 4:
          n = Ns;
          break;
        case 16:
          n = Dr;
          break;
        case 536870912:
          n = Ts;
          break;
        default:
          n = Dr;
      }
      n = ba(n, Ka.bind(null, e));
    }
    e.callbackPriority = t, e.callbackNode = n;
  }
}
function Ka(e, t) {
  if (zr = -1, Lr = 0, M & 6) throw Error(g(327));
  var n = e.callbackNode;
  if (qt() && e.callbackNode !== n) return null;
  var r = Fr(e, e === Z ? q : 0);
  if (r === 0) return null;
  if (r & 30 || r & e.expiredLanes || t) t = el(e, r);
  else {
    t = r;
    var l = M;
    M |= 2;
    var u = Xa();
    (Z !== e || q !== t) && (Ae = null, un = W() + 500, Ct(e, t));
    do
      try {
        _d();
        break;
      } catch (i) {
        Ya(e, i);
      }
    while (!0);
    co(), Jr.current = u, M = l, Q !== null ? t = 0 : (Z = null, q = 0, t = Y);
  }
  if (t !== 0) {
    if (t === 2 && (l = au(e), l !== 0 && (r = l, t = ju(e, l))), t === 1) throw n = Gn, Ct(e, 0), be(e, r), de(e, W()), n;
    if (t === 6) be(e, r);
    else {
      if (l = e.current.alternate, !(r & 30) && !Ed(l) && (t = el(e, r), t === 2 && (u = au(e), u !== 0 && (r = u, t = ju(e, u))), t === 1)) throw n = Gn, Ct(e, 0), be(e, r), de(e, W()), n;
      switch (e.finishedWork = l, e.finishedLanes = r, t) {
        case 0:
        case 1:
          throw Error(g(345));
        case 2:
          wt(e, se, Ae);
          break;
        case 3:
          if (be(e, r), (r & 130023424) === r && (t = Po + 500 - W(), 10 < t)) {
            if (Fr(e, 0) !== 0) break;
            if (l = e.suspendedLanes, (l & r) !== r) {
              ue(), e.pingedLanes |= e.suspendedLanes & l;
              break;
            }
            e.timeoutHandle = yu(wt.bind(null, e, se, Ae), t);
            break;
          }
          wt(e, se, Ae);
          break;
        case 4:
          if (be(e, r), (r & 4194240) === r) break;
          for (t = e.eventTimes, l = -1; 0 < r; ) {
            var o = 31 - Re(r);
            u = 1 << o, o = t[o], o > l && (l = o), r &= ~u;
          }
          if (r = l, r = W() - r, r = (120 > r ? 120 : 480 > r ? 480 : 1080 > r ? 1080 : 1920 > r ? 1920 : 3e3 > r ? 3e3 : 4320 > r ? 4320 : 1960 * kd(r / 1960)) - r, 10 < r) {
            e.timeoutHandle = yu(wt.bind(null, e, se, Ae), r);
            break;
          }
          wt(e, se, Ae);
          break;
        case 5:
          wt(e, se, Ae);
          break;
        default:
          throw Error(g(329));
      }
    }
  }
  return de(e, W()), e.callbackNode === n ? Ka.bind(null, e) : null;
}
function ju(e, t) {
  var n = Rn;
  return e.current.memoizedState.isDehydrated && (Ct(e, t).flags |= 256), e = el(e, t), e !== 2 && (t = se, se = n, t !== null && Uu(t)), e;
}
function Uu(e) {
  se === null ? se = e : se.push.apply(se, e);
}
function Ed(e) {
  for (var t = e; ; ) {
    if (t.flags & 16384) {
      var n = t.updateQueue;
      if (n !== null && (n = n.stores, n !== null)) for (var r = 0; r < n.length; r++) {
        var l = n[r], u = l.getSnapshot;
        l = l.value;
        try {
          if (!Ie(u(), l)) return !1;
        } catch {
          return !1;
        }
      }
    }
    if (n = t.child, t.subtreeFlags & 16384 && n !== null) n.return = t, t = n;
    else {
      if (t === e) break;
      for (; t.sibling === null; ) {
        if (t.return === null || t.return === e) return !0;
        t = t.return;
      }
      t.sibling.return = t.return, t = t.sibling;
    }
  }
  return !0;
}
function be(e, t) {
  for (t &= ~xo, t &= ~dl, e.suspendedLanes |= t, e.pingedLanes &= ~t, e = e.expirationTimes; 0 < t; ) {
    var n = 31 - Re(t), r = 1 << n;
    e[n] = -1, t &= ~r;
  }
}
function $i(e) {
  if (M & 6) throw Error(g(327));
  qt();
  var t = Fr(e, 0);
  if (!(t & 1)) return de(e, W()), null;
  var n = el(e, t);
  if (e.tag !== 0 && n === 2) {
    var r = au(e);
    r !== 0 && (t = r, n = ju(e, r));
  }
  if (n === 1) throw n = Gn, Ct(e, 0), be(e, t), de(e, W()), n;
  if (n === 6) throw Error(g(345));
  return e.finishedWork = e.current.alternate, e.finishedLanes = t, wt(e, se, Ae), de(e, W()), null;
}
function No(e, t) {
  var n = M;
  M |= 1;
  try {
    return e(t);
  } finally {
    M = n, M === 0 && (un = W() + 500, sl && mt());
  }
}
function Lt(e) {
  tt !== null && tt.tag === 0 && !(M & 6) && qt();
  var t = M;
  M |= 1;
  var n = Ee.transition, r = I;
  try {
    if (Ee.transition = null, I = 1, e) return e();
  } finally {
    I = r, Ee.transition = n, M = t, !(M & 6) && mt();
  }
}
function To() {
  pe = Kt.current, F(Kt);
}
function Ct(e, t) {
  e.finishedWork = null, e.finishedLanes = 0;
  var n = e.timeoutHandle;
  if (n !== -1 && (e.timeoutHandle = -1, qf(n)), Q !== null) for (n = Q.return; n !== null; ) {
    var r = n;
    switch (io(r), r.tag) {
      case 1:
        r = r.type.childContextTypes, r != null && Vr();
        break;
      case 3:
        rn(), F(ce), F(re), yo();
        break;
      case 5:
        vo(r);
        break;
      case 4:
        rn();
        break;
      case 13:
        F(U);
        break;
      case 19:
        F(U);
        break;
      case 10:
        fo(r.type._context);
        break;
      case 22:
      case 23:
        To();
    }
    n = n.return;
  }
  if (Z = e, Q = e = at(e.current, null), q = pe = t, Y = 0, Gn = null, xo = dl = zt = 0, se = Rn = null, kt !== null) {
    for (t = 0; t < kt.length; t++) if (n = kt[t], r = n.interleaved, r !== null) {
      n.interleaved = null;
      var l = r.next, u = n.pending;
      if (u !== null) {
        var o = u.next;
        u.next = l, r.next = o;
      }
      n.pending = r;
    }
    kt = null;
  }
  return e;
}
function Ya(e, t) {
  do {
    var n = Q;
    try {
      if (co(), Pr.current = Zr, Gr) {
        for (var r = A.memoizedState; r !== null; ) {
          var l = r.queue;
          l !== null && (l.pending = null), r = r.next;
        }
        Gr = !1;
      }
      if (Tt = 0, G = K = A = null, zn = !1, Kn = 0, _o.current = null, n === null || n.return === null) {
        Y = 1, Gn = t, Q = null;
        break;
      }
      e: {
        var u = e, o = n.return, i = n, s = t;
        if (t = q, i.flags |= 32768, s !== null && typeof s == "object" && typeof s.then == "function") {
          var c = s, h = i, m = h.tag;
          if (!(h.mode & 1) && (m === 0 || m === 11 || m === 15)) {
            var p = h.alternate;
            p ? (h.updateQueue = p.updateQueue, h.memoizedState = p.memoizedState, h.lanes = p.lanes) : (h.updateQueue = null, h.memoizedState = null);
          }
          var S = Ni(o);
          if (S !== null) {
            S.flags &= -257, Ti(S, o, i, u, t), S.mode & 1 && Pi(u, c, t), t = S, s = c;
            var v = t.updateQueue;
            if (v === null) {
              var w = /* @__PURE__ */ new Set();
              w.add(s), t.updateQueue = w;
            } else v.add(s);
            break e;
          } else {
            if (!(t & 1)) {
              Pi(u, c, t), zo();
              break e;
            }
            s = Error(g(426));
          }
        } else if (j && i.mode & 1) {
          var L = Ni(o);
          if (L !== null) {
            !(L.flags & 65536) && (L.flags |= 256), Ti(L, o, i, u, t), so(ln(s, i));
            break e;
          }
        }
        u = s = ln(s, i), Y !== 4 && (Y = 2), Rn === null ? Rn = [u] : Rn.push(u), u = o;
        do {
          switch (u.tag) {
            case 3:
              u.flags |= 65536, t &= -t, u.lanes |= t;
              var f = La(u, s, t);
              Si(u, f);
              break e;
            case 1:
              i = s;
              var a = u.type, d = u.stateNode;
              if (!(u.flags & 128) && (typeof a.getDerivedStateFromError == "function" || d !== null && typeof d.componentDidCatch == "function" && (it === null || !it.has(d)))) {
                u.flags |= 65536, t &= -t, u.lanes |= t;
                var y = Ra(u, i, t);
                Si(u, y);
                break e;
              }
          }
          u = u.return;
        } while (u !== null);
      }
      Za(n);
    } catch (k) {
      t = k, Q === n && n !== null && (Q = n = n.return);
      continue;
    }
    break;
  } while (!0);
}
function Xa() {
  var e = Jr.current;
  return Jr.current = Zr, e === null ? Zr : e;
}
function zo() {
  (Y === 0 || Y === 3 || Y === 2) && (Y = 4), Z === null || !(zt & 268435455) && !(dl & 268435455) || be(Z, q);
}
function el(e, t) {
  var n = M;
  M |= 2;
  var r = Xa();
  (Z !== e || q !== t) && (Ae = null, Ct(e, t));
  do
    try {
      Cd();
      break;
    } catch (l) {
      Ya(e, l);
    }
  while (!0);
  if (co(), M = n, Jr.current = r, Q !== null) throw Error(g(261));
  return Z = null, q = 0, Y;
}
function Cd() {
  for (; Q !== null; ) Ga(Q);
}
function _d() {
  for (; Q !== null && !Xc(); ) Ga(Q);
}
function Ga(e) {
  var t = qa(e.alternate, e, pe);
  e.memoizedProps = e.pendingProps, t === null ? Za(e) : Q = t, _o.current = null;
}
function Za(e) {
  var t = e;
  do {
    var n = t.alternate;
    if (e = t.return, t.flags & 32768) {
      if (n = yd(n, t), n !== null) {
        n.flags &= 32767, Q = n;
        return;
      }
      if (e !== null) e.flags |= 32768, e.subtreeFlags = 0, e.deletions = null;
      else {
        Y = 6, Q = null;
        return;
      }
    } else if (n = vd(n, t, pe), n !== null) {
      Q = n;
      return;
    }
    if (t = t.sibling, t !== null) {
      Q = t;
      return;
    }
    Q = t = e;
  } while (t !== null);
  Y === 0 && (Y = 5);
}
function wt(e, t, n) {
  var r = I, l = Ee.transition;
  try {
    Ee.transition = null, I = 1, xd(e, t, n, r);
  } finally {
    Ee.transition = l, I = r;
  }
  return null;
}
function xd(e, t, n, r) {
  do
    qt();
  while (tt !== null);
  if (M & 6) throw Error(g(327));
  n = e.finishedWork;
  var l = e.finishedLanes;
  if (n === null) return null;
  if (e.finishedWork = null, e.finishedLanes = 0, n === e.current) throw Error(g(177));
  e.callbackNode = null, e.callbackPriority = 0;
  var u = n.lanes | n.childLanes;
  if (lf(e, u), e === Z && (Q = Z = null, q = 0), !(n.subtreeFlags & 2064) && !(n.flags & 2064) || gr || (gr = !0, ba(Dr, function() {
    return qt(), null;
  })), u = (n.flags & 15990) !== 0, n.subtreeFlags & 15990 || u) {
    u = Ee.transition, Ee.transition = null;
    var o = I;
    I = 1;
    var i = M;
    M |= 4, _o.current = null, wd(e, n), Wa(n, e), Qf(hu), jr = !!mu, hu = mu = null, e.current = n, Sd(n), Gc(), M = i, I = o, Ee.transition = u;
  } else e.current = n;
  if (gr && (gr = !1, tt = e, br = l), u = e.pendingLanes, u === 0 && (it = null), qc(n.stateNode), de(e, W()), t !== null) for (r = e.onRecoverableError, n = 0; n < t.length; n++) l = t[n], r(l.value, { componentStack: l.stack, digest: l.digest });
  if (qr) throw qr = !1, e = Du, Du = null, e;
  return br & 1 && e.tag !== 0 && qt(), u = e.pendingLanes, u & 1 ? e === Fu ? Mn++ : (Mn = 0, Fu = e) : Mn = 0, mt(), null;
}
function qt() {
  if (tt !== null) {
    var e = Ls(br), t = Ee.transition, n = I;
    try {
      if (Ee.transition = null, I = 16 > e ? 16 : e, tt === null) var r = !1;
      else {
        if (e = tt, tt = null, br = 0, M & 6) throw Error(g(331));
        var l = M;
        for (M |= 4, E = e.current; E !== null; ) {
          var u = E, o = u.child;
          if (E.flags & 16) {
            var i = u.deletions;
            if (i !== null) {
              for (var s = 0; s < i.length; s++) {
                var c = i[s];
                for (E = c; E !== null; ) {
                  var h = E;
                  switch (h.tag) {
                    case 0:
                    case 11:
                    case 15:
                      Ln(8, h, u);
                  }
                  var m = h.child;
                  if (m !== null) m.return = h, E = m;
                  else for (; E !== null; ) {
                    h = E;
                    var p = h.sibling, S = h.return;
                    if (Va(h), h === c) {
                      E = null;
                      break;
                    }
                    if (p !== null) {
                      p.return = S, E = p;
                      break;
                    }
                    E = S;
                  }
                }
              }
              var v = u.alternate;
              if (v !== null) {
                var w = v.child;
                if (w !== null) {
                  v.child = null;
                  do {
                    var L = w.sibling;
                    w.sibling = null, w = L;
                  } while (w !== null);
                }
              }
              E = u;
            }
          }
          if (u.subtreeFlags & 2064 && o !== null) o.return = u, E = o;
          else e: for (; E !== null; ) {
            if (u = E, u.flags & 2048) switch (u.tag) {
              case 0:
              case 11:
              case 15:
                Ln(9, u, u.return);
            }
            var f = u.sibling;
            if (f !== null) {
              f.return = u.return, E = f;
              break e;
            }
            E = u.return;
          }
        }
        var a = e.current;
        for (E = a; E !== null; ) {
          o = E;
          var d = o.child;
          if (o.subtreeFlags & 2064 && d !== null) d.return = o, E = d;
          else e: for (o = a; E !== null; ) {
            if (i = E, i.flags & 2048) try {
              switch (i.tag) {
                case 0:
                case 11:
                case 15:
                  fl(9, i);
              }
            } catch (k) {
              V(i, i.return, k);
            }
            if (i === o) {
              E = null;
              break e;
            }
            var y = i.sibling;
            if (y !== null) {
              y.return = i.return, E = y;
              break e;
            }
            E = i.return;
          }
        }
        if (M = l, mt(), je && typeof je.onPostCommitFiberRoot == "function") try {
          je.onPostCommitFiberRoot(rl, e);
        } catch {
        }
        r = !0;
      }
      return r;
    } finally {
      I = n, Ee.transition = t;
    }
  }
  return !1;
}
function Vi(e, t, n) {
  t = ln(n, t), t = La(e, t, 1), e = ot(e, t, 1), t = ue(), e !== null && (Jn(e, 1, t), de(e, t));
}
function V(e, t, n) {
  if (e.tag === 3) Vi(e, e, n);
  else for (; t !== null; ) {
    if (t.tag === 3) {
      Vi(t, e, n);
      break;
    } else if (t.tag === 1) {
      var r = t.stateNode;
      if (typeof t.type.getDerivedStateFromError == "function" || typeof r.componentDidCatch == "function" && (it === null || !it.has(r))) {
        e = ln(n, e), e = Ra(t, e, 1), t = ot(t, e, 1), e = ue(), t !== null && (Jn(t, 1, e), de(t, e));
        break;
      }
    }
    t = t.return;
  }
}
function Pd(e, t, n) {
  var r = e.pingCache;
  r !== null && r.delete(t), t = ue(), e.pingedLanes |= e.suspendedLanes & n, Z === e && (q & n) === n && (Y === 4 || Y === 3 && (q & 130023424) === q && 500 > W() - Po ? Ct(e, 0) : xo |= n), de(e, t);
}
function Ja(e, t) {
  t === 0 && (e.mode & 1 ? (t = sr, sr <<= 1, !(sr & 130023424) && (sr = 4194304)) : t = 1);
  var n = ue();
  e = Ke(e, t), e !== null && (Jn(e, t, n), de(e, n));
}
function Nd(e) {
  var t = e.memoizedState, n = 0;
  t !== null && (n = t.retryLane), Ja(e, n);
}
function Td(e, t) {
  var n = 0;
  switch (e.tag) {
    case 13:
      var r = e.stateNode, l = e.memoizedState;
      l !== null && (n = l.retryLane);
      break;
    case 19:
      r = e.stateNode;
      break;
    default:
      throw Error(g(314));
  }
  r !== null && r.delete(t), Ja(e, n);
}
var qa;
qa = function(e, t, n) {
  if (e !== null) if (e.memoizedProps !== t.pendingProps || ce.current) ae = !0;
  else {
    if (!(e.lanes & n) && !(t.flags & 128)) return ae = !1, hd(e, t, n);
    ae = !!(e.flags & 131072);
  }
  else ae = !1, j && t.flags & 1048576 && na(t, Wr, t.index);
  switch (t.lanes = 0, t.tag) {
    case 2:
      var r = t.type;
      Tr(e, t), e = t.pendingProps;
      var l = en(t, re.current);
      Jt(t, n), l = wo(null, t, r, e, l, n);
      var u = So();
      return t.flags |= 1, typeof l == "object" && l !== null && typeof l.render == "function" && l.$$typeof === void 0 ? (t.tag = 1, t.memoizedState = null, t.updateQueue = null, fe(r) ? (u = !0, Hr(t)) : u = !1, t.memoizedState = l.state !== null && l.state !== void 0 ? l.state : null, mo(t), l.updater = cl, t.stateNode = l, l._reactInternals = t, _u(t, r, e, n), t = Nu(null, t, r, !0, u, n)) : (t.tag = 0, j && u && oo(t), le(null, t, l, n), t = t.child), t;
    case 16:
      r = t.elementType;
      e: {
        switch (Tr(e, t), e = t.pendingProps, l = r._init, r = l(r._payload), t.type = r, l = t.tag = Ld(r), e = Te(r, e), l) {
          case 0:
            t = Pu(null, t, r, e, n);
            break e;
          case 1:
            t = Ri(null, t, r, e, n);
            break e;
          case 11:
            t = zi(null, t, r, e, n);
            break e;
          case 14:
            t = Li(null, t, r, Te(r.type, e), n);
            break e;
        }
        throw Error(g(
          306,
          r,
          ""
        ));
      }
      return t;
    case 0:
      return r = t.type, l = t.pendingProps, l = t.elementType === r ? l : Te(r, l), Pu(e, t, r, l, n);
    case 1:
      return r = t.type, l = t.pendingProps, l = t.elementType === r ? l : Te(r, l), Ri(e, t, r, l, n);
    case 3:
      e: {
        if (Da(t), e === null) throw Error(g(387));
        r = t.pendingProps, u = t.memoizedState, l = u.element, sa(e, t), Yr(t, r, null, n);
        var o = t.memoizedState;
        if (r = o.element, u.isDehydrated) if (u = { element: r, isDehydrated: !1, cache: o.cache, pendingSuspenseBoundaries: o.pendingSuspenseBoundaries, transitions: o.transitions }, t.updateQueue.baseState = u, t.memoizedState = u, t.flags & 256) {
          l = ln(Error(g(423)), t), t = Mi(e, t, r, n, l);
          break e;
        } else if (r !== l) {
          l = ln(Error(g(424)), t), t = Mi(e, t, r, n, l);
          break e;
        } else for (me = ut(t.stateNode.containerInfo.firstChild), he = t, j = !0, Le = null, n = oa(t, null, r, n), t.child = n; n; ) n.flags = n.flags & -3 | 4096, n = n.sibling;
        else {
          if (tn(), r === l) {
            t = Ye(e, t, n);
            break e;
          }
          le(e, t, r, n);
        }
        t = t.child;
      }
      return t;
    case 5:
      return aa(t), e === null && ku(t), r = t.type, l = t.pendingProps, u = e !== null ? e.memoizedProps : null, o = l.children, vu(r, l) ? o = null : u !== null && vu(r, u) && (t.flags |= 32), Oa(e, t), le(e, t, o, n), t.child;
    case 6:
      return e === null && ku(t), null;
    case 13:
      return Fa(e, t, n);
    case 4:
      return ho(t, t.stateNode.containerInfo), r = t.pendingProps, e === null ? t.child = nn(t, null, r, n) : le(e, t, r, n), t.child;
    case 11:
      return r = t.type, l = t.pendingProps, l = t.elementType === r ? l : Te(r, l), zi(e, t, r, l, n);
    case 7:
      return le(e, t, t.pendingProps, n), t.child;
    case 8:
      return le(e, t, t.pendingProps.children, n), t.child;
    case 12:
      return le(e, t, t.pendingProps.children, n), t.child;
    case 10:
      e: {
        if (r = t.type._context, l = t.pendingProps, u = t.memoizedProps, o = l.value, O(Qr, r._currentValue), r._currentValue = o, u !== null) if (Ie(u.value, o)) {
          if (u.children === l.children && !ce.current) {
            t = Ye(e, t, n);
            break e;
          }
        } else for (u = t.child, u !== null && (u.return = t); u !== null; ) {
          var i = u.dependencies;
          if (i !== null) {
            o = u.child;
            for (var s = i.firstContext; s !== null; ) {
              if (s.context === r) {
                if (u.tag === 1) {
                  s = Be(-1, n & -n), s.tag = 2;
                  var c = u.updateQueue;
                  if (c !== null) {
                    c = c.shared;
                    var h = c.pending;
                    h === null ? s.next = s : (s.next = h.next, h.next = s), c.pending = s;
                  }
                }
                u.lanes |= n, s = u.alternate, s !== null && (s.lanes |= n), Eu(
                  u.return,
                  n,
                  t
                ), i.lanes |= n;
                break;
              }
              s = s.next;
            }
          } else if (u.tag === 10) o = u.type === t.type ? null : u.child;
          else if (u.tag === 18) {
            if (o = u.return, o === null) throw Error(g(341));
            o.lanes |= n, i = o.alternate, i !== null && (i.lanes |= n), Eu(o, n, t), o = u.sibling;
          } else o = u.child;
          if (o !== null) o.return = u;
          else for (o = u; o !== null; ) {
            if (o === t) {
              o = null;
              break;
            }
            if (u = o.sibling, u !== null) {
              u.return = o.return, o = u;
              break;
            }
            o = o.return;
          }
          u = o;
        }
        le(e, t, l.children, n), t = t.child;
      }
      return t;
    case 9:
      return l = t.type, r = t.pendingProps.children, Jt(t, n), l = Ce(l), r = r(l), t.flags |= 1, le(e, t, r, n), t.child;
    case 14:
      return r = t.type, l = Te(r, t.pendingProps), l = Te(r.type, l), Li(e, t, r, l, n);
    case 15:
      return Ma(e, t, t.type, t.pendingProps, n);
    case 17:
      return r = t.type, l = t.pendingProps, l = t.elementType === r ? l : Te(r, l), Tr(e, t), t.tag = 1, fe(r) ? (e = !0, Hr(t)) : e = !1, Jt(t, n), za(t, r, l), _u(t, r, l, n), Nu(null, t, r, !0, e, n);
    case 19:
      return ja(e, t, n);
    case 22:
      return Ia(e, t, n);
  }
  throw Error(g(156, t.tag));
};
function ba(e, t) {
  return Ps(e, t);
}
function zd(e, t, n, r) {
  this.tag = e, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = r, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
}
function ke(e, t, n, r) {
  return new zd(e, t, n, r);
}
function Lo(e) {
  return e = e.prototype, !(!e || !e.isReactComponent);
}
function Ld(e) {
  if (typeof e == "function") return Lo(e) ? 1 : 0;
  if (e != null) {
    if (e = e.$$typeof, e === Xu) return 11;
    if (e === Gu) return 14;
  }
  return 2;
}
function at(e, t) {
  var n = e.alternate;
  return n === null ? (n = ke(e.tag, t, e.key, e.mode), n.elementType = e.elementType, n.type = e.type, n.stateNode = e.stateNode, n.alternate = e, e.alternate = n) : (n.pendingProps = t, n.type = e.type, n.flags = 0, n.subtreeFlags = 0, n.deletions = null), n.flags = e.flags & 14680064, n.childLanes = e.childLanes, n.lanes = e.lanes, n.child = e.child, n.memoizedProps = e.memoizedProps, n.memoizedState = e.memoizedState, n.updateQueue = e.updateQueue, t = e.dependencies, n.dependencies = t === null ? null : { lanes: t.lanes, firstContext: t.firstContext }, n.sibling = e.sibling, n.index = e.index, n.ref = e.ref, n;
}
function Rr(e, t, n, r, l, u) {
  var o = 2;
  if (r = e, typeof e == "function") Lo(e) && (o = 1);
  else if (typeof e == "string") o = 5;
  else e: switch (e) {
    case Ft:
      return _t(n.children, l, u, t);
    case Yu:
      o = 8, l |= 8;
      break;
    case Xl:
      return e = ke(12, n, t, l | 2), e.elementType = Xl, e.lanes = u, e;
    case Gl:
      return e = ke(13, n, t, l), e.elementType = Gl, e.lanes = u, e;
    case Zl:
      return e = ke(19, n, t, l), e.elementType = Zl, e.lanes = u, e;
    case as:
      return pl(n, l, u, t);
    default:
      if (typeof e == "object" && e !== null) switch (e.$$typeof) {
        case is:
          o = 10;
          break e;
        case ss:
          o = 9;
          break e;
        case Xu:
          o = 11;
          break e;
        case Gu:
          o = 14;
          break e;
        case Ze:
          o = 16, r = null;
          break e;
      }
      throw Error(g(130, e == null ? e : typeof e, ""));
  }
  return t = ke(o, n, t, l), t.elementType = e, t.type = r, t.lanes = u, t;
}
function _t(e, t, n, r) {
  return e = ke(7, e, r, t), e.lanes = n, e;
}
function pl(e, t, n, r) {
  return e = ke(22, e, r, t), e.elementType = as, e.lanes = n, e.stateNode = { isHidden: !1 }, e;
}
function Ql(e, t, n) {
  return e = ke(6, e, null, t), e.lanes = n, e;
}
function Kl(e, t, n) {
  return t = ke(4, e.children !== null ? e.children : [], e.key, t), t.lanes = n, t.stateNode = { containerInfo: e.containerInfo, pendingChildren: null, implementation: e.implementation }, t;
}
function Rd(e, t, n, r, l) {
  this.tag = t, this.containerInfo = e, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = Pl(0), this.expirationTimes = Pl(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Pl(0), this.identifierPrefix = r, this.onRecoverableError = l, this.mutableSourceEagerHydrationData = null;
}
function Ro(e, t, n, r, l, u, o, i, s) {
  return e = new Rd(e, t, n, i, s), t === 1 ? (t = 1, u === !0 && (t |= 8)) : t = 0, u = ke(3, null, null, t), e.current = u, u.stateNode = e, u.memoizedState = { element: r, isDehydrated: n, cache: null, transitions: null, pendingSuspenseBoundaries: null }, mo(u), e;
}
function Md(e, t, n) {
  var r = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
  return { $$typeof: Dt, key: r == null ? null : "" + r, children: e, containerInfo: t, implementation: n };
}
function ec(e) {
  if (!e) return ft;
  e = e._reactInternals;
  e: {
    if (Mt(e) !== e || e.tag !== 1) throw Error(g(170));
    var t = e;
    do {
      switch (t.tag) {
        case 3:
          t = t.stateNode.context;
          break e;
        case 1:
          if (fe(t.type)) {
            t = t.stateNode.__reactInternalMemoizedMergedChildContext;
            break e;
          }
      }
      t = t.return;
    } while (t !== null);
    throw Error(g(171));
  }
  if (e.tag === 1) {
    var n = e.type;
    if (fe(n)) return ea(e, n, t);
  }
  return t;
}
function tc(e, t, n, r, l, u, o, i, s) {
  return e = Ro(n, r, !0, e, l, u, o, i, s), e.context = ec(null), n = e.current, r = ue(), l = st(n), u = Be(r, l), u.callback = t ?? null, ot(n, u, l), e.current.lanes = l, Jn(e, l, r), de(e, r), e;
}
function ml(e, t, n, r) {
  var l = t.current, u = ue(), o = st(l);
  return n = ec(n), t.context === null ? t.context = n : t.pendingContext = n, t = Be(u, o), t.payload = { element: e }, r = r === void 0 ? null : r, r !== null && (t.callback = r), e = ot(l, t, o), e !== null && (Me(e, l, o, u), xr(e, l, o)), o;
}
function tl(e) {
  if (e = e.current, !e.child) return null;
  switch (e.child.tag) {
    case 5:
      return e.child.stateNode;
    default:
      return e.child.stateNode;
  }
}
function Hi(e, t) {
  if (e = e.memoizedState, e !== null && e.dehydrated !== null) {
    var n = e.retryLane;
    e.retryLane = n !== 0 && n < t ? n : t;
  }
}
function Mo(e, t) {
  Hi(e, t), (e = e.alternate) && Hi(e, t);
}
function Id() {
  return null;
}
var nc = typeof reportError == "function" ? reportError : function(e) {
  console.error(e);
};
function Io(e) {
  this._internalRoot = e;
}
hl.prototype.render = Io.prototype.render = function(e) {
  var t = this._internalRoot;
  if (t === null) throw Error(g(409));
  ml(e, t, null, null);
};
hl.prototype.unmount = Io.prototype.unmount = function() {
  var e = this._internalRoot;
  if (e !== null) {
    this._internalRoot = null;
    var t = e.containerInfo;
    Lt(function() {
      ml(null, e, null, null);
    }), t[Qe] = null;
  }
};
function hl(e) {
  this._internalRoot = e;
}
hl.prototype.unstable_scheduleHydration = function(e) {
  if (e) {
    var t = Is();
    e = { blockedOn: null, target: e, priority: t };
    for (var n = 0; n < qe.length && t !== 0 && t < qe[n].priority; n++) ;
    qe.splice(n, 0, e), n === 0 && Ds(e);
  }
};
function Oo(e) {
  return !(!e || e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11);
}
function vl(e) {
  return !(!e || e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11 && (e.nodeType !== 8 || e.nodeValue !== " react-mount-point-unstable "));
}
function Bi() {
}
function Od(e, t, n, r, l) {
  if (l) {
    if (typeof r == "function") {
      var u = r;
      r = function() {
        var c = tl(o);
        u.call(c);
      };
    }
    var o = tc(t, r, e, 0, null, !1, !1, "", Bi);
    return e._reactRootContainer = o, e[Qe] = o.current, Vn(e.nodeType === 8 ? e.parentNode : e), Lt(), o;
  }
  for (; l = e.lastChild; ) e.removeChild(l);
  if (typeof r == "function") {
    var i = r;
    r = function() {
      var c = tl(s);
      i.call(c);
    };
  }
  var s = Ro(e, 0, !1, null, null, !1, !1, "", Bi);
  return e._reactRootContainer = s, e[Qe] = s.current, Vn(e.nodeType === 8 ? e.parentNode : e), Lt(function() {
    ml(t, s, n, r);
  }), s;
}
function yl(e, t, n, r, l) {
  var u = n._reactRootContainer;
  if (u) {
    var o = u;
    if (typeof l == "function") {
      var i = l;
      l = function() {
        var s = tl(o);
        i.call(s);
      };
    }
    ml(t, o, e, l);
  } else o = Od(n, t, e, l, r);
  return tl(o);
}
Rs = function(e) {
  switch (e.tag) {
    case 3:
      var t = e.stateNode;
      if (t.current.memoizedState.isDehydrated) {
        var n = En(t.pendingLanes);
        n !== 0 && (qu(t, n | 1), de(t, W()), !(M & 6) && (un = W() + 500, mt()));
      }
      break;
    case 13:
      Lt(function() {
        var r = Ke(e, 1);
        if (r !== null) {
          var l = ue();
          Me(r, e, 1, l);
        }
      }), Mo(e, 1);
  }
};
bu = function(e) {
  if (e.tag === 13) {
    var t = Ke(e, 134217728);
    if (t !== null) {
      var n = ue();
      Me(t, e, 134217728, n);
    }
    Mo(e, 134217728);
  }
};
Ms = function(e) {
  if (e.tag === 13) {
    var t = st(e), n = Ke(e, t);
    if (n !== null) {
      var r = ue();
      Me(n, e, t, r);
    }
    Mo(e, t);
  }
};
Is = function() {
  return I;
};
Os = function(e, t) {
  var n = I;
  try {
    return I = e, t();
  } finally {
    I = n;
  }
};
ou = function(e, t, n) {
  switch (t) {
    case "input":
      if (bl(e, n), t = n.name, n.type === "radio" && t != null) {
        for (n = e; n.parentNode; ) n = n.parentNode;
        for (n = n.querySelectorAll("input[name=" + JSON.stringify("" + t) + '][type="radio"]'), t = 0; t < n.length; t++) {
          var r = n[t];
          if (r !== e && r.form === e.form) {
            var l = il(r);
            if (!l) throw Error(g(90));
            fs(r), bl(r, l);
          }
        }
      }
      break;
    case "textarea":
      ps(e, n);
      break;
    case "select":
      t = n.value, t != null && Yt(e, !!n.multiple, t, !1);
  }
};
Ss = No;
ks = Lt;
var Dd = { usingClientEntryPoint: !1, Events: [bn, $t, il, gs, ws, No] }, wn = { findFiberByHostInstance: St, bundleType: 0, version: "18.3.1", rendererPackageName: "react-dom" }, Fd = { bundleType: wn.bundleType, version: wn.version, rendererPackageName: wn.rendererPackageName, rendererConfig: wn.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: Xe.ReactCurrentDispatcher, findHostInstanceByFiber: function(e) {
  return e = _s(e), e === null ? null : e.stateNode;
}, findFiberByHostInstance: wn.findFiberByHostInstance || Id, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.3.1-next-f1338f8080-20240426" };
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
  var wr = __REACT_DEVTOOLS_GLOBAL_HOOK__;
  if (!wr.isDisabled && wr.supportsFiber) try {
    rl = wr.inject(Fd), je = wr;
  } catch {
  }
}
ye.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Dd;
ye.createPortal = function(e, t) {
  var n = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
  if (!Oo(t)) throw Error(g(200));
  return Md(e, t, null, n);
};
ye.createRoot = function(e, t) {
  if (!Oo(e)) throw Error(g(299));
  var n = !1, r = "", l = nc;
  return t != null && (t.unstable_strictMode === !0 && (n = !0), t.identifierPrefix !== void 0 && (r = t.identifierPrefix), t.onRecoverableError !== void 0 && (l = t.onRecoverableError)), t = Ro(e, 1, !1, null, null, n, !1, r, l), e[Qe] = t.current, Vn(e.nodeType === 8 ? e.parentNode : e), new Io(t);
};
ye.findDOMNode = function(e) {
  if (e == null) return null;
  if (e.nodeType === 1) return e;
  var t = e._reactInternals;
  if (t === void 0)
    throw typeof e.render == "function" ? Error(g(188)) : (e = Object.keys(e).join(","), Error(g(268, e)));
  return e = _s(t), e = e === null ? null : e.stateNode, e;
};
ye.flushSync = function(e) {
  return Lt(e);
};
ye.hydrate = function(e, t, n) {
  if (!vl(t)) throw Error(g(200));
  return yl(null, e, t, !0, n);
};
ye.hydrateRoot = function(e, t, n) {
  if (!Oo(e)) throw Error(g(405));
  var r = n != null && n.hydratedSources || null, l = !1, u = "", o = nc;
  if (n != null && (n.unstable_strictMode === !0 && (l = !0), n.identifierPrefix !== void 0 && (u = n.identifierPrefix), n.onRecoverableError !== void 0 && (o = n.onRecoverableError)), t = tc(t, null, e, 1, n ?? null, l, !1, u, o), e[Qe] = t.current, Vn(e), r) for (e = 0; e < r.length; e++) n = r[e], l = n._getVersion, l = l(n._source), t.mutableSourceEagerHydrationData == null ? t.mutableSourceEagerHydrationData = [n, l] : t.mutableSourceEagerHydrationData.push(
    n,
    l
  );
  return new hl(t);
};
ye.render = function(e, t, n) {
  if (!vl(t)) throw Error(g(200));
  return yl(null, e, t, !1, n);
};
ye.unmountComponentAtNode = function(e) {
  if (!vl(e)) throw Error(g(40));
  return e._reactRootContainer ? (Lt(function() {
    yl(null, null, e, !1, function() {
      e._reactRootContainer = null, e[Qe] = null;
    });
  }), !0) : !1;
};
ye.unstable_batchedUpdates = No;
ye.unstable_renderSubtreeIntoContainer = function(e, t, n, r) {
  if (!vl(n)) throw Error(g(200));
  if (e == null || e._reactInternals === void 0) throw Error(g(38));
  return yl(e, t, n, !1, r);
};
ye.version = "18.3.1-next-f1338f8080-20240426";
function rc() {
  if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"))
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(rc);
    } catch (e) {
      console.error(e);
    }
}
rc(), rs.exports = ye;
var jd = rs.exports, lc, Wi = jd;
lc = Wi.createRoot, Wi.hydrateRoot;
class Ud {
  constructor(t) {
    yt(this, "plugin");
    yt(this, "api", null);
    this.plugin = t;
  }
  /**
   * Set the plugin API (called by PluginManager when registering)
   */
  setAPI(t) {
    this.api = t;
  }
  /**
   * Subscribe to state changes for a scope
   */
  onStateChange(t, n) {
    if (!this.api) {
      console.warn(
        \`[GeoWebPluginInstance] Cannot subscribe to \${t}: API not set\`
      );
      return;
    }
    this.api.onStateChange(t, n);
  }
  /**
   * Send an event for a scope
   */
  sendEvent(t, n) {
    if (!this.api) {
      console.warn(
        \`[GeoWebPluginInstance] Cannot send event to \${t}: API not set\`
      );
      return;
    }
    this.api.sendEvent(t, n);
  }
}
const Ad = /^(\\d{4})-(\\d{2})-(\\d{2})T(\\d{2}):(\\d{2}):(\\d{2})Z$/;
function uc(e) {
  const t = Ad.exec(e);
  if (!t) return !1;
  const [, n, r, l, u, o, i] = t, s = Number(r), c = Number(l), h = Number(u), m = Number(o), p = Number(i);
  return !(s < 1 || s > 12 || c < 1 || c > 31 || h > 23 || m > 59 || p > 59);
}
function $d(e) {
  const t = e.toISOString().replace(/\\.\\d{3}Z$/, "Z");
  if (!uc(t))
    throw new Error(
      \`Could not convert Date to Iso8601Utc: \${e.toISOString()}\`
    );
  return t;
}
function Vd(e, t) {
  const n = t;
  if (!uc(n)) {
    const r = /\\.\\d{3}Z$/.test(n) ? " Timestamp contains milliseconds; use toIso8601Utc()- function to convert into correct time format ." : "";
    throw new Error(
      \`Invalid ISO 8601 UTC timestamp (expected YYYY-MM-DDTHH:MM:SSZ): "\${n}".\${r}\`
    );
  }
  e.sendEvent("time", { type: "setTime", time: n });
}
const Hd = (e) => {
  const t = new Date(e), n = t.getUTCHours(), r = t.getUTCMinutes();
  return n * 60 + r;
}, Bd = (e, t) => {
  const n = Math.floor(e / 60), r = e % 60, l = /* @__PURE__ */ new Date();
  return l.setUTCHours(n, r, 0, 0), $d(l);
}, xt = 60, oc = 24, Wd = oc * xt, Qi = [
  { label: "12:00 AM", minutes: 0 },
  { label: "8:00 AM", minutes: 8 * xt },
  { label: "4:00 PM", minutes: 16 * xt },
  { label: "12:00 AM", minutes: 24 * xt }
], Qd = ({
  value: e,
  onChange: t,
  min: n = 0,
  max: r = Wd
}) => {
  const l = Ot.useRef(null), [u, o] = Ot.useState(!1), i = (v) => v < n ? n : v > r ? r : v, s = (e - n) / (r - n) * 100, c = Ot.useCallback(
    (v) => {
      const w = l.current;
      if (!w) return;
      const { left: L, width: f } = w.getBoundingClientRect(), d = (v - L) / f, y = n + d * (r - n), k = i(y);
      t(k);
    },
    [n, r, t]
  );
  Ot.useEffect(() => {
    if (!u) return;
    const v = (L) => {
      "touches" in L ? L.touches.length > 0 && c(L.touches[0].clientX) : c(L.clientX);
    }, w = () => o(!1);
    return window.addEventListener("mousemove", v), window.addEventListener("touchmove", v, { passive: !1 }), window.addEventListener("mouseup", w), window.addEventListener("touchend", w), () => {
      window.removeEventListener("mousemove", v), window.removeEventListener("touchmove", v), window.removeEventListener("mouseup", w), window.removeEventListener("touchend", w);
    };
  }, [u, c]);
  const h = (v) => {
    v.preventDefault(), o(!0), "touches" in v ? c(v.touches[0].clientX) : c(v.clientX);
  }, m = (v) => {
    c(v.clientX);
  }, p = (v) => {
    const w = Math.round(v), L = Math.floor(w / xt) % oc, f = w % xt, a = L >= 12 ? "PM" : "AM", d = (L + 11) % 12 + 1, y = f.toString().padStart(2, "0");
    return \`\${d}:\${y} \${a}\`;
  }, S = (v, w, L) => (v - w) / (L - w) * 100;
  return /* @__PURE__ */ Ne.jsxs("div", { className: "time-slider-card", children: [
    /* @__PURE__ */ Ne.jsx("div", { className: "time-slider-title", children: "TIME SLIDER v1.1" }),
    /* @__PURE__ */ Ne.jsx("div", { className: "time-slider-track-wrapper", children: /* @__PURE__ */ Ne.jsxs(
      "div",
      {
        ref: l,
        className: "time-slider-track",
        onMouseDown: m,
        children: [
          Qi.map((v) => {
            const w = S(v.minutes, n, r);
            return /* @__PURE__ */ Ne.jsx(
              "div",
              {
                className: "time-slider-marker",
                style: { left: \`\${w}%\` }
              },
              \`\${v.label}-\${v.minutes}\`
            );
          }),
          /* @__PURE__ */ Ne.jsx(
            "div",
            {
              className: \`time-slider-thumb \${u ? "dragging" : ""}\`,
              style: { left: \`\${s}%\` },
              onMouseDown: h,
              onTouchStart: h
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ Ne.jsx("div", { className: "time-slider-labels", children: Qi.map((v) => /* @__PURE__ */ Ne.jsx("span", { children: v.label }, v.label + v.minutes)) }),
    /* @__PURE__ */ Ne.jsx("div", { className: "time-slider-value", children: p(e) })
  ] });
}, Kd = ({ instance: e }) => {
  const n = 8 * xt, [r, l] = Ot.useState(n);
  Ot.useEffect(() => {
    if (!e) {
      window.console.log(
        "timeslider-lite-plugin: plugin instance not available"
      );
      return;
    }
    window.console.log(
      "timeslider-lite-plugin: [React Component] Setting up counter state subscription"
    ), e.onStateChange("time", (o) => {
      window.console.log(
        "timeslider-lite-plugin: [React Component] Received counter state:",
        o
      );
      const i = Hd(o.time);
      console.log("time in minutes:", i), l(i);
    });
  }, [e]);
  const u = (o) => {
    if (!e) return;
    const i = Bd(o);
    console.log("will send time to geoweb in format:", i), Vd(e, i);
  };
  return /* @__PURE__ */ Ne.jsx(
    Qd,
    {
      value: r,
      onChange: u,
      instance: e
    }
  );
}, Yd = (e, t) => {
  const n = lc(e);
  return n.render(/* @__PURE__ */ Ne.jsx(Kd, { instance: t })), n;
};
let Xd = 0;
class Gd extends Ud {
  constructor(n, r) {
    super(r);
    yt(this, "id", 0);
    yt(this, "target");
    yt(this, "disposed", !1);
    yt(this, "root");
    this.id = Xd++, console.log(
      "timeslider-lite-plugin: creating plugin instance " + this.id + " in target",
      n
    ), console.log("timeslider-lite-plugin: plugin reference:", r), console.log(
      "timeslider-lite-plugin: this.plugin after super:",
      this.plugin
    ), this.target = n, this.root = Yd(n, this);
  }
  dispose() {
    if (!this.disposed) {
      this.disposed = !0, console.log("plugin-1: disposing instance " + this.id);
      try {
        this.root.unmount();
      } catch (n) {
        if (n instanceof DOMException && n.name === "NotFoundError") {
          console.warn(
            "plugin-1: unmount skipped because host already detached DOM for instance " + this.id
          );
          return;
        }
        throw n;
      }
    }
  }
}
const Zd = () => {
  const e = {
    name: "MagnificentTimeSlider",
    version: "1.0.0",
    scopes: ["time"],
    type: "overlay",
    createInstance(t) {
      return new Gd(t, e);
    }
  };
  return e;
}, Jd = Zd(), bd = { plugin: Jd };
window.pluginModule = bd;`;
export default demoPluginBundle;
